/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Avallon API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const ListVoiceAgentsQueryParams = zod.object({
  "agent_name": zod.string().optional().describe('Filter by exact agent name')
})

export const listVoiceAgentsResponseDataAgentsItemInactivityTimeoutSecondsOneMin = -9007199254740991;
export const listVoiceAgentsResponseDataAgentsItemInactivityTimeoutSecondsOneMax = 9007199254740991;

export const listVoiceAgentsResponseDataTotalMin = -9007199254740991;
export const listVoiceAgentsResponseDataTotalMax = 9007199254740991;



export const ListVoiceAgentsResponse = zod.object({
  "data": zod.object({
  "agents": zod.array(zod.object({
  "id": zod.string(),
  "tenant_id": zod.string(),
  "agent_name": zod.string(),
  "direction": zod.enum(['INBOUND', 'OUTBOUND']),
  "phone_number": zod.union([zod.string(),zod.null()]),
  "created_at": zod.string().datetime({"offset":true}),
  "updated_at": zod.string().datetime({"offset":true}),
  "llm_model": zod.enum(['GPT4.1', 'AZURE-GPT4o', 'AZURE-GPT4.1', 'GPT-5', 'GPT-5-low', 'GPT-5-high', 'GPT-5.1-chat-latest', 'GPT-5.1-no-reasoning', 'GEMINI-1.5-flash', 'GEMINI-2.5-flash', 'GEMINI-2.5-flash-lite', 'GEMINI-3-flash', 'CLAUDE-sonnet-4.6', 'CLAUDE-haiku-4.5', 'GPT-5.4-mini']),
  "tts_provider": zod.enum(['elevenlabs', 'cartesia', 'google', 'aws-polly']),
  "tts_model": zod.enum(['eleven_flash_v2_5', 'eleven_turbo_v2_5', 'sonic-3', 'sonic-3.5', 'sonic-3.6', 'chirp_3', 'polly-neural']),
  "language": zod.enum(['en-US', 'de-DE']),
  "tts_voice_id": zod.string().describe('Voice ID from the TTS provider'),
  "stt_model": zod.enum(['DEEPGRAM-NOVA-2-GENERAL', 'DEEPGRAM-NOVA-3-GENERAL', 'AWS-TRANSCRIBE', 'ELEVENLABS-SCRIBE-V2-REALTIME', 'CARTESIA-INK-2']),
  "background_sounds": zod.enum(['enabled', 'disabled']),
  "noise_cancellation": zod.enum(['NONE', 'NC', 'BVC', 'BVC_TELEPHONY']),
  "voice_mail_detection": zod.boolean(),
  "dial_pad": zod.boolean(),
  "end_call": zod.boolean(),
  "transfer_phone_number": zod.union([zod.string(),zod.null()]),
  "call_processor_id": zod.union([zod.string(),zod.null()]),
  "call_processor_type": zod.union([zod.enum(['extractor', 'worker']),zod.null()]),
  "evaluator_slug": zod.union([zod.string(),zod.null()]),
  "lk_cloud_routing_pct": zod.number(),
  "fallback_llm_model": zod.union([zod.enum(['GPT4.1', 'AZURE-GPT4o', 'AZURE-GPT4.1', 'GPT-5', 'GPT-5-low', 'GPT-5-high', 'GPT-5.1-chat-latest', 'GPT-5.1-no-reasoning', 'GEMINI-1.5-flash', 'GEMINI-2.5-flash', 'GEMINI-2.5-flash-lite', 'GEMINI-3-flash', 'CLAUDE-sonnet-4.6', 'CLAUDE-haiku-4.5', 'GPT-5.4-mini']),zod.null()]),
  "fallback_tts_provider": zod.union([zod.enum(['elevenlabs', 'cartesia', 'google', 'aws-polly']),zod.null()]),
  "fallback_tts_model": zod.union([zod.enum(['eleven_flash_v2_5', 'eleven_turbo_v2_5', 'sonic-3', 'sonic-3.5', 'sonic-3.6', 'chirp_3', 'polly-neural']),zod.null()]),
  "fallback_tts_voice_id": zod.union([zod.string(),zod.null()]),
  "fallback_stt_model": zod.union([zod.enum(['DEEPGRAM-NOVA-2-GENERAL', 'DEEPGRAM-NOVA-3-GENERAL', 'AWS-TRANSCRIBE', 'ELEVENLABS-SCRIBE-V2-REALTIME', 'CARTESIA-INK-2']),zod.null()]),
  "greeting": zod.union([zod.string(),zod.null()]),
  "inactivity_timeout_seconds": zod.union([zod.number().int().min(listVoiceAgentsResponseDataAgentsItemInactivityTimeoutSecondsOneMin).max(listVoiceAgentsResponseDataAgentsItemInactivityTimeoutSecondsOneMax),zod.null()]).describe('Inactivity timeout in seconds. null disables the feature.'),
  "tool_ids": zod.array(zod.string()).describe('Tools the agent can call. Part of the versioned config: each version captures its own set, and a rollback restores it.')
})),
  "total": zod.number().int().min(listVoiceAgentsResponseDataTotalMin).max(listVoiceAgentsResponseDataTotalMax).describe('Total number of agents')
}),
  "message": zod.string()
})



export const createVoiceAgentBodyInactivityTimeoutSecondsOneMin = 5;
export const createVoiceAgentBodyInactivityTimeoutSecondsOneMax = 9007199254740991;



export const CreateVoiceAgentBody = zod.object({
  "agent_name": zod.string().min(1).describe('Name for the agent'),
  "direction": zod.enum(['OUTBOUND', 'INBOUND']).describe('Call direction the agent handles'),
  "llm_model": zod.enum(['GPT4.1', 'AZURE-GPT4o', 'AZURE-GPT4.1', 'GPT-5', 'GPT-5-low', 'GPT-5-high', 'GPT-5.1-chat-latest', 'GPT-5.1-no-reasoning', 'GEMINI-1.5-flash', 'GEMINI-2.5-flash', 'GEMINI-2.5-flash-lite', 'GEMINI-3-flash', 'CLAUDE-sonnet-4.6', 'CLAUDE-haiku-4.5', 'GPT-5.4-mini']).describe('LLM model for conversation'),
  "tts_provider": zod.enum(['elevenlabs', 'cartesia', 'google', 'aws-polly']).describe('Text-to-speech provider'),
  "tts_model": zod.enum(['eleven_flash_v2_5', 'eleven_turbo_v2_5', 'sonic-3', 'sonic-3.5', 'sonic-3.6', 'chirp_3', 'polly-neural']).describe('Text-to-speech model'),
  "tts_voice_id": zod.union([zod.union([zod.union([zod.enum(['Achernar', 'Achird']),zod.enum(['v3V1d2rk6528UrLKRuy8', 'cauGUrZQIRUvQs3glrUi', 'OYTbf65OHHFELVut7v2H'])]),zod.enum(['5c42302c-194b-4d0c-ba1a-8cb485c84ab9', 'e8e5fffb-252c-436d-b842-8879b84445b6', 'f786b574-daa5-4673-aa0c-cbe3e8534c02', 'db6b0ed5-d5d3-463d-ae85-518a07d3c2b4', 'a5136bf9-224c-4d76-b823-52bd5efcffcc', '62ae83ad-4f6a-430b-af41-a9bede9286ca', 'ef191366-f52f-447a-a398-ed8c0f2943a1', '8d8ce8c9-44a4-46c4-b10f-9a927b99a853', '5ee9feff-1265-424a-9d7f-8e4d431a12c7', 'b9de4a89-2257-424b-94c2-db18ba68c81a', 'b0a1cdc7-e0d3-4d48-900d-7a936762c77b'])]),zod.enum(['Joanna', 'Kendra', 'Salli', 'Joey', 'Vicki', 'Daniel'])]).describe('Voice ID from the TTS provider'),
  "stt_model": zod.enum(['DEEPGRAM-NOVA-2-GENERAL', 'DEEPGRAM-NOVA-3-GENERAL', 'AWS-TRANSCRIBE', 'ELEVENLABS-SCRIBE-V2-REALTIME', 'CARTESIA-INK-2']).describe('Speech-to-text model'),
  "transfer_phone_number": zod.union([zod.string(),zod.null()]).describe('Phone number to transfer calls to'),
  "phone_number_id": zod.string().optional().describe('ID of phone number to assign to agent'),
  "language": zod.enum(['en-US', 'de-DE']).describe('Language for the agent'),
  "dial_pad": zod.boolean().optional().describe('Whether the agent supports DTMF dial pad input'),
  "end_call": zod.boolean().optional().describe('Whether the agent can end the call'),
  "call_processor_id": zod.union([zod.string(),zod.null()]).optional().describe('ID of extractor or worker to run after call'),
  "call_processor_type": zod.enum(['extractor', 'worker']).optional().describe('Type of processor: extractor or worker'),
  "inactivity_timeout_seconds": zod.union([zod.number().int().min(createVoiceAgentBodyInactivityTimeoutSecondsOneMin).max(createVoiceAgentBodyInactivityTimeoutSecondsOneMax),zod.null()]).optional().describe('Inactivity timeout in seconds. null disables the feature. Minimum 5. Defaults to 7 if omitted.')
})

export const createVoiceAgentResponseDataAgentInactivityTimeoutSecondsOneMin = -9007199254740991;
export const createVoiceAgentResponseDataAgentInactivityTimeoutSecondsOneMax = 9007199254740991;



export const CreateVoiceAgentResponse = zod.object({
  "data": zod.object({
  "agent": zod.object({
  "id": zod.string(),
  "tenant_id": zod.string(),
  "agent_name": zod.string(),
  "direction": zod.enum(['INBOUND', 'OUTBOUND']),
  "phone_number": zod.union([zod.string(),zod.null()]),
  "created_at": zod.string().datetime({"offset":true}),
  "updated_at": zod.string().datetime({"offset":true}),
  "llm_model": zod.enum(['GPT4.1', 'AZURE-GPT4o', 'AZURE-GPT4.1', 'GPT-5', 'GPT-5-low', 'GPT-5-high', 'GPT-5.1-chat-latest', 'GPT-5.1-no-reasoning', 'GEMINI-1.5-flash', 'GEMINI-2.5-flash', 'GEMINI-2.5-flash-lite', 'GEMINI-3-flash', 'CLAUDE-sonnet-4.6', 'CLAUDE-haiku-4.5', 'GPT-5.4-mini']),
  "tts_provider": zod.enum(['elevenlabs', 'cartesia', 'google', 'aws-polly']),
  "tts_model": zod.enum(['eleven_flash_v2_5', 'eleven_turbo_v2_5', 'sonic-3', 'sonic-3.5', 'sonic-3.6', 'chirp_3', 'polly-neural']),
  "language": zod.enum(['en-US', 'de-DE']),
  "tts_voice_id": zod.string().describe('Voice ID from the TTS provider'),
  "stt_model": zod.enum(['DEEPGRAM-NOVA-2-GENERAL', 'DEEPGRAM-NOVA-3-GENERAL', 'AWS-TRANSCRIBE', 'ELEVENLABS-SCRIBE-V2-REALTIME', 'CARTESIA-INK-2']),
  "background_sounds": zod.enum(['enabled', 'disabled']),
  "noise_cancellation": zod.enum(['NONE', 'NC', 'BVC', 'BVC_TELEPHONY']),
  "voice_mail_detection": zod.boolean(),
  "dial_pad": zod.boolean(),
  "end_call": zod.boolean(),
  "transfer_phone_number": zod.union([zod.string(),zod.null()]),
  "call_processor_id": zod.union([zod.string(),zod.null()]),
  "call_processor_type": zod.union([zod.enum(['extractor', 'worker']),zod.null()]),
  "evaluator_slug": zod.union([zod.string(),zod.null()]),
  "lk_cloud_routing_pct": zod.number(),
  "fallback_llm_model": zod.union([zod.enum(['GPT4.1', 'AZURE-GPT4o', 'AZURE-GPT4.1', 'GPT-5', 'GPT-5-low', 'GPT-5-high', 'GPT-5.1-chat-latest', 'GPT-5.1-no-reasoning', 'GEMINI-1.5-flash', 'GEMINI-2.5-flash', 'GEMINI-2.5-flash-lite', 'GEMINI-3-flash', 'CLAUDE-sonnet-4.6', 'CLAUDE-haiku-4.5', 'GPT-5.4-mini']),zod.null()]),
  "fallback_tts_provider": zod.union([zod.enum(['elevenlabs', 'cartesia', 'google', 'aws-polly']),zod.null()]),
  "fallback_tts_model": zod.union([zod.enum(['eleven_flash_v2_5', 'eleven_turbo_v2_5', 'sonic-3', 'sonic-3.5', 'sonic-3.6', 'chirp_3', 'polly-neural']),zod.null()]),
  "fallback_tts_voice_id": zod.union([zod.string(),zod.null()]),
  "fallback_stt_model": zod.union([zod.enum(['DEEPGRAM-NOVA-2-GENERAL', 'DEEPGRAM-NOVA-3-GENERAL', 'AWS-TRANSCRIBE', 'ELEVENLABS-SCRIBE-V2-REALTIME', 'CARTESIA-INK-2']),zod.null()]),
  "greeting": zod.union([zod.string(),zod.null()]),
  "inactivity_timeout_seconds": zod.union([zod.number().int().min(createVoiceAgentResponseDataAgentInactivityTimeoutSecondsOneMin).max(createVoiceAgentResponseDataAgentInactivityTimeoutSecondsOneMax),zod.null()]).describe('Inactivity timeout in seconds. null disables the feature.'),
  "tool_ids": zod.array(zod.string()).describe('Tools the agent can call. Part of the versioned config: each version captures its own set, and a rollback restores it.')
})
}),
  "message": zod.string()
})


export const GetVoiceAgentParams = zod.object({
  "voiceAgentId": zod.string().uuid().describe('Voice Agent ID')
})

export const getVoiceAgentResponseDataAgentInactivityTimeoutSecondsOneMin = -9007199254740991;
export const getVoiceAgentResponseDataAgentInactivityTimeoutSecondsOneMax = 9007199254740991;



export const GetVoiceAgentResponse = zod.object({
  "data": zod.object({
  "agent": zod.object({
  "id": zod.string(),
  "tenant_id": zod.string(),
  "agent_name": zod.string(),
  "direction": zod.enum(['INBOUND', 'OUTBOUND']),
  "phone_number": zod.union([zod.string(),zod.null()]),
  "created_at": zod.string().datetime({"offset":true}),
  "updated_at": zod.string().datetime({"offset":true}),
  "llm_model": zod.enum(['GPT4.1', 'AZURE-GPT4o', 'AZURE-GPT4.1', 'GPT-5', 'GPT-5-low', 'GPT-5-high', 'GPT-5.1-chat-latest', 'GPT-5.1-no-reasoning', 'GEMINI-1.5-flash', 'GEMINI-2.5-flash', 'GEMINI-2.5-flash-lite', 'GEMINI-3-flash', 'CLAUDE-sonnet-4.6', 'CLAUDE-haiku-4.5', 'GPT-5.4-mini']),
  "tts_provider": zod.enum(['elevenlabs', 'cartesia', 'google', 'aws-polly']),
  "tts_model": zod.enum(['eleven_flash_v2_5', 'eleven_turbo_v2_5', 'sonic-3', 'sonic-3.5', 'sonic-3.6', 'chirp_3', 'polly-neural']),
  "language": zod.enum(['en-US', 'de-DE']),
  "tts_voice_id": zod.string().describe('Voice ID from the TTS provider'),
  "stt_model": zod.enum(['DEEPGRAM-NOVA-2-GENERAL', 'DEEPGRAM-NOVA-3-GENERAL', 'AWS-TRANSCRIBE', 'ELEVENLABS-SCRIBE-V2-REALTIME', 'CARTESIA-INK-2']),
  "background_sounds": zod.enum(['enabled', 'disabled']),
  "noise_cancellation": zod.enum(['NONE', 'NC', 'BVC', 'BVC_TELEPHONY']),
  "voice_mail_detection": zod.boolean(),
  "dial_pad": zod.boolean(),
  "end_call": zod.boolean(),
  "transfer_phone_number": zod.union([zod.string(),zod.null()]),
  "call_processor_id": zod.union([zod.string(),zod.null()]),
  "call_processor_type": zod.union([zod.enum(['extractor', 'worker']),zod.null()]),
  "evaluator_slug": zod.union([zod.string(),zod.null()]),
  "lk_cloud_routing_pct": zod.number(),
  "fallback_llm_model": zod.union([zod.enum(['GPT4.1', 'AZURE-GPT4o', 'AZURE-GPT4.1', 'GPT-5', 'GPT-5-low', 'GPT-5-high', 'GPT-5.1-chat-latest', 'GPT-5.1-no-reasoning', 'GEMINI-1.5-flash', 'GEMINI-2.5-flash', 'GEMINI-2.5-flash-lite', 'GEMINI-3-flash', 'CLAUDE-sonnet-4.6', 'CLAUDE-haiku-4.5', 'GPT-5.4-mini']),zod.null()]),
  "fallback_tts_provider": zod.union([zod.enum(['elevenlabs', 'cartesia', 'google', 'aws-polly']),zod.null()]),
  "fallback_tts_model": zod.union([zod.enum(['eleven_flash_v2_5', 'eleven_turbo_v2_5', 'sonic-3', 'sonic-3.5', 'sonic-3.6', 'chirp_3', 'polly-neural']),zod.null()]),
  "fallback_tts_voice_id": zod.union([zod.string(),zod.null()]),
  "fallback_stt_model": zod.union([zod.enum(['DEEPGRAM-NOVA-2-GENERAL', 'DEEPGRAM-NOVA-3-GENERAL', 'AWS-TRANSCRIBE', 'ELEVENLABS-SCRIBE-V2-REALTIME', 'CARTESIA-INK-2']),zod.null()]),
  "greeting": zod.union([zod.string(),zod.null()]),
  "inactivity_timeout_seconds": zod.union([zod.number().int().min(getVoiceAgentResponseDataAgentInactivityTimeoutSecondsOneMin).max(getVoiceAgentResponseDataAgentInactivityTimeoutSecondsOneMax),zod.null()]).describe('Inactivity timeout in seconds. null disables the feature.'),
  "tool_ids": zod.array(zod.string()).describe('Tools the agent can call. Part of the versioned config: each version captures its own set, and a rollback restores it.'),
  "test_phone_number": zod.union([zod.string(),zod.null()])
})
}),
  "message": zod.string()
})


export const UpdateVoiceAgentParams = zod.object({
  "voiceAgentId": zod.string().uuid()
})


export const updateVoiceAgentBodyInactivityTimeoutSecondsOneMin = 5;
export const updateVoiceAgentBodyInactivityTimeoutSecondsOneMax = 9007199254740991;



export const UpdateVoiceAgentBody = zod.object({
  "name": zod.string().min(1).optional(),
  "call_processor_id": zod.union([zod.string().uuid(),zod.null()]).optional(),
  "call_processor_type": zod.enum(['extractor', 'worker']).optional(),
  "inactivity_timeout_seconds": zod.union([zod.number().int().min(updateVoiceAgentBodyInactivityTimeoutSecondsOneMin).max(updateVoiceAgentBodyInactivityTimeoutSecondsOneMax),zod.null()]).optional().describe('Inactivity timeout in seconds. null disables the feature. Minimum 5. Omit to leave unchanged.'),
  "voice_mail_detection": zod.boolean().optional().describe('Enable voicemail beep detection on outbound calls. Omit to leave unchanged.'),
  "noise_cancellation": zod.enum(['NONE', 'NC', 'BVC', 'BVC_TELEPHONY']).optional().describe('Noise cancellation mode applied to the caller audio. Omit to leave unchanged.'),
  "tool_ids": zod.array(zod.string().uuid()).optional().describe('Replace the agent\'s attached tool set. Omit to leave unchanged; pass [] to detach all.')
})

export const updateVoiceAgentResponseDataAgentInactivityTimeoutSecondsOneMin = -9007199254740991;
export const updateVoiceAgentResponseDataAgentInactivityTimeoutSecondsOneMax = 9007199254740991;



export const UpdateVoiceAgentResponse = zod.object({
  "data": zod.object({
  "agent": zod.object({
  "id": zod.string(),
  "tenant_id": zod.string(),
  "agent_name": zod.string(),
  "direction": zod.enum(['INBOUND', 'OUTBOUND']),
  "phone_number": zod.union([zod.string(),zod.null()]),
  "created_at": zod.string().datetime({"offset":true}),
  "updated_at": zod.string().datetime({"offset":true}),
  "llm_model": zod.enum(['GPT4.1', 'AZURE-GPT4o', 'AZURE-GPT4.1', 'GPT-5', 'GPT-5-low', 'GPT-5-high', 'GPT-5.1-chat-latest', 'GPT-5.1-no-reasoning', 'GEMINI-1.5-flash', 'GEMINI-2.5-flash', 'GEMINI-2.5-flash-lite', 'GEMINI-3-flash', 'CLAUDE-sonnet-4.6', 'CLAUDE-haiku-4.5', 'GPT-5.4-mini']),
  "tts_provider": zod.enum(['elevenlabs', 'cartesia', 'google', 'aws-polly']),
  "tts_model": zod.enum(['eleven_flash_v2_5', 'eleven_turbo_v2_5', 'sonic-3', 'sonic-3.5', 'sonic-3.6', 'chirp_3', 'polly-neural']),
  "language": zod.enum(['en-US', 'de-DE']),
  "tts_voice_id": zod.string().describe('Voice ID from the TTS provider'),
  "stt_model": zod.enum(['DEEPGRAM-NOVA-2-GENERAL', 'DEEPGRAM-NOVA-3-GENERAL', 'AWS-TRANSCRIBE', 'ELEVENLABS-SCRIBE-V2-REALTIME', 'CARTESIA-INK-2']),
  "background_sounds": zod.enum(['enabled', 'disabled']),
  "noise_cancellation": zod.enum(['NONE', 'NC', 'BVC', 'BVC_TELEPHONY']),
  "voice_mail_detection": zod.boolean(),
  "dial_pad": zod.boolean(),
  "end_call": zod.boolean(),
  "transfer_phone_number": zod.union([zod.string(),zod.null()]),
  "call_processor_id": zod.union([zod.string(),zod.null()]),
  "call_processor_type": zod.union([zod.enum(['extractor', 'worker']),zod.null()]),
  "evaluator_slug": zod.union([zod.string(),zod.null()]),
  "lk_cloud_routing_pct": zod.number(),
  "fallback_llm_model": zod.union([zod.enum(['GPT4.1', 'AZURE-GPT4o', 'AZURE-GPT4.1', 'GPT-5', 'GPT-5-low', 'GPT-5-high', 'GPT-5.1-chat-latest', 'GPT-5.1-no-reasoning', 'GEMINI-1.5-flash', 'GEMINI-2.5-flash', 'GEMINI-2.5-flash-lite', 'GEMINI-3-flash', 'CLAUDE-sonnet-4.6', 'CLAUDE-haiku-4.5', 'GPT-5.4-mini']),zod.null()]),
  "fallback_tts_provider": zod.union([zod.enum(['elevenlabs', 'cartesia', 'google', 'aws-polly']),zod.null()]),
  "fallback_tts_model": zod.union([zod.enum(['eleven_flash_v2_5', 'eleven_turbo_v2_5', 'sonic-3', 'sonic-3.5', 'sonic-3.6', 'chirp_3', 'polly-neural']),zod.null()]),
  "fallback_tts_voice_id": zod.union([zod.string(),zod.null()]),
  "fallback_stt_model": zod.union([zod.enum(['DEEPGRAM-NOVA-2-GENERAL', 'DEEPGRAM-NOVA-3-GENERAL', 'AWS-TRANSCRIBE', 'ELEVENLABS-SCRIBE-V2-REALTIME', 'CARTESIA-INK-2']),zod.null()]),
  "greeting": zod.union([zod.string(),zod.null()]),
  "inactivity_timeout_seconds": zod.union([zod.number().int().min(updateVoiceAgentResponseDataAgentInactivityTimeoutSecondsOneMin).max(updateVoiceAgentResponseDataAgentInactivityTimeoutSecondsOneMax),zod.null()]).describe('Inactivity timeout in seconds. null disables the feature.'),
  "tool_ids": zod.array(zod.string()).describe('Tools the agent can call. Part of the versioned config: each version captures its own set, and a rollback restores it.')
})
}),
  "message": zod.string()
})


export const DeleteVoiceAgentParams = zod.object({
  "voiceAgentId": zod.string().uuid().describe('Voice Agent ID')
})

export const DeleteVoiceAgentResponse = zod.object({
  "data": zod.object({

}),
  "message": zod.string()
})


export const ListVoiceAgentVersionsParams = zod.object({
  "voiceAgentId": zod.string().uuid()
})

export const listVoiceAgentVersionsQueryCountDefault = 50;
export const listVoiceAgentVersionsQueryCountMax = 100;

export const listVoiceAgentVersionsQueryOffsetDefault = 0;
export const listVoiceAgentVersionsQueryOffsetMin = 0;

export const listVoiceAgentVersionsQuerySortByDefault = `version`;
export const listVoiceAgentVersionsQuerySortOrderDefault = `desc`;

export const ListVoiceAgentVersionsQueryParams = zod.object({
  "count": zod.number().min(1).max(listVoiceAgentVersionsQueryCountMax).default(listVoiceAgentVersionsQueryCountDefault),
  "offset": zod.number().min(listVoiceAgentVersionsQueryOffsetMin).default(listVoiceAgentVersionsQueryOffsetDefault),
  "sort_by": zod.enum(['version', 'created_at']).default(listVoiceAgentVersionsQuerySortByDefault),
  "sort_order": zod.enum(['asc', 'desc']).default(listVoiceAgentVersionsQuerySortOrderDefault)
})

export const listVoiceAgentVersionsResponseDataItemVersionMin = -9007199254740991;
export const listVoiceAgentVersionsResponseDataItemVersionMax = 9007199254740991;

export const listVoiceAgentVersionsResponseMetaTotalMin = -9007199254740991;
export const listVoiceAgentVersionsResponseMetaTotalMax = 9007199254740991;



export const ListVoiceAgentVersionsResponse = zod.object({
  "data": zod.array(zod.object({
  "voice_agent_id": zod.string(),
  "version": zod.number().int().min(listVoiceAgentVersionsResponseDataItemVersionMin).max(listVoiceAgentVersionsResponseDataItemVersionMax),
  "active_environments": zod.array(zod.enum(['live', 'test'])).describe('Release channels whose parent-agent pointers currently select this version. A version may be both `live` and `test`.'),
  "actor": zod.string(),
  "created_at": zod.string().datetime({"offset":true}),
  "changed_fields": zod.array(zod.string()).describe('Voice agent config field names (matching the keys on the voice agent response) whose values differ from the previous version. Empty for version 1.')
})),
  "message": zod.string(),
  "meta": zod.object({
  "total": zod.number().int().min(listVoiceAgentVersionsResponseMetaTotalMin).max(listVoiceAgentVersionsResponseMetaTotalMax).describe('Total number of versions')
})
})


export const GetVoiceAgentVersionParams = zod.object({
  "voiceAgentId": zod.string().uuid(),
  "version": zod.number()
})

export const getVoiceAgentVersionResponseDataInactivityTimeoutSecondsOneMin = -9007199254740991;
export const getVoiceAgentVersionResponseDataInactivityTimeoutSecondsOneMax = 9007199254740991;

export const getVoiceAgentVersionResponseDataVersionMin = -9007199254740991;
export const getVoiceAgentVersionResponseDataVersionMax = 9007199254740991;



export const GetVoiceAgentVersionResponse = zod.object({
  "data": zod.object({
  "id": zod.string(),
  "tenant_id": zod.string(),
  "agent_name": zod.string(),
  "direction": zod.enum(['INBOUND', 'OUTBOUND']),
  "phone_number": zod.union([zod.string(),zod.null()]),
  "created_at": zod.string().datetime({"offset":true}),
  "updated_at": zod.string().datetime({"offset":true}),
  "llm_model": zod.enum(['GPT4.1', 'AZURE-GPT4o', 'AZURE-GPT4.1', 'GPT-5', 'GPT-5-low', 'GPT-5-high', 'GPT-5.1-chat-latest', 'GPT-5.1-no-reasoning', 'GEMINI-1.5-flash', 'GEMINI-2.5-flash', 'GEMINI-2.5-flash-lite', 'GEMINI-3-flash', 'CLAUDE-sonnet-4.6', 'CLAUDE-haiku-4.5', 'GPT-5.4-mini']),
  "tts_provider": zod.enum(['elevenlabs', 'cartesia', 'google', 'aws-polly']),
  "tts_model": zod.enum(['eleven_flash_v2_5', 'eleven_turbo_v2_5', 'sonic-3', 'sonic-3.5', 'sonic-3.6', 'chirp_3', 'polly-neural']),
  "language": zod.enum(['en-US', 'de-DE']),
  "tts_voice_id": zod.string().describe('Voice ID from the TTS provider'),
  "stt_model": zod.enum(['DEEPGRAM-NOVA-2-GENERAL', 'DEEPGRAM-NOVA-3-GENERAL', 'AWS-TRANSCRIBE', 'ELEVENLABS-SCRIBE-V2-REALTIME', 'CARTESIA-INK-2']),
  "background_sounds": zod.enum(['enabled', 'disabled']),
  "noise_cancellation": zod.enum(['NONE', 'NC', 'BVC', 'BVC_TELEPHONY']),
  "voice_mail_detection": zod.boolean(),
  "dial_pad": zod.boolean(),
  "end_call": zod.boolean(),
  "transfer_phone_number": zod.union([zod.string(),zod.null()]),
  "call_processor_id": zod.union([zod.string(),zod.null()]),
  "call_processor_type": zod.union([zod.enum(['extractor', 'worker']),zod.null()]),
  "evaluator_slug": zod.union([zod.string(),zod.null()]),
  "lk_cloud_routing_pct": zod.number(),
  "fallback_llm_model": zod.union([zod.enum(['GPT4.1', 'AZURE-GPT4o', 'AZURE-GPT4.1', 'GPT-5', 'GPT-5-low', 'GPT-5-high', 'GPT-5.1-chat-latest', 'GPT-5.1-no-reasoning', 'GEMINI-1.5-flash', 'GEMINI-2.5-flash', 'GEMINI-2.5-flash-lite', 'GEMINI-3-flash', 'CLAUDE-sonnet-4.6', 'CLAUDE-haiku-4.5', 'GPT-5.4-mini']),zod.null()]),
  "fallback_tts_provider": zod.union([zod.enum(['elevenlabs', 'cartesia', 'google', 'aws-polly']),zod.null()]),
  "fallback_tts_model": zod.union([zod.enum(['eleven_flash_v2_5', 'eleven_turbo_v2_5', 'sonic-3', 'sonic-3.5', 'sonic-3.6', 'chirp_3', 'polly-neural']),zod.null()]),
  "fallback_tts_voice_id": zod.union([zod.string(),zod.null()]),
  "fallback_stt_model": zod.union([zod.enum(['DEEPGRAM-NOVA-2-GENERAL', 'DEEPGRAM-NOVA-3-GENERAL', 'AWS-TRANSCRIBE', 'ELEVENLABS-SCRIBE-V2-REALTIME', 'CARTESIA-INK-2']),zod.null()]),
  "greeting": zod.union([zod.string(),zod.null()]),
  "inactivity_timeout_seconds": zod.union([zod.number().int().min(getVoiceAgentVersionResponseDataInactivityTimeoutSecondsOneMin).max(getVoiceAgentVersionResponseDataInactivityTimeoutSecondsOneMax),zod.null()]).describe('Inactivity timeout in seconds. null disables the feature.'),
  "tool_ids": zod.array(zod.string()).describe('Tools the agent can call. Part of the versioned config: each version captures its own set, and a rollback restores it.'),
  "version": zod.number().int().min(getVoiceAgentVersionResponseDataVersionMin).max(getVoiceAgentVersionResponseDataVersionMax),
  "active_environments": zod.array(zod.enum(['live', 'test'])).describe('Release channels whose parent-agent pointers currently select this version. A version may be both `live` and `test`.'),
  "version_created_at": zod.string().datetime({"offset":true}),
  "actor": zod.string(),
  "changed_fields": zod.array(zod.string()).describe('Voice agent config field names (matching the keys on the voice agent response) whose values differ from the previous version. Empty for version 1.')
}),
  "message": zod.string()
})


export const PromoteVoiceAgentVersionParams = zod.object({
  "voiceAgentId": zod.string().uuid(),
  "version": zod.number()
})

export const PromoteVoiceAgentVersionBody = zod.object({
  "environment": zod.enum(['live', 'test'])
})

export const PromoteVoiceAgentVersionResponse = zod.object({
  "data": zod.object({
  "version": zod.number(),
  "environment": zod.enum(['live', 'test'])
}),
  "message": zod.string()
})


export const GetVoiceAgentVersionChangeSummaryParams = zod.object({
  "voiceAgentId": zod.string().uuid(),
  "version": zod.number()
})

export const GetVoiceAgentVersionChangeSummaryResponse = zod.object({
  "data": zod.object({
  "summary": zod.string().describe('AI-generated summary of what changed between this version and the previous one. Empty string when there is no previous version (version 1).')
}),
  "message": zod.string()
})


export const GetVoiceAgentPlaceholdersParams = zod.object({
  "voiceAgentId": zod.string().uuid()
})

export const GetVoiceAgentPlaceholdersResponse = zod.object({
  "data": zod.object({
  "placeholders": zod.array(zod.string()).describe('Available placeholder variables')
}),
  "message": zod.string()
})


export const GetVoiceAgentPromptParams = zod.object({
  "voiceAgentId": zod.string().uuid()
})

export const GetVoiceAgentPromptQueryParams = zod.object({
  "version": zod.number().optional()
})

export const GetVoiceAgentPromptResponse = zod.object({
  "data": zod.object({
  "prompt": zod.string().optional(),
  "greeting": zod.union([zod.string(),zod.null()]).optional()
}),
  "message": zod.string()
})


export const UpdateVoiceAgentPromptParams = zod.object({
  "voiceAgentId": zod.string().uuid()
})





export const UpdateVoiceAgentPromptBody = zod.object({
  "prompt": zod.string().min(1).optional(),
  "greeting": zod.union([zod.string().min(1),zod.null()]).optional()
})

export const UpdateVoiceAgentPromptResponse = zod.object({
  "data": zod.object({
  "id": zod.string(),
  "updated_at": zod.string().datetime({"offset":true})
}),
  "message": zod.string()
})


export const UpdateVoiceAgentModelsParams = zod.object({
  "voiceAgentId": zod.string().uuid()
})

export const UpdateVoiceAgentModelsBody = zod.object({
  "llm_model": zod.enum(['GPT4.1', 'AZURE-GPT4o', 'AZURE-GPT4.1', 'GPT-5', 'GPT-5-low', 'GPT-5-high', 'GPT-5.1-chat-latest', 'GPT-5.1-no-reasoning', 'GEMINI-1.5-flash', 'GEMINI-2.5-flash', 'GEMINI-2.5-flash-lite', 'GEMINI-3-flash', 'CLAUDE-sonnet-4.6', 'CLAUDE-haiku-4.5', 'GPT-5.4-mini']),
  "tts_provider": zod.enum(['elevenlabs', 'cartesia', 'google', 'aws-polly']),
  "tts_model": zod.enum(['eleven_flash_v2_5', 'eleven_turbo_v2_5', 'sonic-3', 'sonic-3.5', 'sonic-3.6', 'chirp_3', 'polly-neural']),
  "tts_voice_id": zod.union([zod.union([zod.union([zod.enum(['Achernar', 'Achird']),zod.enum(['v3V1d2rk6528UrLKRuy8', 'cauGUrZQIRUvQs3glrUi', 'OYTbf65OHHFELVut7v2H'])]),zod.enum(['5c42302c-194b-4d0c-ba1a-8cb485c84ab9', 'e8e5fffb-252c-436d-b842-8879b84445b6', 'f786b574-daa5-4673-aa0c-cbe3e8534c02', 'db6b0ed5-d5d3-463d-ae85-518a07d3c2b4', 'a5136bf9-224c-4d76-b823-52bd5efcffcc', '62ae83ad-4f6a-430b-af41-a9bede9286ca', 'ef191366-f52f-447a-a398-ed8c0f2943a1', '8d8ce8c9-44a4-46c4-b10f-9a927b99a853', '5ee9feff-1265-424a-9d7f-8e4d431a12c7', 'b9de4a89-2257-424b-94c2-db18ba68c81a', 'b0a1cdc7-e0d3-4d48-900d-7a936762c77b'])]),zod.enum(['Joanna', 'Kendra', 'Salli', 'Joey', 'Vicki', 'Daniel'])]),
  "stt_model": zod.enum(['DEEPGRAM-NOVA-2-GENERAL', 'DEEPGRAM-NOVA-3-GENERAL', 'AWS-TRANSCRIBE', 'ELEVENLABS-SCRIBE-V2-REALTIME', 'CARTESIA-INK-2']),
  "language": zod.enum(['en-US', 'de-DE']),
  "fallback_llm_model": zod.union([zod.enum(['GPT4.1', 'AZURE-GPT4o', 'AZURE-GPT4.1', 'GPT-5', 'GPT-5-low', 'GPT-5-high', 'GPT-5.1-chat-latest', 'GPT-5.1-no-reasoning', 'GEMINI-1.5-flash', 'GEMINI-2.5-flash', 'GEMINI-2.5-flash-lite', 'GEMINI-3-flash', 'CLAUDE-sonnet-4.6', 'CLAUDE-haiku-4.5', 'GPT-5.4-mini']),zod.null()]).optional(),
  "fallback_tts_provider": zod.union([zod.enum(['elevenlabs', 'cartesia', 'google', 'aws-polly']),zod.null()]).optional(),
  "fallback_tts_model": zod.union([zod.enum(['eleven_flash_v2_5', 'eleven_turbo_v2_5', 'sonic-3', 'sonic-3.5', 'sonic-3.6', 'chirp_3', 'polly-neural']),zod.null()]).optional(),
  "fallback_tts_voice_id": zod.union([zod.union([zod.union([zod.union([zod.enum(['Achernar', 'Achird']),zod.enum(['v3V1d2rk6528UrLKRuy8', 'cauGUrZQIRUvQs3glrUi', 'OYTbf65OHHFELVut7v2H'])]),zod.enum(['5c42302c-194b-4d0c-ba1a-8cb485c84ab9', 'e8e5fffb-252c-436d-b842-8879b84445b6', 'f786b574-daa5-4673-aa0c-cbe3e8534c02', 'db6b0ed5-d5d3-463d-ae85-518a07d3c2b4', 'a5136bf9-224c-4d76-b823-52bd5efcffcc', '62ae83ad-4f6a-430b-af41-a9bede9286ca', 'ef191366-f52f-447a-a398-ed8c0f2943a1', '8d8ce8c9-44a4-46c4-b10f-9a927b99a853', '5ee9feff-1265-424a-9d7f-8e4d431a12c7', 'b9de4a89-2257-424b-94c2-db18ba68c81a', 'b0a1cdc7-e0d3-4d48-900d-7a936762c77b'])]),zod.enum(['Joanna', 'Kendra', 'Salli', 'Joey', 'Vicki', 'Daniel'])]),zod.null()]).optional(),
  "fallback_stt_model": zod.union([zod.enum(['DEEPGRAM-NOVA-2-GENERAL', 'DEEPGRAM-NOVA-3-GENERAL', 'AWS-TRANSCRIBE', 'ELEVENLABS-SCRIBE-V2-REALTIME', 'CARTESIA-INK-2']),zod.null()]).optional()
})

export const updateVoiceAgentModelsResponseDataAgentInactivityTimeoutSecondsOneMin = -9007199254740991;
export const updateVoiceAgentModelsResponseDataAgentInactivityTimeoutSecondsOneMax = 9007199254740991;



export const UpdateVoiceAgentModelsResponse = zod.object({
  "data": zod.object({
  "agent": zod.object({
  "id": zod.string(),
  "tenant_id": zod.string(),
  "agent_name": zod.string(),
  "direction": zod.enum(['INBOUND', 'OUTBOUND']),
  "phone_number": zod.union([zod.string(),zod.null()]),
  "created_at": zod.string().datetime({"offset":true}),
  "updated_at": zod.string().datetime({"offset":true}),
  "llm_model": zod.enum(['GPT4.1', 'AZURE-GPT4o', 'AZURE-GPT4.1', 'GPT-5', 'GPT-5-low', 'GPT-5-high', 'GPT-5.1-chat-latest', 'GPT-5.1-no-reasoning', 'GEMINI-1.5-flash', 'GEMINI-2.5-flash', 'GEMINI-2.5-flash-lite', 'GEMINI-3-flash', 'CLAUDE-sonnet-4.6', 'CLAUDE-haiku-4.5', 'GPT-5.4-mini']),
  "tts_provider": zod.enum(['elevenlabs', 'cartesia', 'google', 'aws-polly']),
  "tts_model": zod.enum(['eleven_flash_v2_5', 'eleven_turbo_v2_5', 'sonic-3', 'sonic-3.5', 'sonic-3.6', 'chirp_3', 'polly-neural']),
  "language": zod.enum(['en-US', 'de-DE']),
  "tts_voice_id": zod.string().describe('Voice ID from the TTS provider'),
  "stt_model": zod.enum(['DEEPGRAM-NOVA-2-GENERAL', 'DEEPGRAM-NOVA-3-GENERAL', 'AWS-TRANSCRIBE', 'ELEVENLABS-SCRIBE-V2-REALTIME', 'CARTESIA-INK-2']),
  "background_sounds": zod.enum(['enabled', 'disabled']),
  "noise_cancellation": zod.enum(['NONE', 'NC', 'BVC', 'BVC_TELEPHONY']),
  "voice_mail_detection": zod.boolean(),
  "dial_pad": zod.boolean(),
  "end_call": zod.boolean(),
  "transfer_phone_number": zod.union([zod.string(),zod.null()]),
  "call_processor_id": zod.union([zod.string(),zod.null()]),
  "call_processor_type": zod.union([zod.enum(['extractor', 'worker']),zod.null()]),
  "evaluator_slug": zod.union([zod.string(),zod.null()]),
  "lk_cloud_routing_pct": zod.number(),
  "fallback_llm_model": zod.union([zod.enum(['GPT4.1', 'AZURE-GPT4o', 'AZURE-GPT4.1', 'GPT-5', 'GPT-5-low', 'GPT-5-high', 'GPT-5.1-chat-latest', 'GPT-5.1-no-reasoning', 'GEMINI-1.5-flash', 'GEMINI-2.5-flash', 'GEMINI-2.5-flash-lite', 'GEMINI-3-flash', 'CLAUDE-sonnet-4.6', 'CLAUDE-haiku-4.5', 'GPT-5.4-mini']),zod.null()]),
  "fallback_tts_provider": zod.union([zod.enum(['elevenlabs', 'cartesia', 'google', 'aws-polly']),zod.null()]),
  "fallback_tts_model": zod.union([zod.enum(['eleven_flash_v2_5', 'eleven_turbo_v2_5', 'sonic-3', 'sonic-3.5', 'sonic-3.6', 'chirp_3', 'polly-neural']),zod.null()]),
  "fallback_tts_voice_id": zod.union([zod.string(),zod.null()]),
  "fallback_stt_model": zod.union([zod.enum(['DEEPGRAM-NOVA-2-GENERAL', 'DEEPGRAM-NOVA-3-GENERAL', 'AWS-TRANSCRIBE', 'ELEVENLABS-SCRIBE-V2-REALTIME', 'CARTESIA-INK-2']),zod.null()]),
  "greeting": zod.union([zod.string(),zod.null()]),
  "inactivity_timeout_seconds": zod.union([zod.number().int().min(updateVoiceAgentModelsResponseDataAgentInactivityTimeoutSecondsOneMin).max(updateVoiceAgentModelsResponseDataAgentInactivityTimeoutSecondsOneMax),zod.null()]).describe('Inactivity timeout in seconds. null disables the feature.'),
  "tool_ids": zod.array(zod.string()).describe('Tools the agent can call. Part of the versioned config: each version captures its own set, and a rollback restores it.')
})
}),
  "message": zod.string()
})


export const UpdateCallControlsParams = zod.object({
  "voiceAgentId": zod.string().uuid()
})

export const UpdateCallControlsBody = zod.object({
  "dial_pad": zod.boolean().optional(),
  "end_call": zod.boolean().optional(),
  "transfer_phone_number": zod.union([zod.string(),zod.null()]).optional()
})

export const updateCallControlsResponseDataAgentInactivityTimeoutSecondsOneMin = -9007199254740991;
export const updateCallControlsResponseDataAgentInactivityTimeoutSecondsOneMax = 9007199254740991;



export const UpdateCallControlsResponse = zod.object({
  "data": zod.object({
  "agent": zod.object({
  "id": zod.string(),
  "tenant_id": zod.string(),
  "agent_name": zod.string(),
  "direction": zod.enum(['INBOUND', 'OUTBOUND']),
  "phone_number": zod.union([zod.string(),zod.null()]),
  "created_at": zod.string().datetime({"offset":true}),
  "updated_at": zod.string().datetime({"offset":true}),
  "llm_model": zod.enum(['GPT4.1', 'AZURE-GPT4o', 'AZURE-GPT4.1', 'GPT-5', 'GPT-5-low', 'GPT-5-high', 'GPT-5.1-chat-latest', 'GPT-5.1-no-reasoning', 'GEMINI-1.5-flash', 'GEMINI-2.5-flash', 'GEMINI-2.5-flash-lite', 'GEMINI-3-flash', 'CLAUDE-sonnet-4.6', 'CLAUDE-haiku-4.5', 'GPT-5.4-mini']),
  "tts_provider": zod.enum(['elevenlabs', 'cartesia', 'google', 'aws-polly']),
  "tts_model": zod.enum(['eleven_flash_v2_5', 'eleven_turbo_v2_5', 'sonic-3', 'sonic-3.5', 'sonic-3.6', 'chirp_3', 'polly-neural']),
  "language": zod.enum(['en-US', 'de-DE']),
  "tts_voice_id": zod.string().describe('Voice ID from the TTS provider'),
  "stt_model": zod.enum(['DEEPGRAM-NOVA-2-GENERAL', 'DEEPGRAM-NOVA-3-GENERAL', 'AWS-TRANSCRIBE', 'ELEVENLABS-SCRIBE-V2-REALTIME', 'CARTESIA-INK-2']),
  "background_sounds": zod.enum(['enabled', 'disabled']),
  "noise_cancellation": zod.enum(['NONE', 'NC', 'BVC', 'BVC_TELEPHONY']),
  "voice_mail_detection": zod.boolean(),
  "dial_pad": zod.boolean(),
  "end_call": zod.boolean(),
  "transfer_phone_number": zod.union([zod.string(),zod.null()]),
  "call_processor_id": zod.union([zod.string(),zod.null()]),
  "call_processor_type": zod.union([zod.enum(['extractor', 'worker']),zod.null()]),
  "evaluator_slug": zod.union([zod.string(),zod.null()]),
  "lk_cloud_routing_pct": zod.number(),
  "fallback_llm_model": zod.union([zod.enum(['GPT4.1', 'AZURE-GPT4o', 'AZURE-GPT4.1', 'GPT-5', 'GPT-5-low', 'GPT-5-high', 'GPT-5.1-chat-latest', 'GPT-5.1-no-reasoning', 'GEMINI-1.5-flash', 'GEMINI-2.5-flash', 'GEMINI-2.5-flash-lite', 'GEMINI-3-flash', 'CLAUDE-sonnet-4.6', 'CLAUDE-haiku-4.5', 'GPT-5.4-mini']),zod.null()]),
  "fallback_tts_provider": zod.union([zod.enum(['elevenlabs', 'cartesia', 'google', 'aws-polly']),zod.null()]),
  "fallback_tts_model": zod.union([zod.enum(['eleven_flash_v2_5', 'eleven_turbo_v2_5', 'sonic-3', 'sonic-3.5', 'sonic-3.6', 'chirp_3', 'polly-neural']),zod.null()]),
  "fallback_tts_voice_id": zod.union([zod.string(),zod.null()]),
  "fallback_stt_model": zod.union([zod.enum(['DEEPGRAM-NOVA-2-GENERAL', 'DEEPGRAM-NOVA-3-GENERAL', 'AWS-TRANSCRIBE', 'ELEVENLABS-SCRIBE-V2-REALTIME', 'CARTESIA-INK-2']),zod.null()]),
  "greeting": zod.union([zod.string(),zod.null()]),
  "inactivity_timeout_seconds": zod.union([zod.number().int().min(updateCallControlsResponseDataAgentInactivityTimeoutSecondsOneMin).max(updateCallControlsResponseDataAgentInactivityTimeoutSecondsOneMax),zod.null()]).describe('Inactivity timeout in seconds. null disables the feature.'),
  "tool_ids": zod.array(zod.string()).describe('Tools the agent can call. Part of the versioned config: each version captures its own set, and a rollback restores it.')
})
}),
  "message": zod.string()
})


export const ScheduleJobParams = zod.object({
  "voiceAgentId": zod.string().uuid()
})

export const scheduleJobBodyScheduleWindowMinutesDefault = 60;
export const scheduleJobBodyScheduleWindowMinutesMin = 10;
export const scheduleJobBodyScheduleWindowMinutesMax = 9007199254740991;

export const scheduleJobBodyPayloadDefault = {};
export const scheduleJobBodyTriggerImmediatelyDefault = false;

export const ScheduleJobBody = zod.object({
  "scheduled_at": zod.string(),
  "schedule_window_minutes": zod.number().int().min(scheduleJobBodyScheduleWindowMinutesMin).max(scheduleJobBodyScheduleWindowMinutesMax).default(scheduleJobBodyScheduleWindowMinutesDefault),
  "destination_phone_number": zod.string(),
  "payload": zod.record(zod.string(), zod.unknown()).default(scheduleJobBodyPayloadDefault),
  "metadata": zod.record(zod.string(), zod.unknown()).optional(),
  "environment": zod.enum(['live', 'test']).optional().describe('Promoted environment the job dispatches against (agent configuration and phone binding). Defaults to `live`. TEST requires an active TEST promotion.'),
  "trigger_immediately": zod.boolean().default(scheduleJobBodyTriggerImmediatelyDefault)
})

export const ScheduleJobResponse = zod.object({
  "data": zod.object({
  "id": zod.string(),
  "agent_id": zod.string(),
  "tenant_id": zod.string(),
  "scheduled_at": zod.string().datetime({"offset":true}),
  "schedule_window_minutes": zod.number(),
  "destination_phone_number": zod.string(),
  "payload": zod.record(zod.string(), zod.unknown()),
  "metadata": zod.union([zod.record(zod.string(), zod.unknown()),zod.null()]),
  "environment": zod.enum(['live', 'test']).describe('Promoted environment the job dispatches against (agent configuration and phone binding). TEST requires an active TEST promotion.'),
  "status": zod.enum(['pending', 'queued', 'in_progress', 'completed', 'canceled']),
  "created_at": zod.string().datetime({"offset":true})
}),
  "message": zod.string()
})


export const listJobsQueryCountDefault = 50;
export const listJobsQueryCountMax = 100;

export const listJobsQueryOffsetDefault = 0;
export const listJobsQueryOffsetMin = 0;
export const listJobsQueryOffsetMax = 9007199254740991;



export const ListJobsQueryParams = zod.object({
  "agent": zod.string().uuid().optional(),
  "count": zod.number().int().min(1).max(listJobsQueryCountMax).default(listJobsQueryCountDefault),
  "offset": zod.number().int().min(listJobsQueryOffsetMin).max(listJobsQueryOffsetMax).default(listJobsQueryOffsetDefault),
  "status": zod.array(zod.enum(['pending', 'queued', 'in_progress', 'completed', 'canceled'])),
  "scheduled_after": zod.string().datetime({"offset":true}).optional(),
  "scheduled_before": zod.string().datetime({"offset":true}).optional()
})

export const ListJobsResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.string(),
  "agent_id": zod.string(),
  "tenant_id": zod.string(),
  "scheduled_at": zod.string().datetime({"offset":true}),
  "schedule_window_minutes": zod.number(),
  "destination_phone_number": zod.string(),
  "payload": zod.record(zod.string(), zod.unknown()),
  "metadata": zod.union([zod.record(zod.string(), zod.unknown()),zod.null()]),
  "environment": zod.enum(['live', 'test']).describe('Promoted environment the job dispatches against (agent configuration and phone binding). TEST requires an active TEST promotion.'),
  "status": zod.enum(['pending', 'queued', 'in_progress', 'completed', 'canceled']),
  "created_at": zod.string().datetime({"offset":true})
})),
  "message": zod.string(),
  "meta": zod.object({
  "total": zod.number()
})
})


export const CancelJobParams = zod.object({
  "jobId": zod.string().uuid()
})

export const CancelJobResponse = zod.object({
  "data": zod.object({
  "id": zod.string(),
  "agent_id": zod.string(),
  "tenant_id": zod.string(),
  "scheduled_at": zod.string().datetime({"offset":true}),
  "schedule_window_minutes": zod.number(),
  "destination_phone_number": zod.string(),
  "payload": zod.record(zod.string(), zod.unknown()),
  "metadata": zod.union([zod.record(zod.string(), zod.unknown()),zod.null()]),
  "environment": zod.enum(['live', 'test']).describe('Promoted environment the job dispatches against (agent configuration and phone binding). TEST requires an active TEST promotion.'),
  "status": zod.enum(['pending', 'queued', 'in_progress', 'completed', 'canceled']),
  "created_at": zod.string().datetime({"offset":true})
}),
  "message": zod.string()
})


export const ListApiKeysQueryParams = zod.object({
  "include_revoked": zod.enum(['true', 'false']).optional().describe('Include revoked keys in the response'),
  "owner_profile_id": zod.string().uuid().optional().describe('Only return keys owned by this team member. Ids come from the team endpoint.')
})

export const ListApiKeysResponse = zod.object({
  "data": zod.object({
  "data": zod.array(zod.object({
  "id": zod.string().describe('Unique identifier for the API key'),
  "name": zod.string().describe('Human-readable name for the API key'),
  "owner_profile_id": zod.string().describe('Id of the team member the key acts as, as returned by the team endpoint. The owner\'s role caps the key\'s effective role, and the key stops working once the owner is removed from the tenant.'),
  "key_prefix": zod.string().describe('First 12 characters of the key (e.g. ak_live_abc1)'),
  "role": zod.enum(['admin', 'avallon_admin', 'member']).describe('Role granted to this API key'),
  "last_used_at": zod.string().datetime({"offset":true}).optional().describe('Last usage timestamp, if ever used'),
  "expires_at": zod.string().datetime({"offset":true}).optional().describe('Expiration date, if set'),
  "revoked_at": zod.string().datetime({"offset":true}).optional().describe('Revocation timestamp, if revoked'),
  "created_at": zod.string().datetime({"offset":true}).describe('Creation timestamp'),
  "updated_at": zod.string().datetime({"offset":true}).describe('Last update timestamp')
})),
  "count": zod.number().describe('Total number of keys returned')
}),
  "message": zod.string()
})


export const createApiKeyBodyNameMax = 100;

export const createApiKeyBodyEnvironmentDefault = `live`;

export const CreateApiKeyBody = zod.object({
  "name": zod.string().min(1).max(createApiKeyBodyNameMax).describe('Human-readable name for the API key'),
  "expires_at": zod.string().datetime({"offset":true}).optional().describe('Optional expiration date (ISO 8601)'),
  "environment": zod.enum(['test', 'live']).default(createApiKeyBodyEnvironmentDefault).describe('Target environment for the key'),
  "role": zod.enum(['admin', 'avallon_admin', 'member']).optional().describe('Role granted to this API key (defaults to admin). Caller\'s role caps the maximum grantable role.')
})

export const CreateApiKeyResponse = zod.object({
  "data": zod.object({
  "id": zod.string().describe('Unique identifier for the API key'),
  "name": zod.string().describe('Human-readable name for the API key'),
  "owner_profile_id": zod.string().describe('Id of the team member the key acts as, as returned by the team endpoint. The owner\'s role caps the key\'s effective role, and the key stops working once the owner is removed from the tenant.'),
  "key_prefix": zod.string().describe('First 12 characters of the key (e.g. ak_live_abc1)'),
  "role": zod.enum(['admin', 'avallon_admin', 'member']).describe('Role granted to this API key'),
  "last_used_at": zod.string().datetime({"offset":true}).optional().describe('Last usage timestamp, if ever used'),
  "expires_at": zod.string().datetime({"offset":true}).optional().describe('Expiration date, if set'),
  "revoked_at": zod.string().datetime({"offset":true}).optional().describe('Revocation timestamp, if revoked'),
  "created_at": zod.string().datetime({"offset":true}).describe('Creation timestamp'),
  "updated_at": zod.string().datetime({"offset":true}).describe('Last update timestamp'),
  "api_key": zod.string().describe('The full API key — only returned once at creation')
}),
  "message": zod.string()
})


export const RevokeApiKeyParams = zod.object({
  "id": zod.string().uuid().describe('The API key ID to revoke')
})

export const RevokeApiKeyResponse = zod.object({
  "data": zod.object({
  "message": zod.string().describe('Confirmation message')
}),
  "message": zod.string()
})


export const UpdateApiKeyParams = zod.object({
  "id": zod.string().uuid().describe('The API key ID to update')
})

export const UpdateApiKeyBody = zod.object({
  "role": zod.enum(['admin', 'avallon_admin', 'member']).describe('New role to grant this API key. Caller\'s role caps the maximum grantable role.')
})

export const UpdateApiKeyResponse = zod.object({
  "data": zod.object({
  "id": zod.string().describe('Unique identifier for the API key'),
  "name": zod.string().describe('Human-readable name for the API key'),
  "owner_profile_id": zod.string().describe('Id of the team member the key acts as, as returned by the team endpoint. The owner\'s role caps the key\'s effective role, and the key stops working once the owner is removed from the tenant.'),
  "key_prefix": zod.string().describe('First 12 characters of the key (e.g. ak_live_abc1)'),
  "role": zod.enum(['admin', 'avallon_admin', 'member']).describe('Role granted to this API key'),
  "last_used_at": zod.string().datetime({"offset":true}).optional().describe('Last usage timestamp, if ever used'),
  "expires_at": zod.string().datetime({"offset":true}).optional().describe('Expiration date, if set'),
  "revoked_at": zod.string().datetime({"offset":true}).optional().describe('Revocation timestamp, if revoked'),
  "created_at": zod.string().datetime({"offset":true}).describe('Creation timestamp'),
  "updated_at": zod.string().datetime({"offset":true}).describe('Last update timestamp')
}),
  "message": zod.string()
})



export const createArtifactBodyFileBase64Max = 9000000;



export const CreateArtifactBody = zod.object({
  "document_name": zod.string().min(1),
  "file_base64": zod.string().min(1).max(createArtifactBodyFileBase64Max),
  "processing_options": zod.object({
  "file_password": zod.string().optional(),
  "file_splitting_enabled": zod.boolean().optional()
}).optional(),
  "created_at_document": zod.string().datetime({"offset":true}).optional(),
  "metadata": zod.record(zod.string(), zod.unknown()).optional()
})

export const CreateArtifactResponse = zod.object({
  "data": zod.array(zod.object({
  "artifact_id": zod.string(),
  "message_id": zod.string(),
  "status": zod.string()
})),
  "message": zod.string()
})


export const listArtifactsQueryCountDefault = 50;
export const listArtifactsQueryCountMax = 100;

export const listArtifactsQueryOffsetDefault = 0;
export const listArtifactsQueryOffsetMin = 0;
export const listArtifactsQueryOffsetMax = 100000;

export const listArtifactsQuerySortByDefault = `created_at`;
export const listArtifactsQuerySortOrderDefault = `desc`;


export const ListArtifactsQueryParams = zod.object({
  "count": zod.number().min(1).max(listArtifactsQueryCountMax).default(listArtifactsQueryCountDefault),
  "offset": zod.number().min(listArtifactsQueryOffsetMin).max(listArtifactsQueryOffsetMax).default(listArtifactsQueryOffsetDefault),
  "sort_by": zod.enum(['created_at', 'updated_at', 'document_name']).default(listArtifactsQuerySortByDefault),
  "sort_order": zod.enum(['asc', 'desc']).default(listArtifactsQuerySortOrderDefault),
  "status": zod.enum(['processing', 'parsed', 'raw', 'missing']).optional(),
  "document_name_query": zod.string().optional(),
  "case_id": zod.string().min(1).optional().describe('Only artifacts linked to this case. Values are normalized server-side (trimmed and lowercased).'),
  "environment": zod.enum(['live', 'test']).optional(),
  "created_after": zod.string().datetime({"offset":true}).optional(),
  "created_before": zod.string().datetime({"offset":true}).optional(),
  "metadata": zod.record(zod.string(), zod.string()).optional().describe('Filter by metadata keys using bracket notation (e.g. metadata[claim_id]=abc-123, metadata[source]=email). Multiple filters are combined with AND logic.')
})

export const ListArtifactsResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.string(),
  "document_name": zod.string(),
  "metadata": zod.record(zod.string(), zod.unknown()),
  "created_at": zod.string().datetime({"offset":true}),
  "created_at_document": zod.union([zod.string(),zod.null()]),
  "updated_at": zod.string().datetime({"offset":true}),
  "has_content": zod.boolean(),
  "status": zod.enum(['processing', 'parsed', 'raw', 'missing'])
})),
  "message": zod.string(),
  "meta": zod.object({
  "total": zod.number()
})
})


export const GetArtifactParams = zod.object({
  "id": zod.string().uuid()
})

export const GetArtifactResponse = zod.object({
  "data": zod.object({
  "data": zod.object({
  "id": zod.string(),
  "document_name": zod.string(),
  "file_url": zod.union([zod.string(),zod.null()]),
  "metadata": zod.record(zod.string(), zod.unknown()),
  "created_at": zod.string().datetime({"offset":true}),
  "created_at_document": zod.union([zod.string(),zod.null()]),
  "updated_at": zod.string().datetime({"offset":true}),
  "status": zod.enum(['processing', 'parsed', 'raw', 'missing']),
  "content_md": zod.union([zod.string(),zod.null()]),
  "content_with_chunkids_md": zod.union([zod.string(),zod.null()]).describe('Parsed content annotated with [chunk_id=...] markers, always included when the artifact has parsed chunks. Chunk IDs are stable citation anchors usable to attribute extracted values to their source location. Null when the artifact has no parsed chunks.')
})
}),
  "message": zod.string()
})


export const DeleteArtifactParams = zod.object({
  "id": zod.string().uuid()
})

export const DeleteArtifactResponse = zod.object({
  "data": zod.object({

}),
  "message": zod.string()
})


export const getArtifactMetadataKeysQueryLimitDefault = 100;
export const getArtifactMetadataKeysQueryLimitMax = 500;



export const GetArtifactMetadataKeysQueryParams = zod.object({
  "limit": zod.number().min(1).max(getArtifactMetadataKeysQueryLimitMax).default(getArtifactMetadataKeysQueryLimitDefault)
})

export const GetArtifactMetadataKeysResponse = zod.object({
  "data": zod.object({
  "data": zod.object({
  "keys": zod.array(zod.string()),
  "values": zod.record(zod.string(), zod.array(zod.unknown()))
})
}),
  "message": zod.string()
})


export const GetArtifactStatusSummaryQueryParams = zod.object({
  "scope": zod.record(zod.string(), zod.string()).describe('Scope to summarize, using bracket notation (e.g. scope[email_id]=abc-123). At least one key is required. Multiple keys are combined with AND logic.')
})

export const getArtifactStatusSummaryResponseDataTotalMin = -9007199254740991;
export const getArtifactStatusSummaryResponseDataTotalMax = 9007199254740991;

export const getArtifactStatusSummaryResponseDataByStatusMinOne = -9007199254740991;
export const getArtifactStatusSummaryResponseDataByStatusMaxOne = 9007199254740991;



export const GetArtifactStatusSummaryResponse = zod.object({
  "data": zod.object({
  "total": zod.number().int().min(getArtifactStatusSummaryResponseDataTotalMin).max(getArtifactStatusSummaryResponseDataTotalMax),
  "by_status": zod.record(zod.string(), zod.number().int().min(getArtifactStatusSummaryResponseDataByStatusMinOne).max(getArtifactStatusSummaryResponseDataByStatusMaxOne))
}),
  "message": zod.string()
})





export const GetArtifactUploadUrlBody = zod.object({
  "filename": zod.string().min(1)
})

export const GetArtifactUploadUrlResponse = zod.object({
  "data": zod.object({
  "upload_url": zod.string(),
  "file_url": zod.string(),
  "expires_at": zod.string()
}),
  "message": zod.string()
})


export const UpdateArtifactMetadataParams = zod.object({
  "id": zod.string().uuid()
})

export const UpdateArtifactMetadataBody = zod.object({
  "metadata": zod.record(zod.string(), zod.unknown())
})

export const UpdateArtifactMetadataResponse = zod.object({
  "data": zod.object({
  "data": zod.object({
  "id": zod.string(),
  "document_name": zod.string(),
  "file_url": zod.union([zod.string(),zod.null()]),
  "metadata": zod.record(zod.string(), zod.unknown()),
  "created_at": zod.string().datetime({"offset":true}),
  "created_at_document": zod.union([zod.string(),zod.null()]),
  "updated_at": zod.string().datetime({"offset":true}),
  "status": zod.enum(['processing', 'parsed', 'raw', 'missing']),
  "content_md": zod.union([zod.string(),zod.null()]),
  "content_with_chunkids_md": zod.union([zod.string(),zod.null()]).describe('Parsed content annotated with [chunk_id=...] markers, always included when the artifact has parsed chunks. Chunk IDs are stable citation anchors usable to attribute extracted values to their source location. Null when the artifact has no parsed chunks.')
})
}),
  "message": zod.string()
})


export const SignUpBody = zod.object({
  "email": zod.string().email(),
  "password": zod.string()
})

export const SignUpResponse = zod.object({
  "data": zod.object({
  "pending_authentication_token": zod.string().optional()
}),
  "message": zod.string()
})









export const SignInBody = zod.union([zod.object({
  "type": zod.literal("password"),
  "email": zod.string().email(),
  "password": zod.string().min(1)
}),zod.object({
  "type": zod.literal("oauth"),
  "code": zod.string().min(1),
  "verifier": zod.string().min(1).optional().describe('PKCE verifier. Required only when the flow was started with a code_challenge.'),
  "provider": zod.enum(['google', 'sso']).optional()
}),zod.object({
  "type": zod.literal("email_otp"),
  "email": zod.string().email(),
  "token": zod.string().min(1),
  "pending_authentication_token": zod.string().min(1).optional()
})])

export const SignInResponse = zod.object({
  "data": zod.object({
  "access_token": zod.string(),
  "refresh_token": zod.string(),
  "expires_at": zod.string().datetime({"offset":true})
}),
  "message": zod.string()
})


export const requestPasswordResetBodyEmailMax = 254;



export const RequestPasswordResetBody = zod.object({
  "email": zod.string().email().max(requestPasswordResetBodyEmailMax)
})

export const RequestPasswordResetResponse = zod.object({
  "data": zod.object({

}),
  "message": zod.string()
})


export const resetPasswordBodyTokenMax = 512;

export const resetPasswordBodyNewPasswordMax = 256;



export const ResetPasswordBody = zod.object({
  "token": zod.string().min(1).max(resetPasswordBodyTokenMax),
  "new_password": zod.string().max(resetPasswordBodyNewPasswordMax)
})

export const ResetPasswordResponse = zod.object({
  "data": zod.object({

}),
  "message": zod.string()
})


export const RefreshTokenBody = zod.object({
  "access_token": zod.string(),
  "refresh_token": zod.string()
})

export const RefreshTokenResponse = zod.object({
  "data": zod.object({
  "access_token": zod.string(),
  "refresh_token": zod.string(),
  "expires_at": zod.string().datetime({"offset":true})
}),
  "message": zod.string()
})





export const GetOAuthUrlQueryParams = zod.object({
  "provider": zod.enum(['google', 'sso']),
  "redirect_uri": zod.string().url(),
  "code_challenge_method": zod.enum(['plain', 's256']).optional().describe('How code_challenge was derived. Required whenever code_challenge is sent.'),
  "code_challenge": zod.string().min(1).optional().describe('PKCE challenge derived from a verifier you keep until sign-in. Omit, together with code_challenge_method, to run the flow without PKCE.'),
  "email": zod.string().email().optional()
})

export const GetOAuthUrlResponse = zod.object({
  "data": zod.object({
  "url": zod.string().url()
}),
  "message": zod.string()
})


export const GetSessionTokenBody = zod.object({
  "tenant_id": zod.string().uuid().optional()
})

export const GetSessionTokenResponse = zod.object({
  "data": zod.object({
  "access_token": zod.string(),
  "tenant_id": zod.string(),
  "expires_in": zod.number()
}),
  "message": zod.string()
})


export const getPartnerJwksPathPartnerRegExp = new RegExp('^[a-z0-9]+(-[a-z0-9]+)*$');


export const GetPartnerJwksParams = zod.object({
  "partner": zod.string().regex(getPartnerJwksPathPartnerRegExp)
})

export const GetPartnerJwksResponse = zod.object({
  "keys": zod.array(zod.object({
  "kty": zod.string(),
  "kid": zod.string(),
  "alg": zod.string(),
  "use": zod.string(),
  "n": zod.string(),
  "e": zod.string()
}))
})


export const PartnerLaunchQueryParams = zod.object({
  "case_id": zod.string().optional(),
  "view": zod.string().optional()
})

export const PartnerLaunchResponse = zod.void()


export const listCallsQueryCountDefault = 50;
export const listCallsQueryCountMax = 100;

export const listCallsQueryOffsetDefault = 0;
export const listCallsQueryOffsetMin = 0;

export const listCallsQuerySortByDefault = `started_at`;
export const listCallsQuerySortOrderDefault = `desc`;




export const ListCallsQueryParams = zod.object({
  "count": zod.number().min(1).max(listCallsQueryCountMax).default(listCallsQueryCountDefault),
  "offset": zod.number().min(listCallsQueryOffsetMin).default(listCallsQueryOffsetDefault),
  "sort_by": zod.enum(['started_at', 'ended_at', 'created_at']).default(listCallsQuerySortByDefault),
  "sort_order": zod.enum(['asc', 'desc']).default(listCallsQuerySortOrderDefault),
  "call_id": zod.string().uuid().optional(),
  "agent_id": zod.string().uuid().optional(),
  "agent_name": zod.string().min(1).optional(),
  "job_id": zod.string().uuid().optional(),
  "direction": zod.enum(['INBOUND', 'OUTBOUND']).optional(),
  "environment": zod.enum(['live', 'test']).optional(),
  "status": zod.enum(['COMPLETED', 'TRANSFERRED', 'DISCONNECTED', 'UNEXPECTED_SHUTDOWN']).optional(),
  "started_after": zod.string().datetime({"offset":true}).optional(),
  "started_before": zod.string().datetime({"offset":true}).optional(),
  "phone_number": zod.string().min(1).optional(),
  "case_id": zod.string().min(1).optional().describe('Only calls linked to this case. Values are normalized server-side (trimmed and lowercased).'),
  "metadata": zod.record(zod.string(), zod.string()).optional().describe('Filter by metadata keys using bracket notation (e.g. metadata[claim_id]=abc-123, metadata[source]=worker). Multiple filters are combined with AND logic.')
})

export const ListCallsResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.string(),
  "external_call_id": zod.union([zod.string(),zod.null()]),
  "direction": zod.enum(['INBOUND', 'OUTBOUND']),
  "agent_id": zod.string(),
  "environment": zod.enum(['live', 'test']).describe('Release channel that handled the call. Test calls hand over to the worker\'s test version.'),
  "job_id": zod.union([zod.string(),zod.null()]),
  "from_phone_number": zod.union([zod.string(),zod.null()]),
  "to_phone_number": zod.union([zod.string(),zod.null()]),
  "started_at": zod.string().datetime({"offset":true}),
  "ended_at": zod.string().datetime({"offset":true}),
  "duration_seconds": zod.union([zod.number(),zod.null()]),
  "completion_status": zod.union([zod.string().describe('Call completion status'),zod.null()]),
  "termination_initiator": zod.union([zod.string(),zod.null()]),
  "disconnect_reason": zod.union([zod.string(),zod.null()]),
  "ended_reason": zod.string(),
  "metadata": zod.union([zod.record(zod.string(), zod.unknown()),zod.null()]),
  "evaluation": zod.union([zod.object({
  "status": zod.string(),
  "score": zod.union([zod.number(),zod.null()]),
  "passed": zod.union([zod.boolean(),zod.null()])
}),zod.null()]),
  "created_at": zod.string().datetime({"offset":true})
})),
  "message": zod.string(),
  "meta": zod.object({
  "total": zod.number()
})
})


export const GetCallParams = zod.object({
  "id": zod.string().uuid()
})

export const GetCallQueryParams = zod.object({
  "include_messages": zod.string().optional()
})

export const GetCallResponse = zod.object({
  "data": zod.object({
  "id": zod.string(),
  "external_call_id": zod.union([zod.string(),zod.null()]),
  "direction": zod.enum(['INBOUND', 'OUTBOUND']),
  "agent_id": zod.string(),
  "environment": zod.enum(['live', 'test']).describe('Release channel that handled the call. Test calls hand over to the worker\'s test version.'),
  "job_id": zod.union([zod.string(),zod.null()]),
  "from_phone_number": zod.union([zod.string(),zod.null()]),
  "to_phone_number": zod.union([zod.string(),zod.null()]),
  "started_at": zod.string().datetime({"offset":true}),
  "ended_at": zod.string().datetime({"offset":true}),
  "duration_seconds": zod.union([zod.number(),zod.null()]),
  "completion_status": zod.union([zod.string().describe('Call completion status'),zod.null()]),
  "termination_initiator": zod.union([zod.string(),zod.null()]),
  "disconnect_reason": zod.union([zod.string(),zod.null()]),
  "ended_reason": zod.string(),
  "file_url": zod.union([zod.string(),zod.null()]),
  "metadata": zod.union([zod.record(zod.string(), zod.unknown()),zod.null()]),
  "evaluation": zod.union([zod.object({
  "status": zod.string(),
  "score": zod.union([zod.number(),zod.null()]),
  "passed": zod.union([zod.boolean(),zod.null()])
}),zod.null()]),
  "created_at": zod.string().datetime({"offset":true}),
  "messages": zod.union([zod.array(zod.object({
  "id": zod.string(),
  "message_type": zod.string(),
  "sequence_number": zod.number(),
  "timestamp_seconds": zod.number(),
  "occurred_at": zod.string(),
  "role": zod.union([zod.string(),zod.null()]),
  "message_text": zod.union([zod.string(),zod.null()]),
  "tool_call_id": zod.union([zod.string(),zod.null()]),
  "tool_name": zod.union([zod.string(),zod.null()]),
  "tool_arguments": zod.union([zod.record(zod.string(), zod.unknown()),zod.null()]),
  "tool_result": zod.union([zod.record(zod.string(), zod.unknown()),zod.null()]),
  "metadata": zod.union([zod.record(zod.string(), zod.unknown()),zod.null()])
})),zod.null()])
}),
  "message": zod.string()
})


export const GetCallEvaluationParams = zod.object({
  "id": zod.string().uuid()
})

export const GetCallEvaluationResponse = zod.object({
  "data": zod.object({
  "id": zod.string(),
  "evaluation_status": zod.union([zod.string().describe('Evaluation status'),zod.null()]),
  "score": zod.union([zod.number(),zod.null()]),
  "passed": zod.union([zod.boolean(),zod.null()]),
  "metrics": zod.array(zod.object({
  "slug": zod.string(),
  "name": zod.string(),
  "question": zod.string(),
  "pass": zod.union([zod.boolean(),zod.null()]),
  "score": zod.union([zod.number(),zod.null()]),
  "explanation": zod.union([zod.string(),zod.null()])
}))
}),
  "message": zod.string()
})


export const getCallAnalyticsQueryTimezoneDefault = `UTC`;

export const GetCallAnalyticsQueryParams = zod.object({
  "from": zod.string(),
  "to": zod.string(),
  "timezone": zod.string().default(getCallAnalyticsQueryTimezoneDefault),
  "agent_ids": zod.string().optional()
})

export const GetCallAnalyticsResponse = zod.object({
  "data": zod.object({
  "summary": zod.object({
  "total_calls": zod.number(),
  "avg_evaluation_score": zod.number(),
  "pass_rate": zod.number(),
  "avg_call_duration": zod.number()
}),
  "calls_over_time": zod.array(zod.object({
  "date": zod.string(),
  "calls": zod.number()
})),
  "evaluation_over_time": zod.array(zod.object({
  "date": zod.string(),
  "avg_score": zod.number()
})),
  "score_distribution": zod.array(zod.object({
  "label": zod.string(),
  "count": zod.number()
})),
  "duration_distribution": zod.array(zod.object({
  "label": zod.string(),
  "count": zod.number()
})),
  "metric_performance": zod.array(zod.object({
  "slug": zod.string(),
  "title": zod.string(),
  "avg_score": zod.number(),
  "pass_rate": zod.number(),
  "evaluated": zod.number()
}))
}),
  "message": zod.string()
})


export const getAnalyticsTimeSeriesQueryGranularityDefault = `day`;
export const getAnalyticsTimeSeriesQueryTimezoneDefault = `UTC`;

export const GetAnalyticsTimeSeriesQueryParams = zod.object({
  "metric": zod.enum(['worker_runs', 'documents', 'pages']),
  "from": zod.string(),
  "to": zod.string(),
  "granularity": zod.enum(['day', 'week', 'month']).default(getAnalyticsTimeSeriesQueryGranularityDefault),
  "group_by": zod.enum(['worker_id']).optional(),
  "timezone": zod.string().default(getAnalyticsTimeSeriesQueryTimezoneDefault)
})

export const GetAnalyticsTimeSeriesResponse = zod.object({
  "data": zod.array(zod.object({
  "metric": zod.enum(['worker_runs', 'documents', 'pages']),
  "granularity": zod.enum(['day', 'week', 'month']),
  "group_by": zod.union([zod.enum(['worker_id']),zod.null()]),
  "total": zod.number(),
  "points": zod.array(zod.object({
  "date": zod.string(),
  "group_key": zod.union([zod.string(),zod.null()]),
  "group_label": zod.union([zod.string(),zod.null()]),
  "value": zod.number()
}))
})),
  "message": zod.string()
})


export const CreateCallFeedbackParams = zod.object({
  "id": zod.string().uuid().describe('The call ID')
})

export const createCallFeedbackBodyTextMax = 10000;



export const CreateCallFeedbackBody = zod.object({
  "message_id": zod.string().uuid().describe('The message ID to attach feedback to'),
  "text": zod.string().min(1).max(createCallFeedbackBodyTextMax).describe('Feedback content')
})

export const CreateCallFeedbackResponse = zod.object({
  "data": zod.object({
  "id": zod.string().uuid(),
  "call_id": zod.string().uuid(),
  "message_id": zod.string().uuid(),
  "author_email": zod.string(),
  "text": zod.string(),
  "created_at": zod.string().datetime({"offset":true}),
  "updated_at": zod.string().datetime({"offset":true})
}),
  "message": zod.string()
})


export const ListCallFeedbackParams = zod.object({
  "id": zod.string().uuid().describe('The call ID')
})

export const listCallFeedbackQueryCountDefault = 50;
export const listCallFeedbackQueryCountMax = 100;

export const listCallFeedbackQueryOffsetDefault = 0;
export const listCallFeedbackQueryOffsetMin = 0;

export const listCallFeedbackQuerySortByDefault = `created_at`;
export const listCallFeedbackQuerySortOrderDefault = `asc`;

export const ListCallFeedbackQueryParams = zod.object({
  "count": zod.number().min(1).max(listCallFeedbackQueryCountMax).default(listCallFeedbackQueryCountDefault),
  "offset": zod.number().min(listCallFeedbackQueryOffsetMin).default(listCallFeedbackQueryOffsetDefault),
  "sort_by": zod.enum(['created_at']).default(listCallFeedbackQuerySortByDefault),
  "sort_order": zod.enum(['asc', 'desc']).default(listCallFeedbackQuerySortOrderDefault)
})

export const ListCallFeedbackResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.string().uuid(),
  "call_id": zod.string().uuid(),
  "message_id": zod.string().uuid(),
  "author_email": zod.string(),
  "text": zod.string(),
  "created_at": zod.string().datetime({"offset":true}),
  "updated_at": zod.string().datetime({"offset":true})
})),
  "message": zod.string(),
  "meta": zod.object({
  "total": zod.number()
})
})


export const DeleteCallFeedbackParams = zod.object({
  "id": zod.string().uuid().describe('The call ID'),
  "feedbackId": zod.string().uuid().describe('The feedback ID to delete')
})

export const DeleteCallFeedbackResponse = zod.object({
  "data": zod.null(),
  "message": zod.string()
})


export const CheckInboxAvailabilityQueryParams = zod.object({
  "username": zod.string().describe('Email username')
})

export const CheckInboxAvailabilityResponse = zod.object({
  "data": zod.object({
  "available": zod.boolean().describe('Whether the username is available')
}),
  "message": zod.string()
})


export const createInboxBodyNameMax = 256;

export const createInboxBodyAttachmentPasswordOneMax = 2048;




export const CreateInboxBody = zod.object({
  "name": zod.string().min(1).max(createInboxBodyNameMax),
  "extractor_id": zod.string().uuid().optional().describe('Deprecated. Use processor_id instead.'),
  "processor_id": zod.string().uuid().optional().describe('ID of the processor (extractor or worker) to use.'),
  "processor_type": zod.enum(['extractor', 'worker']).optional().describe('Type of processor. Defaults to \'extractor\' when extractor_id is used.'),
  "attachment_password": zod.union([zod.string().max(createInboxBodyAttachmentPasswordOneMax),zod.null()]).optional(),
  "pdf_splitting_enabled": zod.boolean().optional(),
  "username": zod.string().optional().describe('Username for the live address. Generated when omitted.'),
  "test_username": zod.string().optional().describe('Username for the test address. Generated when omitted.'),
  "allowed_sender_domains": zod.union([zod.array(zod.string()).min(1),zod.null()]).describe('List of allowed sender domain patterns. When null, all senders are accepted. When set to an array, only emails from matching domains are processed. Supports wildcard patterns: \'*.example.com\' matches \'example.com\' and all its subdomains.')
})

export const CreateInboxResponse = zod.object({
  "data": zod.object({
  "id": zod.string(),
  "name": zod.string(),
  "addresses": zod.object({
  "live": zod.string(),
  "test": zod.union([zod.string(),zod.null()]).describe('Null on inboxes created before test addresses existed.')
}).describe('Mail sent to the test address runs the worker\'s test version instead of its live one.'),
  "email_address": zod.string().describe('Deprecated. Use addresses.live instead.'),
  "extractor_id": zod.string().describe('Deprecated. Use processor_id instead.'),
  "processor_id": zod.string(),
  "processor_type": zod.enum(['extractor', 'worker']),
  "has_password": zod.boolean(),
  "pdf_splitting_enabled": zod.boolean(),
  "allowed_sender_domains": zod.union([zod.array(zod.string()),zod.null()]),
  "created_at": zod.string().datetime({"offset":true}),
  "updated_at": zod.string().datetime({"offset":true})
}),
  "message": zod.string()
})


export const listInboxesQueryCountDefault = 50;
export const listInboxesQueryCountMax = 100;

export const listInboxesQueryOffsetDefault = 0;
export const listInboxesQueryOffsetMin = 0;

export const listInboxesQuerySortByDefault = `created_at`;
export const listInboxesQuerySortOrderDefault = `desc`;

export const ListInboxesQueryParams = zod.object({
  "count": zod.number().min(1).max(listInboxesQueryCountMax).default(listInboxesQueryCountDefault),
  "offset": zod.number().min(listInboxesQueryOffsetMin).default(listInboxesQueryOffsetDefault),
  "sort_by": zod.enum(['created_at']).default(listInboxesQuerySortByDefault),
  "sort_order": zod.enum(['asc', 'desc']).default(listInboxesQuerySortOrderDefault)
})

export const ListInboxesResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.string(),
  "name": zod.string(),
  "addresses": zod.object({
  "live": zod.string(),
  "test": zod.union([zod.string(),zod.null()]).describe('Null on inboxes created before test addresses existed.')
}).describe('Mail sent to the test address runs the worker\'s test version instead of its live one.'),
  "email_address": zod.string().describe('Deprecated. Use addresses.live instead.'),
  "extractor_id": zod.string().describe('Deprecated. Use processor_id instead.'),
  "processor_id": zod.string(),
  "processor_type": zod.enum(['extractor', 'worker']),
  "has_password": zod.boolean(),
  "pdf_splitting_enabled": zod.boolean(),
  "allowed_sender_domains": zod.union([zod.array(zod.string()),zod.null()]),
  "created_at": zod.string().datetime({"offset":true}),
  "updated_at": zod.string().datetime({"offset":true})
})),
  "message": zod.string(),
  "meta": zod.object({
  "total": zod.number()
})
})


export const UpdateInboxParams = zod.object({
  "inboxId": zod.string().uuid()
})




export const UpdateInboxBody = zod.object({
  "pdf_splitting_enabled": zod.boolean().optional(),
  "allowed_sender_domains": zod.union([zod.array(zod.string()).min(1),zod.null()]).optional().describe('List of allowed sender domain patterns. Set to null to accept all senders. Set to an array to only process emails from matching domains. Supports wildcard patterns: \'*.example.com\' matches \'example.com\' and all its subdomains.'),
  "processor": zod.object({
  "id": zod.string().uuid().describe('ID of the processor (extractor or worker) to use.'),
  "type": zod.enum(['extractor', 'worker']).describe('Type of processor.')
}).optional().describe('Processor configuration. Pass an object with id and type to change the processor.')
})

export const UpdateInboxResponse = zod.object({
  "data": zod.object({
  "id": zod.string(),
  "name": zod.string(),
  "addresses": zod.object({
  "live": zod.string(),
  "test": zod.union([zod.string(),zod.null()]).describe('Null on inboxes created before test addresses existed.')
}).describe('Mail sent to the test address runs the worker\'s test version instead of its live one.'),
  "email_address": zod.string().describe('Deprecated. Use addresses.live instead.'),
  "extractor_id": zod.string().describe('Deprecated. Use processor_id instead.'),
  "processor_id": zod.string(),
  "processor_type": zod.enum(['extractor', 'worker']),
  "has_password": zod.boolean(),
  "pdf_splitting_enabled": zod.boolean(),
  "allowed_sender_domains": zod.union([zod.array(zod.string()),zod.null()]),
  "created_at": zod.string().datetime({"offset":true}),
  "updated_at": zod.string().datetime({"offset":true})
}),
  "message": zod.string()
})


export const DeleteInboxParams = zod.object({
  "inboxId": zod.string().uuid()
})

export const DeleteInboxResponse = zod.object({
  "data": zod.object({

}),
  "message": zod.string()
})


export const GetEmailParams = zod.object({
  "emailId": zod.string().uuid()
})

export const GetEmailResponse = zod.object({
  "data": zod.object({
  "id": zod.string(),
  "thread_id": zod.string(),
  "inbox_id": zod.union([zod.string(),zod.null()]),
  "email_agent_id": zod.union([zod.string(),zod.null()]),
  "direction": zod.enum(['inbound', 'outbound']),
  "environment": zod.enum(['live', 'test']),
  "from": zod.string(),
  "to": zod.array(zod.string()),
  "cc": zod.array(zod.string()),
  "bcc": zod.array(zod.string()),
  "subject": zod.union([zod.string(),zod.null()]),
  "body_text": zod.union([zod.string(),zod.null()]),
  "body_html": zod.union([zod.string(),zod.null()]),
  "ignored_reason": zod.union([zod.enum(['sender_domain_not_allowed', 'received_via_cc_or_bcc', 'sent_from_own_inbox']),zod.null()]).describe('Why the email was stored without processing. Null for emails that were processed normally.'),
  "sent_at": zod.string(),
  "received_at": zod.string(),
  "created_at": zod.string().datetime({"offset":true})
}),
  "message": zod.string()
})


export const DeleteEmailParams = zod.object({
  "emailId": zod.string().uuid()
})

export const DeleteEmailResponse = zod.object({
  "data": zod.object({

}),
  "message": zod.string()
})



export const listEmailsQueryContentMax = 500;


export const listEmailsQueryCountDefault = 50;
export const listEmailsQueryCountMax = 100;

export const listEmailsQueryOffsetDefault = 0;
export const listEmailsQueryOffsetMin = 0;

export const listEmailsQuerySortByDefault = `created_at`;
export const listEmailsQuerySortOrderDefault = `desc`;

export const ListEmailsQueryParams = zod.object({
  "inbox_id": zod.string().uuid().optional(),
  "thread_id": zod.string().min(1).optional(),
  "agent_id": zod.string().uuid().optional(),
  "sender": zod.string().email().optional(),
  "recipient": zod.string().email().optional(),
  "content": zod.string().min(1).max(listEmailsQueryContentMax).optional(),
  "case_id": zod.string().min(1).optional(),
  "environment": zod.enum(['live', 'test']).optional(),
  "count": zod.number().min(1).max(listEmailsQueryCountMax).default(listEmailsQueryCountDefault),
  "offset": zod.number().min(listEmailsQueryOffsetMin).default(listEmailsQueryOffsetDefault),
  "sort_by": zod.enum(['created_at', 'sent_at']).default(listEmailsQuerySortByDefault),
  "sort_order": zod.enum(['asc', 'desc']).default(listEmailsQuerySortOrderDefault)
})

export const ListEmailsResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.string(),
  "thread_id": zod.string(),
  "inbox_id": zod.union([zod.string(),zod.null()]),
  "email_agent_id": zod.union([zod.string(),zod.null()]),
  "direction": zod.enum(['inbound', 'outbound']),
  "environment": zod.enum(['live', 'test']),
  "from": zod.string(),
  "to": zod.array(zod.string()),
  "subject": zod.union([zod.string(),zod.null()]),
  "preview": zod.union([zod.string(),zod.null()]),
  "ignored_reason": zod.union([zod.enum(['sender_domain_not_allowed', 'received_via_cc_or_bcc', 'sent_from_own_inbox']),zod.null()]).describe('Why the email was stored without processing. Null for emails that were processed normally.'),
  "sent_at": zod.string(),
  "received_at": zod.string(),
  "created_at": zod.string().datetime({"offset":true})
})),
  "message": zod.string(),
  "meta": zod.object({
  "total": zod.number()
})
})


export const listEmailThreadsQueryCountDefault = 50;
export const listEmailThreadsQueryCountMax = 100;

export const listEmailThreadsQueryOffsetDefault = 0;
export const listEmailThreadsQueryOffsetMin = 0;

export const listEmailThreadsQuerySortByDefault = `last_email_at`;
export const listEmailThreadsQuerySortOrderDefault = `desc`;

export const ListEmailThreadsQueryParams = zod.object({
  "inbox_id": zod.string().uuid().optional(),
  "environment": zod.enum(['live', 'test']).optional(),
  "count": zod.number().min(1).max(listEmailThreadsQueryCountMax).default(listEmailThreadsQueryCountDefault),
  "offset": zod.number().min(listEmailThreadsQueryOffsetMin).default(listEmailThreadsQueryOffsetDefault),
  "sort_by": zod.enum(['last_email_at']).default(listEmailThreadsQuerySortByDefault),
  "sort_order": zod.enum(['asc', 'desc']).default(listEmailThreadsQuerySortOrderDefault)
})

export const ListEmailThreadsResponse = zod.object({
  "data": zod.array(zod.object({
  "thread_id": zod.string(),
  "subject": zod.union([zod.string(),zod.null()]),
  "environment": zod.enum(['live', 'test']).describe('Release channel the thread belongs to, taken from its first email.'),
  "last_email_at": zod.string().datetime({"offset":true}),
  "first_sender": zod.string(),
  "first_recipient": zod.union([zod.string(),zod.null()]),
  "message_count": zod.number()
})),
  "message": zod.string(),
  "meta": zod.object({
  "total": zod.number()
})
})


export const ReplyToEmailParams = zod.object({
  "emailId": zod.string().uuid()
})


export const replyToEmailBodyIsHtmlDefault = true;
export const replyToEmailBodyAttachmentsItemOneFilenameMax = 255;

export const replyToEmailBodyAttachmentsItemOneContentTypeMax = 255;


export const replyToEmailBodyAttachmentsMax = 10;



export const ReplyToEmailBody = zod.object({
  "body": zod.string().min(1),
  "is_html": zod.boolean().default(replyToEmailBodyIsHtmlDefault),
  "to": zod.array(zod.string().email()).optional(),
  "cc": zod.array(zod.string().email()).optional(),
  "bcc": zod.array(zod.string().email()).optional(),
  "attachments": zod.array(zod.union([zod.object({
  "type": zod.literal("base64"),
  "filename": zod.string().min(1).max(replyToEmailBodyAttachmentsItemOneFilenameMax),
  "content_type": zod.string().min(1).max(replyToEmailBodyAttachmentsItemOneContentTypeMax),
  "content_base64": zod.string().min(1)
}),zod.object({
  "type": zod.literal("artifact"),
  "artifact_id": zod.string().uuid()
})])).max(replyToEmailBodyAttachmentsMax).optional()
})

export const ReplyToEmailResponse = zod.object({
  "data": zod.object({
  "sent": zod.literal(true)
}),
  "message": zod.string()
})






export const sendEmailBodyIsHtmlDefault = true;
export const sendEmailBodyAttachmentsItemOneFilenameMax = 255;

export const sendEmailBodyAttachmentsItemOneContentTypeMax = 255;


export const sendEmailBodyAttachmentsMax = 10;



export const SendEmailBody = zod.object({
  "inbox_id": zod.string().min(1),
  "environment": zod.enum(['live', 'test']).optional().describe('Inbox address to send from. `test` sends from the inbox\'s test address, `live` from its live one. Defaults to `live`.'),
  "to": zod.array(zod.string().email()).min(1),
  "cc": zod.array(zod.string().email()).optional(),
  "bcc": zod.array(zod.string().email()).optional(),
  "subject": zod.string().min(1),
  "body": zod.string().min(1),
  "is_html": zod.boolean().default(sendEmailBodyIsHtmlDefault),
  "attachments": zod.array(zod.union([zod.object({
  "type": zod.literal("base64"),
  "filename": zod.string().min(1).max(sendEmailBodyAttachmentsItemOneFilenameMax),
  "content_type": zod.string().min(1).max(sendEmailBodyAttachmentsItemOneContentTypeMax),
  "content_base64": zod.string().min(1)
}),zod.object({
  "type": zod.literal("artifact"),
  "artifact_id": zod.string().uuid()
})])).max(sendEmailBodyAttachmentsMax).optional()
})

export const SendEmailResponse = zod.object({
  "data": zod.object({
  "email_id": zod.string(),
  "thread_id": zod.string(),
  "sent": zod.literal(true)
}),
  "message": zod.string()
})


export const listExtractorJobsQueryCountDefault = 50;
export const listExtractorJobsQueryCountMax = 100;

export const listExtractorJobsQueryOffsetDefault = 0;
export const listExtractorJobsQueryOffsetMin = 0;

export const listExtractorJobsQuerySortByDefault = `created_at`;
export const listExtractorJobsQuerySortOrderDefault = `desc`;

export const ListExtractorJobsQueryParams = zod.object({
  "count": zod.number().min(1).max(listExtractorJobsQueryCountMax).default(listExtractorJobsQueryCountDefault).describe('Number of results to return'),
  "offset": zod.number().min(listExtractorJobsQueryOffsetMin).default(listExtractorJobsQueryOffsetDefault).describe('Number of results to skip for pagination'),
  "sort_by": zod.enum(['created_at', 'started_at', 'completed_at']).default(listExtractorJobsQuerySortByDefault).describe('Field to sort by'),
  "sort_order": zod.enum(['asc', 'desc']).default(listExtractorJobsQuerySortOrderDefault).describe('Sort direction'),
  "status": zod.enum(['queued', 'in_progress', 'completed', 'failed', 'canceled']).optional().describe('Filter by job status'),
  "extractor_id": zod.string().uuid().optional().describe('Filter by extractor ID'),
  "created_after": zod.string().datetime({"offset":true}).optional().describe('Filter jobs created after this date (ISO 8601)'),
  "created_before": zod.string().datetime({"offset":true}).optional().describe('Filter jobs created before this date (ISO 8601)'),
  "scope": zod.record(zod.string(), zod.string()).optional().describe('Filter by scope keys using bracket notation (e.g. scope[call_id]=abc-123, scope[email_id]=xyz-456, scope[case_id]=case-789). Multiple filters are combined with AND logic.')
})

export const listExtractorJobsResponseDataItemExtractorVersionMin = -9007199254740991;
export const listExtractorJobsResponseDataItemExtractorVersionMax = 9007199254740991;

export const listExtractorJobsResponseMetaTotalMin = -9007199254740991;
export const listExtractorJobsResponseMetaTotalMax = 9007199254740991;



export const ListExtractorJobsResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.string().describe('Unique job identifier'),
  "extractor_id": zod.string().describe('ID of the extractor that created this job'),
  "extractor_version": zod.number().int().min(listExtractorJobsResponseDataItemExtractorVersionMin).max(listExtractorJobsResponseDataItemExtractorVersionMax).describe('Version of the extractor at job creation time'),
  "extractor_name": zod.string().describe('Name of the extractor'),
  "status": zod.string().describe('Current job status'),
  "scope": zod.record(zod.string(), zod.unknown()).describe('Job scope metadata (e.g. claim_id, email_id)'),
  "created_at": zod.string().describe('ISO 8601 timestamp when the job was created'),
  "started_at": zod.union([zod.string(),zod.null()]).describe('ISO 8601 timestamp when processing started'),
  "completed_at": zod.union([zod.string(),zod.null()]).describe('ISO 8601 timestamp when processing finished'),
  "processing_duration_ms": zod.union([zod.number(),zod.null()]).describe('Processing duration in milliseconds'),
  "extract_id": zod.union([zod.string(),zod.null()]).describe('ID of the resulting extract, if completed'),
  "error": zod.union([zod.string(),zod.null()])
})),
  "message": zod.string(),
  "meta": zod.object({
  "total": zod.number().int().min(listExtractorJobsResponseMetaTotalMin).max(listExtractorJobsResponseMetaTotalMax).describe('Total number of matching jobs')
})
})


export const CreateExtractorJobBody = zod.object({
  "extractor_id": zod.string().uuid(),
  "scope": zod.record(zod.string(), zod.union([zod.string(),zod.number(),zod.boolean(),zod.null()]))
})

export const CreateExtractorJobResponse = zod.object({
  "data": zod.object({
  "id": zod.string(),
  "extractor_id": zod.string(),
  "extractor_version": zod.number(),
  "scope": zod.record(zod.string(), zod.unknown()),
  "status": zod.string(),
  "created_at": zod.string().datetime({"offset":true})
}),
  "message": zod.string()
})


export const GetExtractorJobParams = zod.object({
  "id": zod.string().uuid()
})

export const GetExtractorJobResponse = zod.object({
  "data": zod.object({
  "data": zod.object({
  "id": zod.string(),
  "extractor_id": zod.string(),
  "extractor_version": zod.number(),
  "extractor_name": zod.string(),
  "status": zod.string(),
  "scope": zod.record(zod.string(), zod.unknown()),
  "created_at": zod.string().datetime({"offset":true}),
  "started_at": zod.union([zod.string().datetime({"offset":true}),zod.null()]),
  "completed_at": zod.union([zod.string(),zod.null()]),
  "processing_duration_ms": zod.union([zod.number(),zod.null()]),
  "extract_id": zod.union([zod.string(),zod.null()]),
  "error": zod.union([zod.string(),zod.null()])
})
}),
  "message": zod.string()
})




export const listWorkerRunsQueryCountDefault = 50;
export const listWorkerRunsQueryCountMax = 100;

export const listWorkerRunsQueryOffsetDefault = 0;
export const listWorkerRunsQueryOffsetMin = 0;

export const listWorkerRunsQuerySortByDefault = `created_at`;
export const listWorkerRunsQuerySortOrderDefault = `desc`;

export const ListWorkerRunsQueryParams = zod.object({
  "status": zod.enum(['pending', 'queued', 'starting', 'in_progress', 'completed', 'failed', 'canceled']).optional(),
  "worker_id": zod.string().uuid().optional(),
  "case_id": zod.string().min(1).optional(),
  "outcome": zod.string().min(1).optional(),
  "environment": zod.enum(['live', 'test']).optional(),
  "created_after": zod.string().datetime({"offset":true}).optional(),
  "created_before": zod.string().datetime({"offset":true}).optional(),
  "count": zod.number().min(1).max(listWorkerRunsQueryCountMax).default(listWorkerRunsQueryCountDefault),
  "offset": zod.number().min(listWorkerRunsQueryOffsetMin).default(listWorkerRunsQueryOffsetDefault),
  "sort_by": zod.enum(['created_at', 'started_at', 'completed_at']).default(listWorkerRunsQuerySortByDefault),
  "sort_order": zod.enum(['asc', 'desc']).default(listWorkerRunsQuerySortOrderDefault),
  "scope": zod.record(zod.string(), zod.string()).optional().describe('Filter by scope keys using bracket notation (e.g. scope[call_id]=abc-123). Multiple filters are combined with AND logic.')
})

export const listWorkerRunsResponseDataItemWorkerVersionMin = -9007199254740991;
export const listWorkerRunsResponseDataItemWorkerVersionMax = 9007199254740991;

export const listWorkerRunsResponseMetaTotalMin = -9007199254740991;
export const listWorkerRunsResponseMetaTotalMax = 9007199254740991;



export const ListWorkerRunsResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.string().describe('Unique run identifier'),
  "worker_id": zod.string().describe('ID of the worker'),
  "worker_version": zod.number().int().min(listWorkerRunsResponseDataItemWorkerVersionMin).max(listWorkerRunsResponseDataItemWorkerVersionMax).describe('The worker config version this run executes: the version live at run creation. Editing the worker afterwards does not change it.'),
  "worker_name": zod.string().describe('Name of the worker'),
  "environment": zod.enum(['live', 'test']).describe('Release channel the run was started for. Test calls run the worker\'s test version; every other trigger runs live.'),
  "status": zod.enum(['pending', 'queued', 'starting', 'in_progress', 'completed', 'failed', 'canceled']).describe('Current run status'),
  "scope": zod.union([zod.record(zod.string(), zod.unknown()),zod.null()]).describe('Run scope metadata (e.g. claim_id, email_id). Null when the run has no artifacts.'),
  "created_at": zod.string().datetime({"offset":true}).describe('ISO 8601 timestamp when the run was created'),
  "started_at": zod.union([zod.string().datetime({"offset":true}),zod.null()]).describe('ISO 8601 timestamp when processing started'),
  "completed_at": zod.union([zod.string().datetime({"offset":true}),zod.null()]).describe('ISO 8601 timestamp when processing finished'),
  "processing_duration_ms": zod.union([zod.number(),zod.null()]).describe('Processing duration in milliseconds'),
  "extract_id": zod.union([zod.string().uuid(),zod.null()]).describe('Optional extract ID, set only if the worker run created an extract.'),
  "error": zod.union([zod.string(),zod.null()]),
  "outcome": zod.union([zod.string(),zod.null()]).describe('Use-case-specific business outcome reported by the worker. Null when the run predates outcome tracking or never executed to completion.'),
  "outcome_reason": zod.union([zod.string(),zod.null()]).describe('Worker-authored explanation of the outcome. May contain case content.')
})),
  "message": zod.string(),
  "meta": zod.object({
  "total": zod.number().int().min(listWorkerRunsResponseMetaTotalMin).max(listWorkerRunsResponseMetaTotalMax).describe('Total number of matching runs')
})
})


export const CreateWorkerRunBody = zod.object({
  "worker_id": zod.string().uuid(),
  "scope": zod.union([zod.record(zod.string(), zod.union([zod.string(),zod.number(),zod.boolean(),zod.null()])),zod.null()]),
  "environment": zod.enum(['live', 'test']).optional().describe('Release channel to run. `test` runs the worker\'s test version, `live` the live one. Defaults to `live`.')
})

export const CreateWorkerRunResponse = zod.object({
  "data": zod.object({
  "id": zod.string(),
  "worker_id": zod.string(),
  "worker_version": zod.number(),
  "environment": zod.enum(['live', 'test']),
  "scope": zod.union([zod.record(zod.string(), zod.unknown()),zod.null()]),
  "status": zod.enum(['pending', 'queued', 'starting', 'in_progress', 'completed', 'failed', 'canceled']),
  "created_at": zod.string().datetime({"offset":true})
}),
  "message": zod.string()
})


export const GetWorkerRunParams = zod.object({
  "workerRunId": zod.string().uuid()
})

export const getWorkerRunResponseDataWorkerVersionMin = -9007199254740991;
export const getWorkerRunResponseDataWorkerVersionMax = 9007199254740991;



export const GetWorkerRunResponse = zod.object({
  "data": zod.object({
  "id": zod.string().describe('Unique run identifier'),
  "worker_id": zod.string().describe('ID of the worker'),
  "worker_version": zod.number().int().min(getWorkerRunResponseDataWorkerVersionMin).max(getWorkerRunResponseDataWorkerVersionMax).describe('The worker config version this run executes: the version live at run creation. Editing the worker afterwards does not change it.'),
  "worker_name": zod.string().describe('Name of the worker'),
  "environment": zod.enum(['live', 'test']).describe('Release channel the run was started for. Test calls run the worker\'s test version; every other trigger runs live.'),
  "status": zod.enum(['pending', 'queued', 'starting', 'in_progress', 'completed', 'failed', 'canceled']).describe('Current run status'),
  "scope": zod.union([zod.record(zod.string(), zod.unknown()),zod.null()]).describe('Run scope metadata (e.g. claim_id, email_id). Null when the run has no artifacts.'),
  "created_at": zod.string().datetime({"offset":true}).describe('ISO 8601 timestamp when the run was created'),
  "started_at": zod.union([zod.string().datetime({"offset":true}),zod.null()]).describe('ISO 8601 timestamp when processing started'),
  "completed_at": zod.union([zod.string().datetime({"offset":true}),zod.null()]).describe('ISO 8601 timestamp when processing finished'),
  "processing_duration_ms": zod.union([zod.number(),zod.null()]).describe('Processing duration in milliseconds'),
  "extract_id": zod.union([zod.string().uuid(),zod.null()]).describe('Optional extract ID, set only if the worker run created an extract.'),
  "error": zod.union([zod.string(),zod.null()]),
  "outcome": zod.union([zod.string(),zod.null()]).describe('Use-case-specific business outcome reported by the worker. Null when the run predates outcome tracking or never executed to completion.'),
  "outcome_reason": zod.union([zod.string(),zod.null()]).describe('Worker-authored explanation of the outcome. May contain case content.')
}),
  "message": zod.string()
})


export const ListWorkerRunMessagesParams = zod.object({
  "workerRunId": zod.string().uuid()
})

export const listWorkerRunMessagesQueryCountDefault = 100;
export const listWorkerRunMessagesQueryCountMax = 500;



export const ListWorkerRunMessagesQueryParams = zod.object({
  "after": zod.string().datetime({"offset":true}).optional(),
  "count": zod.number().int().min(1).max(listWorkerRunMessagesQueryCountMax).default(listWorkerRunMessagesQueryCountDefault)
})

export const ListWorkerRunMessagesResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.string(),
  "worker_run_id": zod.string(),
  "message": zod.record(zod.string(), zod.unknown()),
  "emitted_at": zod.string().datetime({"offset":true}),
  "created_at": zod.string().datetime({"offset":true})
})),
  "message": zod.string()
})


export const CancelWorkerRunParams = zod.object({
  "workerRunId": zod.string().uuid()
})

export const cancelWorkerRunResponseDataWorkerVersionMin = -9007199254740991;
export const cancelWorkerRunResponseDataWorkerVersionMax = 9007199254740991;



export const CancelWorkerRunResponse = zod.object({
  "data": zod.object({
  "id": zod.string().describe('Unique run identifier'),
  "worker_id": zod.string().describe('ID of the worker'),
  "worker_version": zod.number().int().min(cancelWorkerRunResponseDataWorkerVersionMin).max(cancelWorkerRunResponseDataWorkerVersionMax).describe('The worker config version this run executes: the version live at run creation. Editing the worker afterwards does not change it.'),
  "worker_name": zod.string().describe('Name of the worker'),
  "environment": zod.enum(['live', 'test']).describe('Release channel the run was started for. Test calls run the worker\'s test version; every other trigger runs live.'),
  "status": zod.enum(['pending', 'queued', 'starting', 'in_progress', 'completed', 'failed', 'canceled']).describe('Current run status'),
  "scope": zod.union([zod.record(zod.string(), zod.unknown()),zod.null()]).describe('Run scope metadata (e.g. claim_id, email_id). Null when the run has no artifacts.'),
  "created_at": zod.string().datetime({"offset":true}).describe('ISO 8601 timestamp when the run was created'),
  "started_at": zod.union([zod.string().datetime({"offset":true}),zod.null()]).describe('ISO 8601 timestamp when processing started'),
  "completed_at": zod.union([zod.string().datetime({"offset":true}),zod.null()]).describe('ISO 8601 timestamp when processing finished'),
  "processing_duration_ms": zod.union([zod.number(),zod.null()]).describe('Processing duration in milliseconds'),
  "extract_id": zod.union([zod.string().uuid(),zod.null()]).describe('Optional extract ID, set only if the worker run created an extract.'),
  "error": zod.union([zod.string(),zod.null()]),
  "outcome": zod.union([zod.string(),zod.null()]).describe('Use-case-specific business outcome reported by the worker. Null when the run predates outcome tracking or never executed to completion.'),
  "outcome_reason": zod.union([zod.string(),zod.null()]).describe('Worker-authored explanation of the outcome. May contain case content.')
}),
  "message": zod.string()
})


export const CreateWorkerEvalFromRunParams = zod.object({
  "workerRunId": zod.string().uuid()
})

export const createWorkerEvalFromRunBodyNameMax = 200;



export const createWorkerEvalFromRunBodyToolMocksItemDescriptionDefault = `Mocked tool available during an evaluation.`;

export const createWorkerEvalFromRunBodyGraderCriterionMax = 10000;



export const CreateWorkerEvalFromRunBody = zod.object({
  "name": zod.string().min(1).max(createWorkerEvalFromRunBodyNameMax),
  "tool_mocks": zod.array(zod.object({
  "mcp_type": zod.string().min(1),
  "tool_name": zod.string().min(1),
  "description": zod.string().default(createWorkerEvalFromRunBodyToolMocksItemDescriptionDefault),
  "input_schema": zod.record(zod.string(), zod.unknown()),
  "responses": zod.array(zod.unknown()).min(1)
})).min(1),
  "grader": zod.object({
  "type": zod.literal("prompt"),
  "criterion": zod.string().min(1).max(createWorkerEvalFromRunBodyGraderCriterionMax)
})
})

export const CreateWorkerEvalFromRunResponse = zod.object({
  "data": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "target": zod.object({
  "type": zod.enum(['worker', 'chat_agent', 'voice_agent']),
  "id": zod.string().uuid()
}),
  "source": zod.object({
  "type": zod.enum(['worker_run', 'chat', 'call']),
  "id": zod.string().uuid()
}),
  "fixture": zod.object({
  "version": zod.literal(1),
  "type": zod.literal("worker_run_replay"),
  "scope": zod.union([zod.record(zod.string(), zod.unknown()),zod.null()]),
  "resolved_artifact_ids": zod.array(zod.string().uuid()),
  "trigger_context": zod.union([zod.string(),zod.null()])
}),
  "tool_mocks": zod.array(zod.object({
  "mcp_type": zod.string(),
  "tool_name": zod.string(),
  "description": zod.string(),
  "input_schema": zod.record(zod.string(), zod.unknown()),
  "responses": zod.array(zod.unknown())
})),
  "grader": zod.object({
  "type": zod.literal("prompt"),
  "criterion": zod.string()
}),
  "created_at": zod.string().datetime({"offset":true})
}),
  "message": zod.string()
})


export const RunEvalParams = zod.object({
  "evalId": zod.string().uuid()
})

export const runEvalResponseDataTargetVersionMin = -9007199254740991;
export const runEvalResponseDataTargetVersionMax = 9007199254740991;



export const RunEvalResponse = zod.object({
  "data": zod.object({
  "id": zod.string().uuid(),
  "eval_id": zod.string().uuid(),
  "target_version": zod.number().int().min(runEvalResponseDataTargetVersionMin).max(runEvalResponseDataTargetVersionMax),
  "status": zod.enum(['queued', 'running', 'passed', 'failed', 'error']),
  "passed": zod.union([zod.boolean(),zod.null()]),
  "reason": zod.union([zod.string(),zod.null()]),
  "error": zod.union([zod.string(),zod.null()]),
  "judge_model": zod.union([zod.string(),zod.null()]),
  "judge_prompt_version": zod.union([zod.string(),zod.null()]),
  "created_at": zod.string().datetime({"offset":true}),
  "started_at": zod.union([zod.string().datetime({"offset":true}),zod.null()]),
  "completed_at": zod.union([zod.string().datetime({"offset":true}),zod.null()])
}),
  "message": zod.string()
})


export const GetEvalRunParams = zod.object({
  "evalRunId": zod.string().uuid()
})

export const getEvalRunResponseDataTargetVersionMin = -9007199254740991;
export const getEvalRunResponseDataTargetVersionMax = 9007199254740991;



export const GetEvalRunResponse = zod.object({
  "data": zod.object({
  "id": zod.string().uuid(),
  "eval_id": zod.string().uuid(),
  "target_version": zod.number().int().min(getEvalRunResponseDataTargetVersionMin).max(getEvalRunResponseDataTargetVersionMax),
  "status": zod.enum(['queued', 'running', 'passed', 'failed', 'error']),
  "passed": zod.union([zod.boolean(),zod.null()]),
  "reason": zod.union([zod.string(),zod.null()]),
  "error": zod.union([zod.string(),zod.null()]),
  "judge_model": zod.union([zod.string(),zod.null()]),
  "judge_prompt_version": zod.union([zod.string(),zod.null()]),
  "created_at": zod.string().datetime({"offset":true}),
  "started_at": zod.union([zod.string().datetime({"offset":true}),zod.null()]),
  "completed_at": zod.union([zod.string().datetime({"offset":true}),zod.null()])
}),
  "message": zod.string()
})





export const CreateExtractorBody = zod.object({
  "name": zod.string().min(1),
  "schema": zod.record(zod.string(), zod.unknown())
})

export const CreateExtractorResponse = zod.object({
  "data": zod.object({
  "id": zod.string(),
  "name": zod.string(),
  "version": zod.number(),
  "schema": zod.record(zod.string(), zod.unknown()),
  "created_at": zod.string().datetime({"offset":true})
}),
  "message": zod.string()
})


export const listExtractorsQueryCountDefault = 50;
export const listExtractorsQueryCountMax = 100;

export const listExtractorsQueryOffsetDefault = 0;
export const listExtractorsQueryOffsetMin = 0;

export const listExtractorsQuerySortByDefault = `created_at`;
export const listExtractorsQuerySortOrderDefault = `desc`;

export const ListExtractorsQueryParams = zod.object({
  "count": zod.number().min(1).max(listExtractorsQueryCountMax).default(listExtractorsQueryCountDefault),
  "offset": zod.number().min(listExtractorsQueryOffsetMin).default(listExtractorsQueryOffsetDefault),
  "sort_by": zod.enum(['created_at', 'name', 'version']).default(listExtractorsQuerySortByDefault),
  "sort_order": zod.enum(['asc', 'desc']).default(listExtractorsQuerySortOrderDefault),
  "name": zod.string().optional()
})

export const ListExtractorsResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.string(),
  "name": zod.string(),
  "version": zod.number(),
  "created_at": zod.string().datetime({"offset":true}),
  "updated_at": zod.string().datetime({"offset":true})
})),
  "message": zod.string(),
  "meta": zod.object({
  "total": zod.number()
})
})


export const GetExtractorParams = zod.object({
  "id": zod.string().uuid()
})

export const GetExtractorResponse = zod.object({
  "data": zod.object({
  "data": zod.object({
  "id": zod.string(),
  "name": zod.string(),
  "version": zod.number(),
  "schema": zod.record(zod.string(), zod.unknown()),
  "created_at": zod.string().datetime({"offset":true}),
  "updated_at": zod.string().datetime({"offset":true})
})
}),
  "message": zod.string()
})





export const UpdateExtractorParams = zod.object({
  "id": zod.string().min(1)
})

export const UpdateExtractorBody = zod.object({
  "schema": zod.record(zod.string(), zod.unknown())
})

export const UpdateExtractorResponse = zod.object({
  "data": zod.object({
  "id": zod.string(),
  "name": zod.string(),
  "version": zod.number(),
  "schema": zod.record(zod.string(), zod.unknown()),
  "created_at": zod.string().datetime({"offset":true})
}),
  "message": zod.string()
})


export const DeleteExtractorParams = zod.object({
  "id": zod.string().uuid()
})

export const DeleteExtractorResponse = zod.object({
  "data": zod.object({

}),
  "message": zod.string()
})







export const CreateWorkerBody = zod.object({
  "name": zod.string().min(1),
  "prompt": zod.string().min(1).optional(),
  "instruction_template": zod.string().min(1).optional().describe('Deprecated. Use `prompt` instead.'),
  "mcp_type": zod.union([zod.enum(['ventiv', 'klear', 'klear-browser', 'demo-browser', 'demo-claims', 'filehandler-browser']),zod.null()]).optional()
})

export const createWorkerResponseDataVersionMin = 0;

export const createWorkerResponseDataVersionsLatestMin = -9007199254740991;
export const createWorkerResponseDataVersionsLatestMax = 9007199254740991;

export const createWorkerResponseDataVersionsLiveMin = -9007199254740991;
export const createWorkerResponseDataVersionsLiveMax = 9007199254740991;

export const createWorkerResponseDataVersionsTestMin = -9007199254740991;
export const createWorkerResponseDataVersionsTestMax = 9007199254740991;



export const CreateWorkerResponse = zod.object({
  "data": zod.object({
  "id": zod.string(),
  "name": zod.string(),
  "mcps": zod.array(zod.object({
  "name": zod.enum(['ventiv', 'klear', 'klear-browser', 'demo-browser', 'demo-claims', 'filehandler-browser']).describe('MCP server identifier.')
})).describe('MCP servers the worker connects to.'),
  "mcp_type": zod.union([zod.string(),zod.null()]).describe('Deprecated. Comma-separated MCP server identifiers; use `mcps` instead.'),
  "version": zod.number().min(createWorkerResponseDataVersionMin).describe('Deprecated. Newest config version; use `versions.latest` instead.'),
  "versions": zod.object({
  "latest": zod.number().int().min(createWorkerResponseDataVersionsLatestMin).max(createWorkerResponseDataVersionsLatestMax).describe('Newest config version. The config fields in this response are its snapshot.'),
  "live": zod.number().int().min(createWorkerResponseDataVersionsLiveMin).max(createWorkerResponseDataVersionsLiveMax).describe('Config version the `live` environment resolves to.'),
  "test": zod.number().int().min(createWorkerResponseDataVersionsTestMin).max(createWorkerResponseDataVersionsTestMax).describe('Config version the `test` environment resolves to.')
}),
  "created_at": zod.string().datetime({"offset":true}),
  "updated_at": zod.string().datetime({"offset":true}),
  "schema": zod.record(zod.string(), zod.unknown()),
  "case_determination_context": zod.union([zod.string(),zod.null()]),
  "tool_ids": zod.array(zod.string()),
  "secret_ids": zod.array(zod.string()).describe('Secrets attached to the worker. A worker with attached secrets sources its environment exclusively from the secret store.'),
  "permissions": zod.array(zod.enum(['workers:run', 'inboxes:send', 'artifacts:write', 'outbound-jobs:schedule', 'cases:write', 'schedules:write', 'information-requests:write'])).describe('Core Plane operations the worker\'s runs are authorized to perform. Executing a tool attached to the worker is governed by the attachment, not by this list.'),
  "model": zod.string(),
  "fast_mode": zod.boolean()
}),
  "message": zod.string()
})


export const listWorkersQueryCountDefault = 50;
export const listWorkersQueryCountMax = 100;

export const listWorkersQueryOffsetDefault = 0;
export const listWorkersQueryOffsetMin = 0;

export const listWorkersQuerySortByDefault = `created_at`;
export const listWorkersQuerySortOrderDefault = `desc`;

export const ListWorkersQueryParams = zod.object({
  "name": zod.string().optional(),
  "count": zod.number().min(1).max(listWorkersQueryCountMax).default(listWorkersQueryCountDefault),
  "offset": zod.number().min(listWorkersQueryOffsetMin).default(listWorkersQueryOffsetDefault),
  "sort_by": zod.enum(['created_at', 'name']).default(listWorkersQuerySortByDefault),
  "sort_order": zod.enum(['asc', 'desc']).default(listWorkersQuerySortOrderDefault)
})

export const listWorkersResponseDataItemVersionMin = 0;

export const listWorkersResponseDataItemVersionsLatestMin = -9007199254740991;
export const listWorkersResponseDataItemVersionsLatestMax = 9007199254740991;

export const listWorkersResponseDataItemVersionsLiveMin = -9007199254740991;
export const listWorkersResponseDataItemVersionsLiveMax = 9007199254740991;

export const listWorkersResponseDataItemVersionsTestMin = -9007199254740991;
export const listWorkersResponseDataItemVersionsTestMax = 9007199254740991;



export const ListWorkersResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.string(),
  "name": zod.string(),
  "mcps": zod.array(zod.object({
  "name": zod.enum(['ventiv', 'klear', 'klear-browser', 'demo-browser', 'demo-claims', 'filehandler-browser']).describe('MCP server identifier.')
})).describe('MCP servers the worker connects to.'),
  "mcp_type": zod.union([zod.string(),zod.null()]).describe('Deprecated. Comma-separated MCP server identifiers; use `mcps` instead.'),
  "version": zod.number().min(listWorkersResponseDataItemVersionMin).describe('Deprecated. Newest config version; use `versions.latest` instead.'),
  "versions": zod.object({
  "latest": zod.number().int().min(listWorkersResponseDataItemVersionsLatestMin).max(listWorkersResponseDataItemVersionsLatestMax).describe('Newest config version. The config fields in this response are its snapshot.'),
  "live": zod.number().int().min(listWorkersResponseDataItemVersionsLiveMin).max(listWorkersResponseDataItemVersionsLiveMax).describe('Config version the `live` environment resolves to.'),
  "test": zod.number().int().min(listWorkersResponseDataItemVersionsTestMin).max(listWorkersResponseDataItemVersionsTestMax).describe('Config version the `test` environment resolves to.')
}),
  "created_at": zod.string().datetime({"offset":true}),
  "updated_at": zod.string().datetime({"offset":true})
})),
  "message": zod.string(),
  "meta": zod.object({
  "total": zod.number()
})
})


export const GetWorkerParams = zod.object({
  "workerId": zod.string().uuid()
})

export const getWorkerResponseDataVersionMin = 0;

export const getWorkerResponseDataVersionsLatestMin = -9007199254740991;
export const getWorkerResponseDataVersionsLatestMax = 9007199254740991;

export const getWorkerResponseDataVersionsLiveMin = -9007199254740991;
export const getWorkerResponseDataVersionsLiveMax = 9007199254740991;

export const getWorkerResponseDataVersionsTestMin = -9007199254740991;
export const getWorkerResponseDataVersionsTestMax = 9007199254740991;



export const GetWorkerResponse = zod.object({
  "data": zod.object({
  "id": zod.string(),
  "name": zod.string(),
  "mcps": zod.array(zod.object({
  "name": zod.enum(['ventiv', 'klear', 'klear-browser', 'demo-browser', 'demo-claims', 'filehandler-browser']).describe('MCP server identifier.')
})).describe('MCP servers the worker connects to.'),
  "mcp_type": zod.union([zod.string(),zod.null()]).describe('Deprecated. Comma-separated MCP server identifiers; use `mcps` instead.'),
  "version": zod.number().min(getWorkerResponseDataVersionMin).describe('Deprecated. Newest config version; use `versions.latest` instead.'),
  "versions": zod.object({
  "latest": zod.number().int().min(getWorkerResponseDataVersionsLatestMin).max(getWorkerResponseDataVersionsLatestMax).describe('Newest config version. The config fields in this response are its snapshot.'),
  "live": zod.number().int().min(getWorkerResponseDataVersionsLiveMin).max(getWorkerResponseDataVersionsLiveMax).describe('Config version the `live` environment resolves to.'),
  "test": zod.number().int().min(getWorkerResponseDataVersionsTestMin).max(getWorkerResponseDataVersionsTestMax).describe('Config version the `test` environment resolves to.')
}),
  "created_at": zod.string().datetime({"offset":true}),
  "updated_at": zod.string().datetime({"offset":true}),
  "schema": zod.record(zod.string(), zod.unknown()),
  "case_determination_context": zod.union([zod.string(),zod.null()]),
  "tool_ids": zod.array(zod.string()),
  "secret_ids": zod.array(zod.string()).describe('Secrets attached to the worker. A worker with attached secrets sources its environment exclusively from the secret store.'),
  "permissions": zod.array(zod.enum(['workers:run', 'inboxes:send', 'artifacts:write', 'outbound-jobs:schedule', 'cases:write', 'schedules:write', 'information-requests:write'])).describe('Core Plane operations the worker\'s runs are authorized to perform. Executing a tool attached to the worker is governed by the attachment, not by this list.'),
  "model": zod.string(),
  "fast_mode": zod.boolean()
}),
  "message": zod.string()
})


export const DeleteWorkerParams = zod.object({
  "workerId": zod.string().uuid()
})

export const DeleteWorkerResponse = zod.object({
  "data": zod.object({

}),
  "message": zod.string()
})


export const UpdateWorkerParams = zod.object({
  "workerId": zod.string().uuid()
})






export const UpdateWorkerBody = zod.object({
  "name": zod.string().min(1).optional(),
  "model": zod.string().min(1).optional().describe('LLM model identifier the worker runs on. Omit to leave unchanged.'),
  "fast_mode": zod.boolean().optional().describe('Toggle fast mode for the worker. Omit to leave unchanged.'),
  "schema": zod.record(zod.string(), zod.unknown()).optional(),
  "tools": zod.array(zod.string().uuid()).optional().describe('Replace the worker\'s attached tool set. Omit to leave unchanged; pass [] to clear.'),
  "secrets": zod.array(zod.string().uuid()).optional().describe('Replace the worker\'s attached secret set. Omit to leave unchanged; pass [] to detach all.'),
  "case_determination_context": zod.union([zod.string().min(1),zod.null()]).optional().describe('Customer-specific context appended to the case-ID determination prompt. Omit to leave unchanged; pass null to clear.'),
  "permissions": zod.array(zod.enum(['workers:run', 'inboxes:send', 'artifacts:write', 'outbound-jobs:schedule', 'cases:write', 'schedules:write', 'information-requests:write'])).optional().describe('Permissions granted to the worker on each run')
})

export const updateWorkerResponseDataVersionMin = 0;

export const updateWorkerResponseDataVersionsLatestMin = -9007199254740991;
export const updateWorkerResponseDataVersionsLatestMax = 9007199254740991;

export const updateWorkerResponseDataVersionsLiveMin = -9007199254740991;
export const updateWorkerResponseDataVersionsLiveMax = 9007199254740991;

export const updateWorkerResponseDataVersionsTestMin = -9007199254740991;
export const updateWorkerResponseDataVersionsTestMax = 9007199254740991;



export const UpdateWorkerResponse = zod.object({
  "data": zod.object({
  "id": zod.string(),
  "name": zod.string(),
  "mcps": zod.array(zod.object({
  "name": zod.enum(['ventiv', 'klear', 'klear-browser', 'demo-browser', 'demo-claims', 'filehandler-browser']).describe('MCP server identifier.')
})).describe('MCP servers the worker connects to.'),
  "mcp_type": zod.union([zod.string(),zod.null()]).describe('Deprecated. Comma-separated MCP server identifiers; use `mcps` instead.'),
  "version": zod.number().min(updateWorkerResponseDataVersionMin).describe('Deprecated. Newest config version; use `versions.latest` instead.'),
  "versions": zod.object({
  "latest": zod.number().int().min(updateWorkerResponseDataVersionsLatestMin).max(updateWorkerResponseDataVersionsLatestMax).describe('Newest config version. The config fields in this response are its snapshot.'),
  "live": zod.number().int().min(updateWorkerResponseDataVersionsLiveMin).max(updateWorkerResponseDataVersionsLiveMax).describe('Config version the `live` environment resolves to.'),
  "test": zod.number().int().min(updateWorkerResponseDataVersionsTestMin).max(updateWorkerResponseDataVersionsTestMax).describe('Config version the `test` environment resolves to.')
}),
  "created_at": zod.string().datetime({"offset":true}),
  "updated_at": zod.string().datetime({"offset":true}),
  "schema": zod.record(zod.string(), zod.unknown()),
  "case_determination_context": zod.union([zod.string(),zod.null()]),
  "tool_ids": zod.array(zod.string()),
  "secret_ids": zod.array(zod.string()).describe('Secrets attached to the worker. A worker with attached secrets sources its environment exclusively from the secret store.'),
  "permissions": zod.array(zod.enum(['workers:run', 'inboxes:send', 'artifacts:write', 'outbound-jobs:schedule', 'cases:write', 'schedules:write', 'information-requests:write'])).describe('Core Plane operations the worker\'s runs are authorized to perform. Executing a tool attached to the worker is governed by the attachment, not by this list.'),
  "model": zod.string(),
  "fast_mode": zod.boolean()
}),
  "message": zod.string()
})


export const GetWorkerPromptParams = zod.object({
  "workerId": zod.string().uuid()
})

export const getWorkerPromptQueryVersionMax = 9007199254740991;



export const GetWorkerPromptQueryParams = zod.object({
  "version": zod.number().int().min(1).max(getWorkerPromptQueryVersionMax).optional()
})

export const GetWorkerPromptResponse = zod.object({
  "data": zod.object({
  "prompt": zod.string()
}),
  "message": zod.string()
})


export const UpdateWorkerPromptParams = zod.object({
  "workerId": zod.string().uuid()
})




export const UpdateWorkerPromptBody = zod.object({
  "prompt": zod.string().min(1)
})

export const UpdateWorkerPromptResponse = zod.object({
  "data": zod.object({
  "id": zod.string(),
  "updated_at": zod.string().datetime({"offset":true})
}),
  "message": zod.string()
})


export const ListWorkerModelsResponse = zod.object({
  "data": zod.array(zod.object({
  "slug": zod.string(),
  "name": zod.string()
})),
  "message": zod.string()
})


export const UpdateWorkerMcpsParams = zod.object({
  "workerId": zod.string().uuid()
})

export const UpdateWorkerMcpsBody = zod.object({
  "mcps": zod.array(zod.object({
  "name": zod.enum(['ventiv', 'klear', 'klear-browser', 'demo-browser', 'demo-claims', 'filehandler-browser']).describe('MCP server identifier.')
})).describe('MCP servers the worker connects to, replacing the current set. Pass an empty array to disconnect the worker from all MCP servers.')
})

export const updateWorkerMcpsResponseDataVersionMin = 0;

export const updateWorkerMcpsResponseDataVersionsLatestMin = -9007199254740991;
export const updateWorkerMcpsResponseDataVersionsLatestMax = 9007199254740991;

export const updateWorkerMcpsResponseDataVersionsLiveMin = -9007199254740991;
export const updateWorkerMcpsResponseDataVersionsLiveMax = 9007199254740991;

export const updateWorkerMcpsResponseDataVersionsTestMin = -9007199254740991;
export const updateWorkerMcpsResponseDataVersionsTestMax = 9007199254740991;



export const UpdateWorkerMcpsResponse = zod.object({
  "data": zod.object({
  "id": zod.string(),
  "name": zod.string(),
  "mcps": zod.array(zod.object({
  "name": zod.enum(['ventiv', 'klear', 'klear-browser', 'demo-browser', 'demo-claims', 'filehandler-browser']).describe('MCP server identifier.')
})).describe('MCP servers the worker connects to.'),
  "mcp_type": zod.union([zod.string(),zod.null()]).describe('Deprecated. Comma-separated MCP server identifiers; use `mcps` instead.'),
  "version": zod.number().min(updateWorkerMcpsResponseDataVersionMin).describe('Deprecated. Newest config version; use `versions.latest` instead.'),
  "versions": zod.object({
  "latest": zod.number().int().min(updateWorkerMcpsResponseDataVersionsLatestMin).max(updateWorkerMcpsResponseDataVersionsLatestMax).describe('Newest config version. The config fields in this response are its snapshot.'),
  "live": zod.number().int().min(updateWorkerMcpsResponseDataVersionsLiveMin).max(updateWorkerMcpsResponseDataVersionsLiveMax).describe('Config version the `live` environment resolves to.'),
  "test": zod.number().int().min(updateWorkerMcpsResponseDataVersionsTestMin).max(updateWorkerMcpsResponseDataVersionsTestMax).describe('Config version the `test` environment resolves to.')
}),
  "created_at": zod.string().datetime({"offset":true}),
  "updated_at": zod.string().datetime({"offset":true}),
  "schema": zod.record(zod.string(), zod.unknown()),
  "case_determination_context": zod.union([zod.string(),zod.null()]),
  "tool_ids": zod.array(zod.string()),
  "secret_ids": zod.array(zod.string()).describe('Secrets attached to the worker. A worker with attached secrets sources its environment exclusively from the secret store.'),
  "permissions": zod.array(zod.enum(['workers:run', 'inboxes:send', 'artifacts:write', 'outbound-jobs:schedule', 'cases:write', 'schedules:write', 'information-requests:write'])).describe('Core Plane operations the worker\'s runs are authorized to perform. Executing a tool attached to the worker is governed by the attachment, not by this list.'),
  "model": zod.string(),
  "fast_mode": zod.boolean()
}),
  "message": zod.string()
})


export const ListWorkerVersionsParams = zod.object({
  "workerId": zod.string().uuid()
})

export const listWorkerVersionsQueryCountDefault = 50;
export const listWorkerVersionsQueryCountMax = 100;

export const listWorkerVersionsQueryOffsetDefault = 0;
export const listWorkerVersionsQueryOffsetMin = 0;

export const listWorkerVersionsQuerySortByDefault = `version`;
export const listWorkerVersionsQuerySortOrderDefault = `desc`;

export const ListWorkerVersionsQueryParams = zod.object({
  "count": zod.number().min(1).max(listWorkerVersionsQueryCountMax).default(listWorkerVersionsQueryCountDefault),
  "offset": zod.number().min(listWorkerVersionsQueryOffsetMin).default(listWorkerVersionsQueryOffsetDefault),
  "sort_by": zod.enum(['version', 'created_at']).default(listWorkerVersionsQuerySortByDefault),
  "sort_order": zod.enum(['asc', 'desc']).default(listWorkerVersionsQuerySortOrderDefault)
})

export const listWorkerVersionsResponseDataItemVersionMin = -9007199254740991;
export const listWorkerVersionsResponseDataItemVersionMax = 9007199254740991;

export const listWorkerVersionsResponseMetaTotalMin = -9007199254740991;
export const listWorkerVersionsResponseMetaTotalMax = 9007199254740991;



export const ListWorkerVersionsResponse = zod.object({
  "data": zod.array(zod.object({
  "worker_id": zod.string(),
  "version": zod.number().int().min(listWorkerVersionsResponseDataItemVersionMin).max(listWorkerVersionsResponseDataItemVersionMax),
  "actor": zod.string(),
  "created_at": zod.string().datetime({"offset":true}),
  "changed_fields": zod.array(zod.string())
})),
  "message": zod.string(),
  "meta": zod.object({
  "total": zod.number().int().min(listWorkerVersionsResponseMetaTotalMin).max(listWorkerVersionsResponseMetaTotalMax)
})
})


export const getWorkerVersionPathVersionMax = 9007199254740991;



export const GetWorkerVersionParams = zod.object({
  "workerId": zod.string().uuid(),
  "version": zod.number().int().min(1).max(getWorkerVersionPathVersionMax)
})

export const getWorkerVersionResponseDataVersionMin = -9007199254740991;
export const getWorkerVersionResponseDataVersionMax = 9007199254740991;



export const GetWorkerVersionResponse = zod.object({
  "data": zod.object({
  "id": zod.string(),
  "name": zod.string(),
  "created_at": zod.string().datetime({"offset":true}),
  "updated_at": zod.string().datetime({"offset":true}),
  "mcps": zod.array(zod.object({
  "name": zod.enum(['ventiv', 'klear', 'klear-browser', 'demo-browser', 'demo-claims', 'filehandler-browser']).describe('MCP server identifier.')
})),
  "schema": zod.record(zod.string(), zod.unknown()),
  "case_determination_context": zod.union([zod.string(),zod.null()]),
  "permissions": zod.array(zod.enum(['workers:run', 'inboxes:send', 'artifacts:write', 'outbound-jobs:schedule', 'cases:write', 'schedules:write', 'information-requests:write'])),
  "model": zod.string(),
  "fast_mode": zod.boolean(),
  "tool_ids": zod.array(zod.string()),
  "secret_ids": zod.array(zod.string()),
  "version": zod.number().int().min(getWorkerVersionResponseDataVersionMin).max(getWorkerVersionResponseDataVersionMax),
  "version_created_at": zod.string().datetime({"offset":true}),
  "actor": zod.string(),
  "changed_fields": zod.array(zod.string())
}),
  "message": zod.string()
})


export const promoteWorkerVersionPathVersionMax = 9007199254740991;



export const PromoteWorkerVersionParams = zod.object({
  "workerId": zod.string().uuid(),
  "version": zod.number().int().min(1).max(promoteWorkerVersionPathVersionMax)
})

export const PromoteWorkerVersionBody = zod.object({
  "environment": zod.enum(['live', 'test'])
})

export const promoteWorkerVersionResponseDataVersionMin = -9007199254740991;
export const promoteWorkerVersionResponseDataVersionMax = 9007199254740991;



export const PromoteWorkerVersionResponse = zod.object({
  "data": zod.object({
  "version": zod.number().int().min(promoteWorkerVersionResponseDataVersionMin).max(promoteWorkerVersionResponseDataVersionMax),
  "environment": zod.enum(['live', 'test'])
}),
  "message": zod.string()
})


export const getWorkerVersionChangeSummaryPathVersionMax = 9007199254740991;



export const GetWorkerVersionChangeSummaryParams = zod.object({
  "workerId": zod.string().uuid(),
  "version": zod.number().int().min(1).max(getWorkerVersionChangeSummaryPathVersionMax)
})

export const GetWorkerVersionChangeSummaryResponse = zod.object({
  "data": zod.object({
  "summary": zod.string()
}),
  "message": zod.string()
})





export const CreateWorkerWebhookParams = zod.object({
  "workerId": zod.string().min(1)
})

export const createWorkerWebhookBodyNameMax = 256;

export const createWorkerWebhookBodyUrlMax = 2048;


export const createWorkerWebhookBodyAuthHeaderNameOneMax = 256;

export const createWorkerWebhookBodyAuthHeaderValueOneMax = 2048;



export const CreateWorkerWebhookBody = zod.object({
  "name": zod.string().min(1).max(createWorkerWebhookBodyNameMax),
  "url": zod.string().url().max(createWorkerWebhookBodyUrlMax),
  "environments": zod.array(zod.enum(['live', 'test'])).min(1).default([`live`]),
  "auth_header_name": zod.union([zod.string().max(createWorkerWebhookBodyAuthHeaderNameOneMax),zod.null()]).optional(),
  "auth_header_value": zod.union([zod.string().max(createWorkerWebhookBodyAuthHeaderValueOneMax),zod.null()]).optional(),
  "enabled": zod.boolean().optional()
})

export const CreateWorkerWebhookResponse = zod.object({
  "data": zod.object({
  "id": zod.string(),
  "scope": zod.union([zod.object({
  "extractor_id": zod.string()
}),zod.object({
  "call_agent_id": zod.string()
}),zod.object({
  "inbox_id": zod.string()
}),zod.object({
  "worker_id": zod.string()
}),zod.object({
  "notifications": zod.literal(true)
}).describe('The organization\'s notification feed, not a resource')]),
  "name": zod.string(),
  "url": zod.string(),
  "auth_header_name": zod.union([zod.string(),zod.null()]),
  "has_auth": zod.boolean(),
  "enabled": zod.boolean(),
  "environments": zod.array(zod.enum(['live', 'test'])),
  "created_at": zod.string().datetime({"offset":true}),
  "updated_at": zod.string().datetime({"offset":true})
}),
  "message": zod.string()
})





export const ListWorkerWebhooksParams = zod.object({
  "workerId": zod.string().min(1)
})

export const ListWorkerWebhooksQueryParams = zod.object({
  "environment": zod.enum(['live', 'test']).optional().describe('Only return webhooks that receive events from this environment. Webhooks configured for both environments match either value.')
})

export const ListWorkerWebhooksResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.string(),
  "scope": zod.union([zod.object({
  "extractor_id": zod.string()
}),zod.object({
  "call_agent_id": zod.string()
}),zod.object({
  "inbox_id": zod.string()
}),zod.object({
  "worker_id": zod.string()
}),zod.object({
  "notifications": zod.literal(true)
}).describe('The organization\'s notification feed, not a resource')]),
  "name": zod.string(),
  "url": zod.string(),
  "auth_header_name": zod.union([zod.string(),zod.null()]),
  "has_auth": zod.boolean(),
  "enabled": zod.boolean(),
  "environments": zod.array(zod.enum(['live', 'test'])),
  "created_at": zod.string().datetime({"offset":true}),
  "updated_at": zod.string().datetime({"offset":true})
})),
  "message": zod.string()
})





export const listCasesQueryCountDefault = 50;
export const listCasesQueryCountMax = 100;

export const listCasesQueryOffsetDefault = 0;
export const listCasesQueryOffsetMin = 0;

export const listCasesQuerySortByDefault = `created_at`;
export const listCasesQuerySortOrderDefault = `desc`;

export const ListCasesQueryParams = zod.object({
  "environment": zod.enum(['live', 'test']).optional().describe('Filter by environment. Omit to list cases in both.'),
  "id": zod.string().min(1).optional().describe('Filter by exact case id. Values are normalized server-side (trimmed and lowercased) to match how case ids are stored.'),
  "subject": zod.string().min(1).optional().describe('Filter by case subject. Case-insensitive substring match against the case subject.'),
  "reporter": zod.string().min(1).optional().describe('Filter by reporter. Case-insensitive substring match against the case reporter.'),
  "created_by": zod.string().optional().describe('Filter by the actor that created the case: "worker:<workerId>" or "user:<profileId>".'),
  "count": zod.number().min(1).max(listCasesQueryCountMax).default(listCasesQueryCountDefault),
  "offset": zod.number().min(listCasesQueryOffsetMin).default(listCasesQueryOffsetDefault),
  "sort_by": zod.enum(['created_at', 'updated_at']).default(listCasesQuerySortByDefault),
  "sort_order": zod.enum(['asc', 'desc']).default(listCasesQuerySortOrderDefault)
})

export const ListCasesResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.string(),
  "environment": zod.enum(['live', 'test']),
  "subject": zod.union([zod.string(),zod.null()]),
  "reporter": zod.union([zod.string(),zod.null()]),
  "created_by": zod.string().describe('Actor that created the case, e.g. "worker:<workerId>" or "user:<profileId>".'),
  "created_at": zod.string().datetime({"offset":true}),
  "updated_at": zod.string().datetime({"offset":true})
})),
  "message": zod.string(),
  "meta": zod.object({
  "total": zod.number()
})
})







export const CreateCaseBody = zod.object({
  "id": zod.string().min(1).describe('Case id, e.g. a claim number. Normalized server-side (trimmed and lowercased) to match how case ids are stored.'),
  "environment": zod.enum(['live', 'test']).optional(),
  "subject": zod.union([zod.string().min(1),zod.null()]).optional().describe('Short description of what the case is about.'),
  "reporter": zod.union([zod.string().min(1),zod.null()]).optional().describe('Name of the person or organization that reported the case.')
})

export const CreateCaseResponse = zod.object({
  "data": zod.object({
  "case": zod.object({
  "id": zod.string(),
  "environment": zod.enum(['live', 'test']),
  "subject": zod.union([zod.string(),zod.null()]),
  "reporter": zod.union([zod.string(),zod.null()]),
  "created_by": zod.string().describe('Actor that created the case, e.g. "worker:<workerId>" or "user:<profileId>".'),
  "created_at": zod.string().datetime({"offset":true}),
  "updated_at": zod.string().datetime({"offset":true})
})
}),
  "message": zod.string()
})



export const searchCasesQueryCountDefault = 20;
export const searchCasesQueryCountMax = 50;

export const searchCasesQueryOffsetDefault = 0;
export const searchCasesQueryOffsetMin = 0;



export const SearchCasesQueryParams = zod.object({
  "q": zod.string().min(1).describe('Free-text probe. Matched as a normalized substring against the case id, and fuzzily (trigram) against subject and reporter. Id matches rank first.'),
  "count": zod.number().min(1).max(searchCasesQueryCountMax).default(searchCasesQueryCountDefault),
  "offset": zod.number().min(searchCasesQueryOffsetMin).default(searchCasesQueryOffsetDefault)
})

export const SearchCasesResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.string(),
  "environment": zod.enum(['live', 'test']),
  "subject": zod.union([zod.string(),zod.null()]),
  "reporter": zod.union([zod.string(),zod.null()]),
  "created_by": zod.string().describe('Actor that created the case, e.g. "worker:<workerId>" or "user:<profileId>".'),
  "created_at": zod.string().datetime({"offset":true}),
  "updated_at": zod.string().datetime({"offset":true})
})),
  "message": zod.string(),
  "meta": zod.object({
  "total": zod.number()
})
})





export const GetCaseParams = zod.object({
  "id": zod.string().min(1)
})

export const GetCaseQueryParams = zod.object({
  "environment": zod.enum(['live', 'test']).optional().describe('Environment the case belongs to. A case reference is unique per environment, so the same reference can name a different case in each. Defaults to `live`. A worker run may omit this or pass its own run\'s environment; any other value is rejected.')
})

export const GetCaseResponse = zod.object({
  "data": zod.object({
  "case": zod.object({
  "id": zod.string(),
  "environment": zod.enum(['live', 'test']),
  "subject": zod.union([zod.string(),zod.null()]),
  "reporter": zod.union([zod.string(),zod.null()]),
  "created_by": zod.string().describe('Actor that created the case, e.g. "worker:<workerId>" or "user:<profileId>".'),
  "created_at": zod.string().datetime({"offset":true}),
  "updated_at": zod.string().datetime({"offset":true})
})
}),
  "message": zod.string()
})





export const AddCaseLinksParams = zod.object({
  "id": zod.string().min(1)
})

export const AddCaseLinksQueryParams = zod.object({
  "environment": zod.enum(['live', 'test']).optional().describe('Environment the case belongs to. A case reference is unique per environment, so the same reference can name a different case in each. Defaults to `live`. A worker run may omit this or pass its own run\'s environment; any other value is rejected.')
})

export const addCaseLinksBodyEntitiesMax = 100;



export const AddCaseLinksBody = zod.object({
  "entities": zod.array(zod.object({
  "entity_type": zod.enum(['artifact', 'call', 'chat', 'email', 'extract', 'information_request', 'schedule', 'worker_run']),
  "entity_id": zod.string().uuid()
})).min(1).max(addCaseLinksBodyEntitiesMax)
})

export const AddCaseLinksResponse = zod.object({
  "data": zod.object({
  "links": zod.array(zod.object({
  "case_id": zod.string(),
  "entity_type": zod.enum(['artifact', 'call', 'chat', 'email', 'extract', 'information_request', 'schedule', 'worker_run']),
  "entity_id": zod.string().uuid(),
  "created_at": zod.string().datetime({"offset":true})
}))
}),
  "message": zod.string()
})





export const ListCaseLinksParams = zod.object({
  "id": zod.string().min(1)
})

export const listCaseLinksQueryCountDefault = 50;
export const listCaseLinksQueryCountMax = 100;

export const listCaseLinksQueryOffsetDefault = 0;
export const listCaseLinksQueryOffsetMin = 0;

export const listCaseLinksQuerySortByDefault = `created_at`;
export const listCaseLinksQuerySortOrderDefault = `desc`;

export const ListCaseLinksQueryParams = zod.object({
  "environment": zod.enum(['live', 'test']).optional().describe('Environment the case belongs to. A case reference is unique per environment, so the same reference can name a different case in each. Defaults to `live`. A worker run may omit this or pass its own run\'s environment; any other value is rejected.'),
  "entity_type": zod.enum(['artifact', 'call', 'chat', 'email', 'extract', 'information_request', 'schedule', 'worker_run']).optional().describe('Filter links by entity type.'),
  "count": zod.number().min(1).max(listCaseLinksQueryCountMax).default(listCaseLinksQueryCountDefault),
  "offset": zod.number().min(listCaseLinksQueryOffsetMin).default(listCaseLinksQueryOffsetDefault),
  "sort_by": zod.enum(['created_at']).default(listCaseLinksQuerySortByDefault),
  "sort_order": zod.enum(['asc', 'desc']).default(listCaseLinksQuerySortOrderDefault)
})

export const ListCaseLinksResponse = zod.object({
  "data": zod.array(zod.object({
  "case_id": zod.string(),
  "entity_type": zod.enum(['artifact', 'call', 'chat', 'email', 'extract', 'information_request', 'schedule', 'worker_run']),
  "entity_id": zod.string().uuid(),
  "created_at": zod.string().datetime({"offset":true})
})),
  "message": zod.string(),
  "meta": zod.object({
  "total": zod.number()
})
})





export const RemoveCaseLinkParams = zod.object({
  "id": zod.string().min(1),
  "entityType": zod.enum(['artifact', 'call', 'chat', 'email', 'extract', 'information_request', 'schedule', 'worker_run']),
  "entityId": zod.string().uuid()
})

export const RemoveCaseLinkQueryParams = zod.object({
  "environment": zod.enum(['live', 'test']).optional().describe('Environment the case belongs to. A case reference is unique per environment, so the same reference can name a different case in each. Defaults to `live`. A worker run may omit this or pass its own run\'s environment; any other value is rejected.')
})

export const RemoveCaseLinkResponse = zod.object({
  "data": zod.object({

}),
  "message": zod.string()
})







export const CreateChatAgentBody = zod.object({
  "name": zod.string().min(1),
  "prompt": zod.string().min(1),
  "greeting": zod.string().min(1).optional()
})

export const CreateChatAgentResponse = zod.object({
  "data": zod.object({
  "chat_agent_id": zod.string(),
  "created_at": zod.string().datetime({"offset":true})
}),
  "message": zod.string()
})


export const listChatAgentsQueryCountDefault = 50;
export const listChatAgentsQueryCountMax = 100;

export const listChatAgentsQueryOffsetDefault = 0;
export const listChatAgentsQueryOffsetMin = 0;

export const listChatAgentsQuerySortByDefault = `created_at`;
export const listChatAgentsQuerySortOrderDefault = `desc`;

export const ListChatAgentsQueryParams = zod.object({
  "count": zod.number().min(1).max(listChatAgentsQueryCountMax).default(listChatAgentsQueryCountDefault),
  "offset": zod.number().min(listChatAgentsQueryOffsetMin).default(listChatAgentsQueryOffsetDefault),
  "sort_by": zod.enum(['created_at', 'name']).default(listChatAgentsQuerySortByDefault),
  "sort_order": zod.enum(['asc', 'desc']).default(listChatAgentsQuerySortOrderDefault)
})

export const ListChatAgentsResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.string(),
  "name": zod.string(),
  "created_at": zod.string().datetime({"offset":true}),
  "updated_at": zod.string().datetime({"offset":true})
})),
  "message": zod.string(),
  "meta": zod.object({
  "total": zod.number()
})
})


export const GetChatAgentParams = zod.object({
  "chatAgentId": zod.string().uuid()
})

export const GetChatAgentResponse = zod.object({
  "data": zod.object({
  "id": zod.string(),
  "name": zod.string(),
  "created_at": zod.string().datetime({"offset":true}),
  "updated_at": zod.string().datetime({"offset":true}),
  "tool_ids": zod.array(zod.string())
}),
  "message": zod.string()
})


export const UpdateChatAgentParams = zod.object({
  "chatAgentId": zod.string().uuid()
})

export const UpdateChatAgentBody = zod.object({
  "tools": zod.array(zod.string().uuid()).optional().describe('Replace the agent\'s attached code tool set. Omit to leave unchanged; pass [] to clear.')
})

export const UpdateChatAgentResponse = zod.object({
  "data": zod.object({
  "id": zod.string(),
  "name": zod.string(),
  "created_at": zod.string().datetime({"offset":true}),
  "updated_at": zod.string().datetime({"offset":true})
}),
  "message": zod.string()
})


export const DeleteChatAgentParams = zod.object({
  "chatAgentId": zod.string().uuid()
})

export const DeleteChatAgentResponse = zod.object({
  "data": zod.object({

}),
  "message": zod.string()
})


export const GetChatAgentPromptParams = zod.object({
  "chatAgentId": zod.string().uuid()
})

export const GetChatAgentPromptResponse = zod.object({
  "data": zod.object({
  "prompt": zod.string(),
  "greeting": zod.string()
}),
  "message": zod.string()
})


export const UpdateChatAgentPromptParams = zod.object({
  "chatAgentId": zod.string().uuid()
})





export const UpdateChatAgentPromptBody = zod.object({
  "prompt": zod.string().min(1).optional(),
  "greeting": zod.string().min(1).optional()
})

export const UpdateChatAgentPromptResponse = zod.object({
  "data": zod.object({
  "id": zod.string(),
  "updated_at": zod.string().datetime({"offset":true})
}),
  "message": zod.string()
})


export const CreateChatBody = zod.object({
  "chat_agent_id": zod.string().uuid()
})

export const CreateChatResponse = zod.object({
  "data": zod.object({
  "id": zod.string().uuid(),
  "created_at": zod.string().datetime({"offset":true}),
  "chat_token": zod.string(),
  "chat_token_expires_in": zod.number()
}),
  "message": zod.string()
})


export const GetChatParams = zod.object({
  "chatId": zod.string().uuid()
})

export const GetChatResponse = zod.object({
  "data": zod.object({
  "id": zod.string().uuid(),
  "chat_agent_id": zod.string().uuid(),
  "created_at": zod.string().datetime({"offset":true}),
  "messages": zod.array(zod.object({
  "id": zod.string().uuid(),
  "role": zod.enum(['user', 'assistant']),
  "content": zod.string(),
  "generated_at": zod.string().datetime({"offset":true})
}))
}),
  "message": zod.string()
})


export const GetPublicChatAgentParams = zod.object({
  "chatAgentId": zod.string().uuid()
})

export const GetPublicChatAgentResponse = zod.object({
  "data": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "greeting": zod.string()
}),
  "message": zod.string()
})


export const PostChatMessageParams = zod.object({
  "chatId": zod.string().uuid()
})

export const postChatMessageBodyContentMax = 32000;



export const PostChatMessageBody = zod.object({
  "content": zod.string().min(1).max(postChatMessageBodyContentMax)
})

export const PostChatMessageResponse = zod.object({
  "data": zod.object({
  "message": zod.object({
  "id": zod.string().uuid(),
  "role": zod.literal("assistant"),
  "content": zod.array(zod.object({
  "type": zod.string()
})),
  "generated_at": zod.string().datetime({"offset":true})
})
}),
  "message": zod.string()
})



export const listChatsQueryCountDefault = 50;
export const listChatsQueryCountMax = 100;

export const listChatsQueryOffsetDefault = 0;
export const listChatsQueryOffsetMin = 0;

export const listChatsQuerySortByDefault = `created_at`;
export const listChatsQuerySortOrderDefault = `desc`;

export const ListChatsQueryParams = zod.object({
  "case_id": zod.string().min(1).optional().describe('Only chats linked to this case. Values are normalized server-side (trimmed and lowercased).'),
  "environment": zod.enum(['live', 'test']).optional(),
  "count": zod.number().min(1).max(listChatsQueryCountMax).default(listChatsQueryCountDefault),
  "offset": zod.number().min(listChatsQueryOffsetMin).default(listChatsQueryOffsetDefault),
  "sort_by": zod.enum(['created_at']).default(listChatsQuerySortByDefault),
  "sort_order": zod.enum(['asc', 'desc']).default(listChatsQuerySortOrderDefault)
})

export const listChatsResponseDataItemMessageCountMin = 0;
export const listChatsResponseDataItemMessageCountMax = 9007199254740991;



export const ListChatsResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.string().uuid(),
  "chat_agent_id": zod.string().uuid(),
  "created_at": zod.string().datetime({"offset":true}),
  "message_count": zod.number().int().min(listChatsResponseDataItemMessageCountMin).max(listChatsResponseDataItemMessageCountMax)
})),
  "message": zod.string(),
  "meta": zod.object({
  "total": zod.number()
})
})


export const ListChatMessagesParams = zod.object({
  "chatId": zod.string().uuid()
})

export const listChatMessagesQueryCountDefault = 50;
export const listChatMessagesQueryCountMax = 100;

export const listChatMessagesQueryOffsetDefault = 0;
export const listChatMessagesQueryOffsetMin = 0;

export const listChatMessagesQuerySortByDefault = `generated_at`;
export const listChatMessagesQuerySortOrderDefault = `asc`;

export const ListChatMessagesQueryParams = zod.object({
  "count": zod.number().min(1).max(listChatMessagesQueryCountMax).default(listChatMessagesQueryCountDefault),
  "offset": zod.number().min(listChatMessagesQueryOffsetMin).default(listChatMessagesQueryOffsetDefault),
  "sort_by": zod.enum(['generated_at']).default(listChatMessagesQuerySortByDefault),
  "sort_order": zod.enum(['asc', 'desc']).default(listChatMessagesQuerySortOrderDefault)
})

export const ListChatMessagesResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.string().uuid(),
  "role": zod.enum(['user', 'assistant', 'tool', 'system']),
  "content": zod.array(zod.object({
  "type": zod.string()
})).describe('Message parts (text, tool-call, tool-result, etc.). Each part has a `type` discriminator.'),
  "generated_at": zod.string().datetime({"offset":true})
})),
  "message": zod.string(),
  "meta": zod.object({
  "total": zod.number()
})
})


export const GetExtractParams = zod.object({
  "id": zod.string().uuid()
})

export const GetExtractResponse = zod.object({
  "data": zod.object({
  "id": zod.string(),
  "processor_type": zod.string(),
  "processor_id": zod.string(),
  "processor_version": zod.number(),
  "processor_name": zod.string(),
  "processor_scope": zod.record(zod.string(), zod.unknown()),
  "extractor_job_id": zod.union([zod.string(),zod.null()]),
  "worker_run_id": zod.union([zod.string(),zod.null()]),
  "result": zod.unknown(),
  "citations": zod.union([zod.unknown(),zod.null()]),
  "created_at": zod.string().datetime({"offset":true})
}),
  "message": zod.string()
})


export const GetExtractCitationsParams = zod.object({
  "id": zod.string().uuid()
})

export const GetExtractCitationsResponse = zod.object({
  "data": zod.object({
  "citations": zod.unknown(),
  "chunks": zod.record(zod.string(), zod.object({
  "artifact_id": zod.string(),
  "artifact_name": zod.string(),
  "page": zod.union([zod.number(),zod.null()]),
  "bounding_box": zod.union([zod.object({
  "left": zod.number(),
  "top": zod.number(),
  "width": zod.number(),
  "height": zod.number()
}),zod.null()]),
  "content": zod.string()
}))
}),
  "message": zod.string()
})


export const listExtractsQueryCountDefault = 50;
export const listExtractsQueryCountMax = 100;

export const listExtractsQueryOffsetDefault = 0;
export const listExtractsQueryOffsetMin = 0;

export const listExtractsQuerySortByDefault = `created_at`;
export const listExtractsQuerySortOrderDefault = `desc`;


export const ListExtractsQueryParams = zod.object({
  "count": zod.number().min(1).max(listExtractsQueryCountMax).default(listExtractsQueryCountDefault),
  "offset": zod.number().min(listExtractsQueryOffsetMin).default(listExtractsQueryOffsetDefault),
  "sort_by": zod.enum(['created_at']).default(listExtractsQuerySortByDefault),
  "sort_order": zod.enum(['asc', 'desc']).default(listExtractsQuerySortOrderDefault),
  "extractor_job_id": zod.string().uuid().optional(),
  "extractor_id": zod.string().uuid().optional(),
  "worker_run_id": zod.string().uuid().optional(),
  "worker_id": zod.string().uuid().optional(),
  "case_id": zod.string().min(1).optional().describe('Filter extracts linked to a specific case. Values are normalized server-side (trimmed and lowercased).'),
  "environment": zod.enum(['live', 'test']).optional(),
  "created_after": zod.string().optional(),
  "created_before": zod.string().optional(),
  "scope": zod.record(zod.string(), zod.string()).optional().describe('Filter by scope keys using bracket notation (e.g. scope[claim_id]=abc-123). Multiple filters are combined with AND logic.')
})

export const ListExtractsResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.string(),
  "extractor_job_id": zod.union([zod.string(),zod.null()]),
  "worker_run_id": zod.union([zod.string(),zod.null()]),
  "processor_type": zod.string(),
  "processor_id": zod.string(),
  "processor_version": zod.number(),
  "processor_name": zod.string(),
  "processor_scope": zod.record(zod.string(), zod.unknown()),
  "result": zod.unknown(),
  "citations": zod.union([zod.unknown(),zod.null()]),
  "created_at": zod.string().datetime({"offset":true})
})),
  "message": zod.string(),
  "meta": zod.object({
  "total": zod.number()
})
})


export const GetProfileResponse = zod.object({
  "data": zod.object({
  "id": zod.string(),
  "first_name": zod.union([zod.string(),zod.null()]),
  "last_name": zod.union([zod.string(),zod.null()]),
  "email": zod.string(),
  "role": zod.enum(['admin', 'avallon_admin', 'member']),
  "permissions": zod.array(zod.enum(['voice-agents:write', 'voice-agents:promote', 'tools:write', 'tools:execute', 'tools:promote', 'extractors:write', 'inboxes:write', 'inboxes:send', 'artifacts:write', 'api-keys:write', 'teams:write', 'cases:write', 'information-requests:write', 'information-requests:resolve', 'feedback:write', 'outbound-jobs:write', 'outbound-jobs:schedule', 'workers:write', 'workers:execute', 'workers:write-mcp', 'workers:run', 'workers:promote', 'chat-agents:write', 'notifications:write', 'prompts:read', 'prompts:write', 'secrets:read', 'secrets:write', 'schedules:read', 'schedules:write'])),
  "tenants": zod.object({
  "active": zod.object({
  "id": zod.string(),
  "name": zod.string()
}),
  "available": zod.array(zod.object({
  "id": zod.string(),
  "name": zod.string()
}))
})
}),
  "message": zod.string()
})


export const ListTeamMembersResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.string(),
  "first_name": zod.union([zod.string(),zod.null()]),
  "last_name": zod.union([zod.string(),zod.null()]),
  "email": zod.string(),
  "role": zod.enum(['admin', 'avallon_admin', 'member']),
  "created_at": zod.string(),
  "updated_at": zod.string()
})),
  "message": zod.string()
})


export const InviteTeamMemberBody = zod.object({
  "email": zod.string().email()
})

export const InviteTeamMemberResponse = zod.object({
  "data": zod.object({
  "id": zod.string().describe('Unique identifier for the invitation'),
  "email": zod.string(),
  "state": zod.enum(['pending', 'accepted', 'expired', 'revoked']),
  "expires_at": zod.string().datetime({"offset":true}).describe('When the invitation stops being redeemable'),
  "created_at": zod.string().datetime({"offset":true}).describe('Creation timestamp')
}),
  "message": zod.string()
})


export const ListTeamInvitationsResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.string().describe('Unique identifier for the invitation'),
  "email": zod.string(),
  "state": zod.enum(['pending', 'accepted', 'expired', 'revoked']),
  "expires_at": zod.string().datetime({"offset":true}).describe('When the invitation stops being redeemable'),
  "created_at": zod.string().datetime({"offset":true}).describe('Creation timestamp')
})),
  "message": zod.string()
})





export const RevokeTeamInvitationParams = zod.object({
  "invitationId": zod.string().min(1)
})

export const RevokeTeamInvitationResponse = zod.void()





export const ResendTeamInvitationParams = zod.object({
  "invitationId": zod.string().min(1)
})

export const ResendTeamInvitationResponse = zod.object({
  "data": zod.object({
  "id": zod.string().describe('Unique identifier for the invitation'),
  "email": zod.string(),
  "state": zod.enum(['pending', 'accepted', 'expired', 'revoked']),
  "expires_at": zod.string().datetime({"offset":true}).describe('When the invitation stops being redeemable'),
  "created_at": zod.string().datetime({"offset":true}).describe('Creation timestamp')
}),
  "message": zod.string()
})


export const UpdateMemberRoleParams = zod.object({
  "id": zod.string().uuid()
})

export const UpdateMemberRoleBody = zod.object({
  "role": zod.enum(['admin', 'member'])
})

export const UpdateMemberRoleResponse = zod.object({
  "data": zod.object({
  "id": zod.string(),
  "first_name": zod.union([zod.string(),zod.null()]),
  "last_name": zod.union([zod.string(),zod.null()]),
  "email": zod.string(),
  "role": zod.enum(['admin', 'avallon_admin', 'member']),
  "created_at": zod.string(),
  "updated_at": zod.string()
}),
  "message": zod.string()
})


export const RemoveMemberParams = zod.object({
  "id": zod.string().uuid()
})

export const RemoveMemberResponse = zod.void()


export const createSecretBodyNameMax = 100;

export const createSecretBodyEnvKeyMax = 128;


export const createSecretBodyEnvKeyRegExp = new RegExp('^[A-Z][A-Z0-9_]*$');
export const createSecretBodyValueMax = 4096;

export const createSecretBodyTestValueMax = 4096;

export const createSecretBodyDescriptionMax = 500;



export const CreateSecretBody = zod.object({
  "name": zod.string().min(1).max(createSecretBodyNameMax).describe('Human-readable display name, unique per organization (e.g. "Klear prod login")'),
  "env_key": zod.string().max(createSecretBodyEnvKeyMax).regex(createSecretBodyEnvKeyRegExp).describe('Environment variable key consumers of the secret will receive the value under (e.g. KLEAR_PASSWORD). Immutable after creation; multiple secrets may share an env key.'),
  "value": zod.string().min(1).max(createSecretBodyValueMax).describe('The secret value. Write-only: it is never returned again.'),
  "test_value": zod.string().min(1).max(createSecretBodyTestValueMax).optional().describe('The value test runs receive under the same env key. Write-only. Omit and test runs receive nothing for this secret.'),
  "description": zod.string().max(createSecretBodyDescriptionMax).optional()
})

export const CreateSecretResponse = zod.object({
  "data": zod.object({
  "id": zod.string().describe('Unique identifier for the secret'),
  "name": zod.string().describe('Human-readable display name, unique per organization'),
  "env_key": zod.string().describe('Environment variable key under which consumers of the secret receive the value. Immutable.'),
  "description": zod.union([zod.string(),zod.null()]).describe('Optional description'),
  "has_test_value": zod.boolean().describe('Whether a test value is set. Test runs receive nothing for this secret until it is.'),
  "created_at": zod.string().datetime({"offset":true}).describe('Creation timestamp'),
  "updated_at": zod.string().datetime({"offset":true}).describe('Last update timestamp (metadata or rotation)')
}),
  "message": zod.string()
})


export const listSecretsQueryCountDefault = 50;
export const listSecretsQueryCountMax = 100;

export const listSecretsQueryOffsetDefault = 0;
export const listSecretsQueryOffsetMin = 0;

export const listSecretsQuerySortByDefault = `name`;
export const listSecretsQuerySortOrderDefault = `asc`;

export const ListSecretsQueryParams = zod.object({
  "count": zod.number().min(1).max(listSecretsQueryCountMax).default(listSecretsQueryCountDefault),
  "offset": zod.number().min(listSecretsQueryOffsetMin).default(listSecretsQueryOffsetDefault),
  "sort_by": zod.enum(['name', 'created_at']).default(listSecretsQuerySortByDefault),
  "sort_order": zod.enum(['asc', 'desc']).default(listSecretsQuerySortOrderDefault)
})

export const ListSecretsResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.string().describe('Unique identifier for the secret'),
  "name": zod.string().describe('Human-readable display name, unique per organization'),
  "env_key": zod.string().describe('Environment variable key under which consumers of the secret receive the value. Immutable.'),
  "description": zod.union([zod.string(),zod.null()]).describe('Optional description'),
  "has_test_value": zod.boolean().describe('Whether a test value is set. Test runs receive nothing for this secret until it is.'),
  "created_at": zod.string().datetime({"offset":true}).describe('Creation timestamp'),
  "updated_at": zod.string().datetime({"offset":true}).describe('Last update timestamp (metadata or rotation)')
})),
  "message": zod.string(),
  "meta": zod.object({
  "total": zod.number()
})
})


export const GetSecretParams = zod.object({
  "secretId": zod.string().uuid()
})

export const GetSecretResponse = zod.object({
  "data": zod.object({
  "id": zod.string().describe('Unique identifier for the secret'),
  "name": zod.string().describe('Human-readable display name, unique per organization'),
  "env_key": zod.string().describe('Environment variable key under which consumers of the secret receive the value. Immutable.'),
  "description": zod.union([zod.string(),zod.null()]).describe('Optional description'),
  "has_test_value": zod.boolean().describe('Whether a test value is set. Test runs receive nothing for this secret until it is.'),
  "created_at": zod.string().datetime({"offset":true}).describe('Creation timestamp'),
  "updated_at": zod.string().datetime({"offset":true}).describe('Last update timestamp (metadata or rotation)')
}),
  "message": zod.string()
})


export const UpdateSecretParams = zod.object({
  "secretId": zod.string().uuid()
})

export const updateSecretBodyNameMax = 100;

export const updateSecretBodyValueMax = 4096;

export const updateSecretBodyTestValueOneMax = 4096;

export const updateSecretBodyDescriptionOneMax = 500;



export const UpdateSecretBody = zod.object({
  "name": zod.string().min(1).max(updateSecretBodyNameMax).optional().describe('New display name. Omit to leave unchanged.'),
  "value": zod.string().min(1).max(updateSecretBodyValueMax).optional().describe('New secret value (rotation). The previous value is overwritten and not retrievable. Omit to leave unchanged.'),
  "test_value": zod.union([zod.string().min(1).max(updateSecretBodyTestValueOneMax),zod.null()]).optional().describe('New value for test runs (rotation). Omit to leave unchanged; pass null to remove it so test runs receive nothing for this secret.'),
  "description": zod.union([zod.string().max(updateSecretBodyDescriptionOneMax),zod.null()]).optional().describe('New description. Omit to leave unchanged; pass null to clear.')
})

export const UpdateSecretResponse = zod.object({
  "data": zod.object({
  "id": zod.string().describe('Unique identifier for the secret'),
  "name": zod.string().describe('Human-readable display name, unique per organization'),
  "env_key": zod.string().describe('Environment variable key under which consumers of the secret receive the value. Immutable.'),
  "description": zod.union([zod.string(),zod.null()]).describe('Optional description'),
  "has_test_value": zod.boolean().describe('Whether a test value is set. Test runs receive nothing for this secret until it is.'),
  "created_at": zod.string().datetime({"offset":true}).describe('Creation timestamp'),
  "updated_at": zod.string().datetime({"offset":true}).describe('Last update timestamp (metadata or rotation)')
}),
  "message": zod.string()
})


export const DeleteSecretParams = zod.object({
  "secretId": zod.string().uuid()
})

export const DeleteSecretResponse = zod.object({
  "data": zod.object({

}),
  "message": zod.string()
})


export const createScheduleBodyRuleTwoPatternsItemMinuteMin = 0;
export const createScheduleBodyRuleTwoPatternsItemMinuteMax = 59;

export const createScheduleBodyRuleTwoPatternsItemHoursOneItemMin = 0;
export const createScheduleBodyRuleTwoPatternsItemHoursOneItemMax = 23;

export const createScheduleBodyRuleTwoPatternsItemHoursOneMax = 24;

export const createScheduleBodyRuleTwoPatternsItemHoursDefault = null;
export const createScheduleBodyRuleTwoPatternsItemWeekdaysOneItemMax = 7;

export const createScheduleBodyRuleTwoPatternsItemWeekdaysOneMax = 7;

export const createScheduleBodyRuleTwoPatternsItemWeekdaysDefault = null;
export const createScheduleBodyRuleTwoPatternsMax = 10;

export const createScheduleBodyNameMax = 200;



export const CreateScheduleBody = zod.object({
  "action": zod.object({
  "type": zod.literal("trigger_worker"),
  "worker_id": zod.string().uuid(),
  "scope": zod.union([zod.record(zod.string(), zod.union([zod.string(),zod.number(),zod.boolean(),zod.null()])),zod.null()]).optional().describe('Scope of the runs this schedule creates. Omit or send null to run without artifacts.')
}).describe('What the schedule does every time it fires'),
  "rule": zod.union([zod.object({
  "type": zod.literal("once"),
  "at": zod.string().datetime({"offset":true}).describe('The moment it fires, in UTC, e.g. "2026-09-01T14:00:00Z"')
}),zod.object({
  "type": zod.literal("recurring"),
  "timezone": zod.string().describe('IANA time zone identifier, e.g. "America/Chicago"'),
  "patterns": zod.array(zod.object({
  "minute": zod.number().int().min(createScheduleBodyRuleTwoPatternsItemMinuteMin).max(createScheduleBodyRuleTwoPatternsItemMinuteMax).describe('Minute, 0-59'),
  "hours": zod.union([zod.array(zod.number().int().min(createScheduleBodyRuleTwoPatternsItemHoursOneItemMin).max(createScheduleBodyRuleTwoPatternsItemHoursOneItemMax).describe('Hour, 0-23')).min(1).max(createScheduleBodyRuleTwoPatternsItemHoursOneMax),zod.null()]).default(createScheduleBodyRuleTwoPatternsItemHoursDefault).describe('Local hours the pattern may fire in. Omit or send null to fire every hour.'),
  "weekdays": zod.union([zod.array(zod.number().int().min(1).max(createScheduleBodyRuleTwoPatternsItemWeekdaysOneItemMax).describe('ISO-8601 weekday, 1 = Monday through 7 = Sunday')).min(1).max(createScheduleBodyRuleTwoPatternsItemWeekdaysOneMax),zod.null()]).default(createScheduleBodyRuleTwoPatternsItemWeekdaysDefault).describe('Local ISO-8601 weekdays the pattern may fire on. Omit or send null to fire every day.')
}).describe('One set of local times a schedule fires at')).min(1).max(createScheduleBodyRuleTwoPatternsMax).describe('The schedule fires whenever any of these patterns comes round, all read in the rule\'s time zone.')
})]).describe('When the schedule fires'),
  "environments": zod.array(zod.enum(['live', 'test'])).optional().describe('Environments the schedule fires in. `live` resolves the worker at its live version, `test` at its test version. Listing both fires every occurrence twice, once per version.'),
  "name": zod.string().min(1).max(createScheduleBodyNameMax).optional().describe('Human-readable name, e.g. "Nightly claim sweep"'),
  "enabled": zod.boolean().optional().describe('Whether the schedule starts firing right away. Defaults to true. Must be omitted or true for `once` rules.')
})

export const createScheduleResponseDataRuleTwoPatternsItemMinuteMin = 0;
export const createScheduleResponseDataRuleTwoPatternsItemMinuteMax = 59;

export const createScheduleResponseDataRuleTwoPatternsItemHoursOneItemMin = 0;
export const createScheduleResponseDataRuleTwoPatternsItemHoursOneItemMax = 23;

export const createScheduleResponseDataRuleTwoPatternsItemHoursOneMax = 24;

export const createScheduleResponseDataRuleTwoPatternsItemHoursDefault = null;
export const createScheduleResponseDataRuleTwoPatternsItemWeekdaysOneItemMax = 7;

export const createScheduleResponseDataRuleTwoPatternsItemWeekdaysOneMax = 7;

export const createScheduleResponseDataRuleTwoPatternsItemWeekdaysDefault = null;
export const createScheduleResponseDataRuleTwoPatternsMax = 10;



export const CreateScheduleResponse = zod.object({
  "data": zod.object({
  "id": zod.string().describe('Unique identifier for the schedule'),
  "name": zod.union([zod.string(),zod.null()]).describe('Optional human-readable name'),
  "action": zod.object({
  "type": zod.literal("trigger_worker"),
  "worker_id": zod.string().uuid(),
  "scope": zod.union([zod.record(zod.string(), zod.union([zod.string(),zod.number(),zod.boolean(),zod.null()])),zod.null()]).optional().describe('Scope of the runs this schedule creates. Omit or send null to run without artifacts.')
}).describe('What the schedule does every time it fires'),
  "rule": zod.union([zod.object({
  "type": zod.literal("once"),
  "at": zod.string().datetime({"offset":true}).describe('The moment it fires, in UTC, e.g. "2026-09-01T14:00:00Z"')
}),zod.object({
  "type": zod.literal("recurring"),
  "timezone": zod.string().describe('IANA time zone identifier, e.g. "America/Chicago"'),
  "patterns": zod.array(zod.object({
  "minute": zod.number().int().min(createScheduleResponseDataRuleTwoPatternsItemMinuteMin).max(createScheduleResponseDataRuleTwoPatternsItemMinuteMax).describe('Minute, 0-59'),
  "hours": zod.union([zod.array(zod.number().int().min(createScheduleResponseDataRuleTwoPatternsItemHoursOneItemMin).max(createScheduleResponseDataRuleTwoPatternsItemHoursOneItemMax).describe('Hour, 0-23')).min(1).max(createScheduleResponseDataRuleTwoPatternsItemHoursOneMax),zod.null()]).default(createScheduleResponseDataRuleTwoPatternsItemHoursDefault).describe('Local hours the pattern may fire in. Omit or send null to fire every hour.'),
  "weekdays": zod.union([zod.array(zod.number().int().min(1).max(createScheduleResponseDataRuleTwoPatternsItemWeekdaysOneItemMax).describe('ISO-8601 weekday, 1 = Monday through 7 = Sunday')).min(1).max(createScheduleResponseDataRuleTwoPatternsItemWeekdaysOneMax),zod.null()]).default(createScheduleResponseDataRuleTwoPatternsItemWeekdaysDefault).describe('Local ISO-8601 weekdays the pattern may fire on. Omit or send null to fire every day.')
}).describe('One set of local times a schedule fires at')).min(1).max(createScheduleResponseDataRuleTwoPatternsMax).describe('The schedule fires whenever any of these patterns comes round, all read in the rule\'s time zone.')
})]).describe('When the schedule fires'),
  "environments": zod.array(zod.enum(['live', 'test'])).describe('Environments the schedule fires in'),
  "enabled": zod.boolean().describe('Whether the schedule currently fires. Disabled never fires.'),
  "next_run_at": zod.union([zod.string().datetime({"offset":true}),zod.null()]).describe('When the schedule fires next, in UTC. Null while disabled, or once a one-off has fired.'),
  "created_by": zod.string().describe('Actor that created the schedule'),
  "created_at": zod.string().datetime({"offset":true}).describe('Creation timestamp'),
  "updated_at": zod.string().datetime({"offset":true}).describe('Last update timestamp')
}),
  "message": zod.string()
})



export const listSchedulesQueryCountDefault = 50;
export const listSchedulesQueryCountMax = 100;

export const listSchedulesQueryOffsetDefault = 0;
export const listSchedulesQueryOffsetMin = 0;

export const listSchedulesQuerySortByDefault = `created_at`;
export const listSchedulesQuerySortOrderDefault = `asc`;

export const ListSchedulesQueryParams = zod.object({
  "worker_id": zod.string().uuid().optional().describe('Only schedules that trigger this worker'),
  "rule_type": zod.enum(['once', 'recurring']).optional().describe('Only schedules whose rule is of this type'),
  "environment": zod.enum(['live', 'test']).optional().describe('Only schedules that run in this environment. A schedule that runs in both matches either value.'),
  "case_id": zod.string().min(1).optional().describe('Only schedules linked to this case. Values are normalized server-side (trimmed and lowercased).'),
  "count": zod.number().min(1).max(listSchedulesQueryCountMax).default(listSchedulesQueryCountDefault),
  "offset": zod.number().min(listSchedulesQueryOffsetMin).default(listSchedulesQueryOffsetDefault),
  "sort_by": zod.enum(['created_at', 'next_run_at']).default(listSchedulesQuerySortByDefault),
  "sort_order": zod.enum(['asc', 'desc']).default(listSchedulesQuerySortOrderDefault)
})

export const listSchedulesResponseDataItemRuleTwoPatternsItemMinuteMin = 0;
export const listSchedulesResponseDataItemRuleTwoPatternsItemMinuteMax = 59;

export const listSchedulesResponseDataItemRuleTwoPatternsItemHoursOneItemMin = 0;
export const listSchedulesResponseDataItemRuleTwoPatternsItemHoursOneItemMax = 23;

export const listSchedulesResponseDataItemRuleTwoPatternsItemHoursOneMax = 24;

export const listSchedulesResponseDataItemRuleTwoPatternsItemHoursDefault = null;
export const listSchedulesResponseDataItemRuleTwoPatternsItemWeekdaysOneItemMax = 7;

export const listSchedulesResponseDataItemRuleTwoPatternsItemWeekdaysOneMax = 7;

export const listSchedulesResponseDataItemRuleTwoPatternsItemWeekdaysDefault = null;
export const listSchedulesResponseDataItemRuleTwoPatternsMax = 10;



export const ListSchedulesResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.string().describe('Unique identifier for the schedule'),
  "name": zod.union([zod.string(),zod.null()]).describe('Optional human-readable name'),
  "action": zod.object({
  "type": zod.literal("trigger_worker"),
  "worker_id": zod.string().uuid(),
  "scope": zod.union([zod.record(zod.string(), zod.union([zod.string(),zod.number(),zod.boolean(),zod.null()])),zod.null()]).optional().describe('Scope of the runs this schedule creates. Omit or send null to run without artifacts.')
}).describe('What the schedule does every time it fires'),
  "rule": zod.union([zod.object({
  "type": zod.literal("once"),
  "at": zod.string().datetime({"offset":true}).describe('The moment it fires, in UTC, e.g. "2026-09-01T14:00:00Z"')
}),zod.object({
  "type": zod.literal("recurring"),
  "timezone": zod.string().describe('IANA time zone identifier, e.g. "America/Chicago"'),
  "patterns": zod.array(zod.object({
  "minute": zod.number().int().min(listSchedulesResponseDataItemRuleTwoPatternsItemMinuteMin).max(listSchedulesResponseDataItemRuleTwoPatternsItemMinuteMax).describe('Minute, 0-59'),
  "hours": zod.union([zod.array(zod.number().int().min(listSchedulesResponseDataItemRuleTwoPatternsItemHoursOneItemMin).max(listSchedulesResponseDataItemRuleTwoPatternsItemHoursOneItemMax).describe('Hour, 0-23')).min(1).max(listSchedulesResponseDataItemRuleTwoPatternsItemHoursOneMax),zod.null()]).default(listSchedulesResponseDataItemRuleTwoPatternsItemHoursDefault).describe('Local hours the pattern may fire in. Omit or send null to fire every hour.'),
  "weekdays": zod.union([zod.array(zod.number().int().min(1).max(listSchedulesResponseDataItemRuleTwoPatternsItemWeekdaysOneItemMax).describe('ISO-8601 weekday, 1 = Monday through 7 = Sunday')).min(1).max(listSchedulesResponseDataItemRuleTwoPatternsItemWeekdaysOneMax),zod.null()]).default(listSchedulesResponseDataItemRuleTwoPatternsItemWeekdaysDefault).describe('Local ISO-8601 weekdays the pattern may fire on. Omit or send null to fire every day.')
}).describe('One set of local times a schedule fires at')).min(1).max(listSchedulesResponseDataItemRuleTwoPatternsMax).describe('The schedule fires whenever any of these patterns comes round, all read in the rule\'s time zone.')
})]).describe('When the schedule fires'),
  "environments": zod.array(zod.enum(['live', 'test'])).describe('Environments the schedule fires in'),
  "enabled": zod.boolean().describe('Whether the schedule currently fires. Disabled never fires.'),
  "next_run_at": zod.union([zod.string().datetime({"offset":true}),zod.null()]).describe('When the schedule fires next, in UTC. Null while disabled, or once a one-off has fired.'),
  "created_by": zod.string().describe('Actor that created the schedule'),
  "created_at": zod.string().datetime({"offset":true}).describe('Creation timestamp'),
  "updated_at": zod.string().datetime({"offset":true}).describe('Last update timestamp')
})),
  "message": zod.string(),
  "meta": zod.object({
  "total": zod.number()
})
})


export const GetScheduleParams = zod.object({
  "scheduleId": zod.string().uuid()
})

export const getScheduleResponseDataRuleTwoPatternsItemMinuteMin = 0;
export const getScheduleResponseDataRuleTwoPatternsItemMinuteMax = 59;

export const getScheduleResponseDataRuleTwoPatternsItemHoursOneItemMin = 0;
export const getScheduleResponseDataRuleTwoPatternsItemHoursOneItemMax = 23;

export const getScheduleResponseDataRuleTwoPatternsItemHoursOneMax = 24;

export const getScheduleResponseDataRuleTwoPatternsItemHoursDefault = null;
export const getScheduleResponseDataRuleTwoPatternsItemWeekdaysOneItemMax = 7;

export const getScheduleResponseDataRuleTwoPatternsItemWeekdaysOneMax = 7;

export const getScheduleResponseDataRuleTwoPatternsItemWeekdaysDefault = null;
export const getScheduleResponseDataRuleTwoPatternsMax = 10;



export const GetScheduleResponse = zod.object({
  "data": zod.object({
  "id": zod.string().describe('Unique identifier for the schedule'),
  "name": zod.union([zod.string(),zod.null()]).describe('Optional human-readable name'),
  "action": zod.object({
  "type": zod.literal("trigger_worker"),
  "worker_id": zod.string().uuid(),
  "scope": zod.union([zod.record(zod.string(), zod.union([zod.string(),zod.number(),zod.boolean(),zod.null()])),zod.null()]).optional().describe('Scope of the runs this schedule creates. Omit or send null to run without artifacts.')
}).describe('What the schedule does every time it fires'),
  "rule": zod.union([zod.object({
  "type": zod.literal("once"),
  "at": zod.string().datetime({"offset":true}).describe('The moment it fires, in UTC, e.g. "2026-09-01T14:00:00Z"')
}),zod.object({
  "type": zod.literal("recurring"),
  "timezone": zod.string().describe('IANA time zone identifier, e.g. "America/Chicago"'),
  "patterns": zod.array(zod.object({
  "minute": zod.number().int().min(getScheduleResponseDataRuleTwoPatternsItemMinuteMin).max(getScheduleResponseDataRuleTwoPatternsItemMinuteMax).describe('Minute, 0-59'),
  "hours": zod.union([zod.array(zod.number().int().min(getScheduleResponseDataRuleTwoPatternsItemHoursOneItemMin).max(getScheduleResponseDataRuleTwoPatternsItemHoursOneItemMax).describe('Hour, 0-23')).min(1).max(getScheduleResponseDataRuleTwoPatternsItemHoursOneMax),zod.null()]).default(getScheduleResponseDataRuleTwoPatternsItemHoursDefault).describe('Local hours the pattern may fire in. Omit or send null to fire every hour.'),
  "weekdays": zod.union([zod.array(zod.number().int().min(1).max(getScheduleResponseDataRuleTwoPatternsItemWeekdaysOneItemMax).describe('ISO-8601 weekday, 1 = Monday through 7 = Sunday')).min(1).max(getScheduleResponseDataRuleTwoPatternsItemWeekdaysOneMax),zod.null()]).default(getScheduleResponseDataRuleTwoPatternsItemWeekdaysDefault).describe('Local ISO-8601 weekdays the pattern may fire on. Omit or send null to fire every day.')
}).describe('One set of local times a schedule fires at')).min(1).max(getScheduleResponseDataRuleTwoPatternsMax).describe('The schedule fires whenever any of these patterns comes round, all read in the rule\'s time zone.')
})]).describe('When the schedule fires'),
  "environments": zod.array(zod.enum(['live', 'test'])).describe('Environments the schedule fires in'),
  "enabled": zod.boolean().describe('Whether the schedule currently fires. Disabled never fires.'),
  "next_run_at": zod.union([zod.string().datetime({"offset":true}),zod.null()]).describe('When the schedule fires next, in UTC. Null while disabled, or once a one-off has fired.'),
  "created_by": zod.string().describe('Actor that created the schedule'),
  "created_at": zod.string().datetime({"offset":true}).describe('Creation timestamp'),
  "updated_at": zod.string().datetime({"offset":true}).describe('Last update timestamp')
}),
  "message": zod.string()
})


export const UpdateScheduleParams = zod.object({
  "scheduleId": zod.string().uuid()
})

export const updateScheduleBodyRuleTwoPatternsItemMinuteMin = 0;
export const updateScheduleBodyRuleTwoPatternsItemMinuteMax = 59;

export const updateScheduleBodyRuleTwoPatternsItemHoursOneItemMin = 0;
export const updateScheduleBodyRuleTwoPatternsItemHoursOneItemMax = 23;

export const updateScheduleBodyRuleTwoPatternsItemHoursOneMax = 24;

export const updateScheduleBodyRuleTwoPatternsItemHoursDefault = null;
export const updateScheduleBodyRuleTwoPatternsItemWeekdaysOneItemMax = 7;

export const updateScheduleBodyRuleTwoPatternsItemWeekdaysOneMax = 7;

export const updateScheduleBodyRuleTwoPatternsItemWeekdaysDefault = null;
export const updateScheduleBodyRuleTwoPatternsMax = 10;

export const updateScheduleBodyNameOneMax = 200;



export const UpdateScheduleBody = zod.object({
  "rule": zod.union([zod.object({
  "type": zod.literal("once"),
  "at": zod.string().datetime({"offset":true}).describe('The moment it fires, in UTC, e.g. "2026-09-01T14:00:00Z"')
}),zod.object({
  "type": zod.literal("recurring"),
  "timezone": zod.string().describe('IANA time zone identifier, e.g. "America/Chicago"'),
  "patterns": zod.array(zod.object({
  "minute": zod.number().int().min(updateScheduleBodyRuleTwoPatternsItemMinuteMin).max(updateScheduleBodyRuleTwoPatternsItemMinuteMax).describe('Minute, 0-59'),
  "hours": zod.union([zod.array(zod.number().int().min(updateScheduleBodyRuleTwoPatternsItemHoursOneItemMin).max(updateScheduleBodyRuleTwoPatternsItemHoursOneItemMax).describe('Hour, 0-23')).min(1).max(updateScheduleBodyRuleTwoPatternsItemHoursOneMax),zod.null()]).default(updateScheduleBodyRuleTwoPatternsItemHoursDefault).describe('Local hours the pattern may fire in. Omit or send null to fire every hour.'),
  "weekdays": zod.union([zod.array(zod.number().int().min(1).max(updateScheduleBodyRuleTwoPatternsItemWeekdaysOneItemMax).describe('ISO-8601 weekday, 1 = Monday through 7 = Sunday')).min(1).max(updateScheduleBodyRuleTwoPatternsItemWeekdaysOneMax),zod.null()]).default(updateScheduleBodyRuleTwoPatternsItemWeekdaysDefault).describe('Local ISO-8601 weekdays the pattern may fire on. Omit or send null to fire every day.')
}).describe('One set of local times a schedule fires at')).min(1).max(updateScheduleBodyRuleTwoPatternsMax).describe('The schedule fires whenever any of these patterns comes round, all read in the rule\'s time zone.')
})]).optional().describe('When the schedule fires'),
  "environments": zod.array(zod.enum(['live', 'test'])).optional().describe('Environments the schedule fires in. `live` resolves the worker at its live version, `test` at its test version. Listing both fires every occurrence twice, once per version.'),
  "name": zod.union([zod.string().min(1).max(updateScheduleBodyNameOneMax),zod.null()]).optional().describe('Human-readable name. Send null to clear it.'),
  "enabled": zod.boolean().optional().describe('Whether the schedule fires. Disabled never fires. Must be omitted or true for `once` rules.')
})

export const updateScheduleResponseDataRuleTwoPatternsItemMinuteMin = 0;
export const updateScheduleResponseDataRuleTwoPatternsItemMinuteMax = 59;

export const updateScheduleResponseDataRuleTwoPatternsItemHoursOneItemMin = 0;
export const updateScheduleResponseDataRuleTwoPatternsItemHoursOneItemMax = 23;

export const updateScheduleResponseDataRuleTwoPatternsItemHoursOneMax = 24;

export const updateScheduleResponseDataRuleTwoPatternsItemHoursDefault = null;
export const updateScheduleResponseDataRuleTwoPatternsItemWeekdaysOneItemMax = 7;

export const updateScheduleResponseDataRuleTwoPatternsItemWeekdaysOneMax = 7;

export const updateScheduleResponseDataRuleTwoPatternsItemWeekdaysDefault = null;
export const updateScheduleResponseDataRuleTwoPatternsMax = 10;



export const UpdateScheduleResponse = zod.object({
  "data": zod.object({
  "id": zod.string().describe('Unique identifier for the schedule'),
  "name": zod.union([zod.string(),zod.null()]).describe('Optional human-readable name'),
  "action": zod.object({
  "type": zod.literal("trigger_worker"),
  "worker_id": zod.string().uuid(),
  "scope": zod.union([zod.record(zod.string(), zod.union([zod.string(),zod.number(),zod.boolean(),zod.null()])),zod.null()]).optional().describe('Scope of the runs this schedule creates. Omit or send null to run without artifacts.')
}).describe('What the schedule does every time it fires'),
  "rule": zod.union([zod.object({
  "type": zod.literal("once"),
  "at": zod.string().datetime({"offset":true}).describe('The moment it fires, in UTC, e.g. "2026-09-01T14:00:00Z"')
}),zod.object({
  "type": zod.literal("recurring"),
  "timezone": zod.string().describe('IANA time zone identifier, e.g. "America/Chicago"'),
  "patterns": zod.array(zod.object({
  "minute": zod.number().int().min(updateScheduleResponseDataRuleTwoPatternsItemMinuteMin).max(updateScheduleResponseDataRuleTwoPatternsItemMinuteMax).describe('Minute, 0-59'),
  "hours": zod.union([zod.array(zod.number().int().min(updateScheduleResponseDataRuleTwoPatternsItemHoursOneItemMin).max(updateScheduleResponseDataRuleTwoPatternsItemHoursOneItemMax).describe('Hour, 0-23')).min(1).max(updateScheduleResponseDataRuleTwoPatternsItemHoursOneMax),zod.null()]).default(updateScheduleResponseDataRuleTwoPatternsItemHoursDefault).describe('Local hours the pattern may fire in. Omit or send null to fire every hour.'),
  "weekdays": zod.union([zod.array(zod.number().int().min(1).max(updateScheduleResponseDataRuleTwoPatternsItemWeekdaysOneItemMax).describe('ISO-8601 weekday, 1 = Monday through 7 = Sunday')).min(1).max(updateScheduleResponseDataRuleTwoPatternsItemWeekdaysOneMax),zod.null()]).default(updateScheduleResponseDataRuleTwoPatternsItemWeekdaysDefault).describe('Local ISO-8601 weekdays the pattern may fire on. Omit or send null to fire every day.')
}).describe('One set of local times a schedule fires at')).min(1).max(updateScheduleResponseDataRuleTwoPatternsMax).describe('The schedule fires whenever any of these patterns comes round, all read in the rule\'s time zone.')
})]).describe('When the schedule fires'),
  "environments": zod.array(zod.enum(['live', 'test'])).describe('Environments the schedule fires in'),
  "enabled": zod.boolean().describe('Whether the schedule currently fires. Disabled never fires.'),
  "next_run_at": zod.union([zod.string().datetime({"offset":true}),zod.null()]).describe('When the schedule fires next, in UTC. Null while disabled, or once a one-off has fired.'),
  "created_by": zod.string().describe('Actor that created the schedule'),
  "created_at": zod.string().datetime({"offset":true}).describe('Creation timestamp'),
  "updated_at": zod.string().datetime({"offset":true}).describe('Last update timestamp')
}),
  "message": zod.string()
})


export const DeleteScheduleParams = zod.object({
  "scheduleId": zod.string().uuid()
})

export const DeleteScheduleResponse = zod.object({
  "data": zod.object({

}),
  "message": zod.string()
})


export const listDispatchesQueryCountDefault = 50;
export const listDispatchesQueryCountMax = 100;

export const listDispatchesQueryOffsetDefault = 0;
export const listDispatchesQueryOffsetMin = 0;

export const listDispatchesQuerySortByDefault = `due_at`;
export const listDispatchesQuerySortOrderDefault = `desc`;

export const ListDispatchesQueryParams = zod.object({
  "trigger_type": zod.enum(['schedule', 'email', 'information_request']).optional().describe('Only dispatches produced by this kind of trigger'),
  "trigger_id": zod.string().uuid().optional().describe('Only dispatches produced by this trigger. Requires `trigger_type`.'),
  "count": zod.number().min(1).max(listDispatchesQueryCountMax).default(listDispatchesQueryCountDefault),
  "offset": zod.number().min(listDispatchesQueryOffsetMin).default(listDispatchesQueryOffsetDefault),
  "sort_by": zod.enum(['due_at']).default(listDispatchesQuerySortByDefault),
  "sort_order": zod.enum(['asc', 'desc']).default(listDispatchesQuerySortOrderDefault)
})

export const listDispatchesResponseDataItemAttemptsMin = -9007199254740991;
export const listDispatchesResponseDataItemAttemptsMax = 9007199254740991;



export const ListDispatchesResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.string(),
  "trigger": zod.object({
  "type": zod.enum(['schedule', 'email', 'information_request']),
  "id": zod.string()
}),
  "target": zod.union([zod.object({
  "type": zod.enum(['worker_run', 'extractor_job']),
  "id": zod.string()
}),zod.null()]),
  "due_at": zod.string().datetime({"offset":true}),
  "expires_at": zod.string().datetime({"offset":true}),
  "environment": zod.enum(['live', 'test']),
  "status": zod.enum(['pending', 'dispatched', 'abandoned']),
  "attempts": zod.number().int().min(listDispatchesResponseDataItemAttemptsMin).max(listDispatchesResponseDataItemAttemptsMax)
})),
  "message": zod.string(),
  "meta": zod.object({
  "total": zod.number()
})
})


export const listNotificationsQueryCountDefault = 50;
export const listNotificationsQueryCountMax = 100;

export const listNotificationsQueryOffsetDefault = 0;
export const listNotificationsQueryOffsetMin = 0;

export const listNotificationsQuerySortByDefault = `created_at`;
export const listNotificationsQuerySortOrderDefault = `desc`;

export const ListNotificationsQueryParams = zod.object({
  "count": zod.number().min(1).max(listNotificationsQueryCountMax).default(listNotificationsQueryCountDefault),
  "offset": zod.number().min(listNotificationsQueryOffsetMin).default(listNotificationsQueryOffsetDefault),
  "sort_by": zod.enum(['created_at']).default(listNotificationsQuerySortByDefault),
  "sort_order": zod.enum(['asc', 'desc']).default(listNotificationsQuerySortOrderDefault)
})

export const ListNotificationsResponse = zod.object({
  "data": zod.array(zod.union([zod.object({
  "id": zod.string(),
  "title": zod.string().describe('Headline to display'),
  "body": zod.string().describe('Body text to display'),
  "created_by": zod.string().describe('Actor that raised the notification'),
  "created_at": zod.string().datetime({"offset":true}),
  "type": zod.literal("worker_issue_reported"),
  "data": zod.object({
  "worker_id": zod.string(),
  "run_id": zod.string()
}).describe('The worker and run that reported the issue')
}),zod.object({
  "id": zod.string(),
  "title": zod.string().describe('Headline to display'),
  "body": zod.string().describe('Body text to display'),
  "created_by": zod.string().describe('Actor that raised the notification'),
  "created_at": zod.string().datetime({"offset":true}),
  "type": zod.literal("information_request_created"),
  "data": zod.object({
  "request_id": zod.string()
}).describe('The information request waiting to be answered')
})])),
  "message": zod.string(),
  "meta": zod.object({
  "total": zod.number()
})
})


export const createInformationRequestBodyTitleMax = 120;

export const createInformationRequestBodyQuestionMax = 2000;



export const CreateInformationRequestBody = zod.object({
  "title": zod.string().min(1).max(createInformationRequestBodyTitleMax).describe('A short label for the question, so somebody scanning a queue of open requests can tell yours apart. Name what it is about, not what you need — no trailing punctuation.'),
  "question": zod.string().min(1).max(createInformationRequestBodyQuestionMax).describe('The single fact you need, as one question. Write it for a person who is not watching this run: say what you were doing, what you could not determine, and what would let you continue.'),
  "metadata": zod.record(zod.string(), zod.unknown()).optional().describe('Context to store alongside the question, for whoever picks it up.')
})

export const CreateInformationRequestResponse = zod.object({
  "data": zod.object({
  "id": zod.string(),
  "title": zod.string().describe('Short label the asker gave the question'),
  "question": zod.string().describe('What the asker needs to know'),
  "resolution": zod.union([zod.string(),zod.null()]).describe('Null while the request is open'),
  "resolved_by": zod.union([zod.string().describe('Actor string, e.g. "worker:<workerId>" or "user:<profileId>".'),zod.null()]),
  "resolved_at": zod.union([zod.string().datetime({"offset":true}),zod.null()]),
  "metadata": zod.record(zod.string(), zod.unknown()),
  "environment": zod.enum(['live', 'test']),
  "created_by": zod.string().describe('Actor that raised the request'),
  "created_at": zod.string().datetime({"offset":true})
}),
  "message": zod.string()
})



export const listInformationRequestsQueryCountDefault = 50;
export const listInformationRequestsQueryCountMax = 100;

export const listInformationRequestsQueryOffsetDefault = 0;
export const listInformationRequestsQueryOffsetMin = 0;

export const listInformationRequestsQuerySortByDefault = `created_at`;
export const listInformationRequestsQuerySortOrderDefault = `desc`;

export const ListInformationRequestsQueryParams = zod.object({
  "resolved": zod.enum(['true', 'false']).optional().describe('Only resolved (`true`) or only open (`false`) requests. Omit for both.'),
  "case_id": zod.string().min(1).optional().describe('Only requests linked to this case. Values are normalized server-side (trimmed and lowercased).'),
  "environment": zod.enum(['live', 'test']).optional(),
  "count": zod.number().min(1).max(listInformationRequestsQueryCountMax).default(listInformationRequestsQueryCountDefault),
  "offset": zod.number().min(listInformationRequestsQueryOffsetMin).default(listInformationRequestsQueryOffsetDefault),
  "sort_by": zod.enum(['created_at']).default(listInformationRequestsQuerySortByDefault),
  "sort_order": zod.enum(['asc', 'desc']).default(listInformationRequestsQuerySortOrderDefault)
})

export const ListInformationRequestsResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.string(),
  "title": zod.string().describe('Short label the asker gave the question'),
  "question": zod.string().describe('What the asker needs to know'),
  "resolution": zod.union([zod.string(),zod.null()]).describe('Null while the request is open'),
  "resolved_by": zod.union([zod.string().describe('Actor string, e.g. "worker:<workerId>" or "user:<profileId>".'),zod.null()]),
  "resolved_at": zod.union([zod.string().datetime({"offset":true}),zod.null()]),
  "metadata": zod.record(zod.string(), zod.unknown()),
  "environment": zod.enum(['live', 'test']),
  "created_by": zod.string().describe('Actor that raised the request'),
  "created_at": zod.string().datetime({"offset":true})
})),
  "message": zod.string(),
  "meta": zod.object({
  "total": zod.number()
})
})


export const GetInformationRequestParams = zod.object({
  "informationRequestId": zod.string().uuid()
})

export const GetInformationRequestResponse = zod.object({
  "data": zod.object({
  "id": zod.string(),
  "title": zod.string().describe('Short label the asker gave the question'),
  "question": zod.string().describe('What the asker needs to know'),
  "resolution": zod.union([zod.string(),zod.null()]).describe('Null while the request is open'),
  "resolved_by": zod.union([zod.string().describe('Actor string, e.g. "worker:<workerId>" or "user:<profileId>".'),zod.null()]),
  "resolved_at": zod.union([zod.string().datetime({"offset":true}),zod.null()]),
  "metadata": zod.record(zod.string(), zod.unknown()),
  "environment": zod.enum(['live', 'test']),
  "created_by": zod.string().describe('Actor that raised the request'),
  "created_at": zod.string().datetime({"offset":true})
}),
  "message": zod.string()
})


export const ResolveInformationRequestParams = zod.object({
  "informationRequestId": zod.string().uuid()
})

export const resolveInformationRequestBodyResolutionMax = 10000;



export const ResolveInformationRequestBody = zod.object({
  "resolution": zod.string().min(1).max(resolveInformationRequestBodyResolutionMax).describe('The information the asker was missing, in plain language')
})

export const ResolveInformationRequestResponse = zod.object({
  "data": zod.object({
  "id": zod.string(),
  "title": zod.string().describe('Short label the asker gave the question'),
  "question": zod.string().describe('What the asker needs to know'),
  "resolution": zod.union([zod.string(),zod.null()]).describe('Null while the request is open'),
  "resolved_by": zod.union([zod.string().describe('Actor string, e.g. "worker:<workerId>" or "user:<profileId>".'),zod.null()]),
  "resolved_at": zod.union([zod.string().datetime({"offset":true}),zod.null()]),
  "metadata": zod.record(zod.string(), zod.unknown()),
  "environment": zod.enum(['live', 'test']),
  "created_by": zod.string().describe('Actor that raised the request'),
  "created_at": zod.string().datetime({"offset":true})
}),
  "message": zod.string()
})







export const CreateToolBody = zod.object({
  "name": zod.string().min(1),
  "code": zod.string().min(1),
  "description": zod.string().min(1)
})

export const createToolResponseDataToolVersionsLatestMin = -9007199254740991;
export const createToolResponseDataToolVersionsLatestMax = 9007199254740991;

export const createToolResponseDataToolVersionsLiveMin = -9007199254740991;
export const createToolResponseDataToolVersionsLiveMax = 9007199254740991;

export const createToolResponseDataToolVersionsTestMin = -9007199254740991;
export const createToolResponseDataToolVersionsTestMax = 9007199254740991;



export const CreateToolResponse = zod.object({
  "data": zod.object({
  "tool": zod.object({
  "id": zod.string(),
  "name": zod.string(),
  "schema": zod.record(zod.string(), zod.unknown()).optional(),
  "description": zod.string().optional(),
  "code": zod.string().optional(),
  "versions": zod.object({
  "latest": zod.number().int().min(createToolResponseDataToolVersionsLatestMin).max(createToolResponseDataToolVersionsLatestMax).describe('Newest config version. The code, schema and secrets in this response are its snapshot.'),
  "live": zod.number().int().min(createToolResponseDataToolVersionsLiveMin).max(createToolResponseDataToolVersionsLiveMax).describe('Config version runs in the `live` environment execute.'),
  "test": zod.number().int().min(createToolResponseDataToolVersionsTestMin).max(createToolResponseDataToolVersionsTestMax).describe('Config version runs in the `test` environment execute.')
})
})
}),
  "message": zod.string()
})


export const listToolsQuerySortByDefault = `created_at`;
export const listToolsQuerySortOrderDefault = `desc`;

export const ListToolsQueryParams = zod.object({
  "sort_by": zod.enum(['created_at', 'updated_at', 'name']).default(listToolsQuerySortByDefault),
  "sort_order": zod.enum(['asc', 'desc']).default(listToolsQuerySortOrderDefault)
})

export const listToolsResponseDataToolsItemVersionsLatestMin = -9007199254740991;
export const listToolsResponseDataToolsItemVersionsLatestMax = 9007199254740991;

export const listToolsResponseDataToolsItemVersionsLiveMin = -9007199254740991;
export const listToolsResponseDataToolsItemVersionsLiveMax = 9007199254740991;

export const listToolsResponseDataToolsItemVersionsTestMin = -9007199254740991;
export const listToolsResponseDataToolsItemVersionsTestMax = 9007199254740991;



export const ListToolsResponse = zod.object({
  "data": zod.object({
  "tools": zod.array(zod.object({
  "id": zod.string(),
  "name": zod.string(),
  "description": zod.string().optional(),
  "versions": zod.object({
  "latest": zod.number().int().min(listToolsResponseDataToolsItemVersionsLatestMin).max(listToolsResponseDataToolsItemVersionsLatestMax).describe('Newest config version. The code, schema and secrets in this response are its snapshot.'),
  "live": zod.number().int().min(listToolsResponseDataToolsItemVersionsLiveMin).max(listToolsResponseDataToolsItemVersionsLiveMax).describe('Config version runs in the `live` environment execute.'),
  "test": zod.number().int().min(listToolsResponseDataToolsItemVersionsTestMin).max(listToolsResponseDataToolsItemVersionsTestMax).describe('Config version runs in the `test` environment execute.')
})
}))
}),
  "message": zod.string()
})


export const DeleteToolParams = zod.object({
  "id": zod.string().uuid()
})

export const DeleteToolResponse = zod.object({
  "data": zod.object({

}),
  "message": zod.string()
})


export const GetToolParams = zod.object({
  "id": zod.string().uuid()
})

export const getToolResponseDataToolVersionsLatestMin = -9007199254740991;
export const getToolResponseDataToolVersionsLatestMax = 9007199254740991;

export const getToolResponseDataToolVersionsLiveMin = -9007199254740991;
export const getToolResponseDataToolVersionsLiveMax = 9007199254740991;

export const getToolResponseDataToolVersionsTestMin = -9007199254740991;
export const getToolResponseDataToolVersionsTestMax = 9007199254740991;



export const GetToolResponse = zod.object({
  "data": zod.object({
  "tool": zod.object({
  "id": zod.string(),
  "name": zod.string(),
  "description": zod.string().optional(),
  "code": zod.string(),
  "schema": zod.record(zod.string(), zod.unknown()),
  "secret_ids": zod.array(zod.string()).describe('Secrets attached to the tool. A tool with attached secrets takes its execution environment exclusively from the secret store, each secret arriving under its own env key.'),
  "versions": zod.object({
  "latest": zod.number().int().min(getToolResponseDataToolVersionsLatestMin).max(getToolResponseDataToolVersionsLatestMax).describe('Newest config version. The code, schema and secrets in this response are its snapshot.'),
  "live": zod.number().int().min(getToolResponseDataToolVersionsLiveMin).max(getToolResponseDataToolVersionsLiveMax).describe('Config version runs in the `live` environment execute.'),
  "test": zod.number().int().min(getToolResponseDataToolVersionsTestMin).max(getToolResponseDataToolVersionsTestMax).describe('Config version runs in the `test` environment execute.')
})
})
}),
  "message": zod.string()
})


export const UpdateToolParams = zod.object({
  "id": zod.string().uuid()
})






export const UpdateToolBody = zod.object({
  "name": zod.string().min(1).optional(),
  "code": zod.string().min(1).optional(),
  "description": zod.string().min(1).optional(),
  "secret_ids": zod.array(zod.string().uuid()).optional().describe('Replace the tool\'s attached secret set. Omit to leave unchanged; pass [] to detach all.')
})

export const updateToolResponseDataToolVersionsLatestMin = -9007199254740991;
export const updateToolResponseDataToolVersionsLatestMax = 9007199254740991;

export const updateToolResponseDataToolVersionsLiveMin = -9007199254740991;
export const updateToolResponseDataToolVersionsLiveMax = 9007199254740991;

export const updateToolResponseDataToolVersionsTestMin = -9007199254740991;
export const updateToolResponseDataToolVersionsTestMax = 9007199254740991;



export const UpdateToolResponse = zod.object({
  "data": zod.object({
  "tool": zod.object({
  "id": zod.string(),
  "name": zod.string(),
  "description": zod.string().optional(),
  "code": zod.string(),
  "schema": zod.record(zod.string(), zod.unknown()),
  "secret_ids": zod.array(zod.string()).describe('Secrets attached to the tool. A tool with attached secrets takes its execution environment exclusively from the secret store, each secret arriving under its own env key.'),
  "versions": zod.object({
  "latest": zod.number().int().min(updateToolResponseDataToolVersionsLatestMin).max(updateToolResponseDataToolVersionsLatestMax).describe('Newest config version. The code, schema and secrets in this response are its snapshot.'),
  "live": zod.number().int().min(updateToolResponseDataToolVersionsLiveMin).max(updateToolResponseDataToolVersionsLiveMax).describe('Config version runs in the `live` environment execute.'),
  "test": zod.number().int().min(updateToolResponseDataToolVersionsTestMin).max(updateToolResponseDataToolVersionsTestMax).describe('Config version runs in the `test` environment execute.')
})
})
}),
  "message": zod.string()
})


export const ExecuteCodeParams = zod.object({
  "id": zod.string().uuid()
})

export const executeCodeBodyParamsDefault = {};

export const ExecuteCodeBody = zod.object({
  "params": zod.record(zod.string(), zod.unknown()).default(executeCodeBodyParamsDefault),
  "environment": zod.enum(['live', 'test']).optional().describe('Environment to run the tool in, which selects the secret values it receives. A worker run is pinned to its own environment; other callers default to live.')
})

export const ExecuteCodeResponse = zod.object({
  "data": zod.object({
  "result": zod.string().optional(),
  "error": zod.object({
  "name": zod.string(),
  "message": zod.string()
}).optional(),
  "traces": zod.array(zod.object({
  "text": zod.string(),
  "timestamp": zod.string()
}))
}),
  "message": zod.string()
})


export const ListToolVersionsParams = zod.object({
  "id": zod.string().uuid()
})

export const listToolVersionsQueryCountDefault = 50;
export const listToolVersionsQueryCountMax = 100;

export const listToolVersionsQueryOffsetDefault = 0;
export const listToolVersionsQueryOffsetMin = 0;

export const listToolVersionsQuerySortByDefault = `version`;
export const listToolVersionsQuerySortOrderDefault = `desc`;

export const ListToolVersionsQueryParams = zod.object({
  "count": zod.number().min(1).max(listToolVersionsQueryCountMax).default(listToolVersionsQueryCountDefault),
  "offset": zod.number().min(listToolVersionsQueryOffsetMin).default(listToolVersionsQueryOffsetDefault),
  "sort_by": zod.enum(['version', 'created_at']).default(listToolVersionsQuerySortByDefault),
  "sort_order": zod.enum(['asc', 'desc']).default(listToolVersionsQuerySortOrderDefault)
})

export const listToolVersionsResponseDataItemVersionMin = -9007199254740991;
export const listToolVersionsResponseDataItemVersionMax = 9007199254740991;

export const listToolVersionsResponseMetaTotalMin = -9007199254740991;
export const listToolVersionsResponseMetaTotalMax = 9007199254740991;



export const ListToolVersionsResponse = zod.object({
  "data": zod.array(zod.object({
  "tool_id": zod.string(),
  "version": zod.number().int().min(listToolVersionsResponseDataItemVersionMin).max(listToolVersionsResponseDataItemVersionMax),
  "actor": zod.string(),
  "created_at": zod.string().datetime({"offset":true}),
  "changed_fields": zod.array(zod.string())
})),
  "message": zod.string(),
  "meta": zod.object({
  "total": zod.number().int().min(listToolVersionsResponseMetaTotalMin).max(listToolVersionsResponseMetaTotalMax)
})
})


export const getToolVersionPathVersionMax = 9007199254740991;



export const GetToolVersionParams = zod.object({
  "id": zod.string().uuid(),
  "version": zod.number().int().min(1).max(getToolVersionPathVersionMax)
})

export const getToolVersionResponseDataVersionMin = -9007199254740991;
export const getToolVersionResponseDataVersionMax = 9007199254740991;



export const GetToolVersionResponse = zod.object({
  "data": zod.object({
  "id": zod.string(),
  "name": zod.string(),
  "created_at": zod.string().datetime({"offset":true}),
  "updated_at": zod.string().datetime({"offset":true}),
  "code": zod.string(),
  "schema": zod.record(zod.string(), zod.unknown()),
  "description": zod.string().optional(),
  "secret_ids": zod.array(zod.string()),
  "version": zod.number().int().min(getToolVersionResponseDataVersionMin).max(getToolVersionResponseDataVersionMax),
  "version_created_at": zod.string().datetime({"offset":true}),
  "actor": zod.string(),
  "changed_fields": zod.array(zod.string())
}),
  "message": zod.string()
})


export const promoteToolVersionPathVersionMax = 9007199254740991;



export const PromoteToolVersionParams = zod.object({
  "id": zod.string().uuid(),
  "version": zod.number().int().min(1).max(promoteToolVersionPathVersionMax)
})

export const PromoteToolVersionBody = zod.object({
  "environment": zod.enum(['live', 'test'])
})

export const promoteToolVersionResponseDataVersionMin = -9007199254740991;
export const promoteToolVersionResponseDataVersionMax = 9007199254740991;



export const PromoteToolVersionResponse = zod.object({
  "data": zod.object({
  "version": zod.number().int().min(promoteToolVersionResponseDataVersionMin).max(promoteToolVersionResponseDataVersionMax),
  "environment": zod.enum(['live', 'test'])
}),
  "message": zod.string()
})


export const getToolVersionChangeSummaryPathVersionMax = 9007199254740991;



export const GetToolVersionChangeSummaryParams = zod.object({
  "id": zod.string().uuid(),
  "version": zod.number().int().min(1).max(getToolVersionChangeSummaryPathVersionMax)
})

export const GetToolVersionChangeSummaryResponse = zod.object({
  "data": zod.object({
  "summary": zod.string()
}),
  "message": zod.string()
})


export const workerListToolsQuerySortByDefault = `created_at`;
export const workerListToolsQuerySortOrderDefault = `desc`;

export const WorkerListToolsQueryParams = zod.object({
  "sort_by": zod.enum(['created_at', 'updated_at', 'name']).default(workerListToolsQuerySortByDefault),
  "sort_order": zod.enum(['asc', 'desc']).default(workerListToolsQuerySortOrderDefault)
})

export const workerListToolsResponseDataToolsItemVersionsLatestMin = -9007199254740991;
export const workerListToolsResponseDataToolsItemVersionsLatestMax = 9007199254740991;

export const workerListToolsResponseDataToolsItemVersionsLiveMin = -9007199254740991;
export const workerListToolsResponseDataToolsItemVersionsLiveMax = 9007199254740991;

export const workerListToolsResponseDataToolsItemVersionsTestMin = -9007199254740991;
export const workerListToolsResponseDataToolsItemVersionsTestMax = 9007199254740991;



export const WorkerListToolsResponse = zod.object({
  "data": zod.object({
  "tools": zod.array(zod.object({
  "id": zod.string(),
  "name": zod.string(),
  "description": zod.string().optional(),
  "versions": zod.object({
  "latest": zod.number().int().min(workerListToolsResponseDataToolsItemVersionsLatestMin).max(workerListToolsResponseDataToolsItemVersionsLatestMax).describe('Newest config version. The code, schema and secrets in this response are its snapshot.'),
  "live": zod.number().int().min(workerListToolsResponseDataToolsItemVersionsLiveMin).max(workerListToolsResponseDataToolsItemVersionsLiveMax).describe('Config version runs in the `live` environment execute.'),
  "test": zod.number().int().min(workerListToolsResponseDataToolsItemVersionsTestMin).max(workerListToolsResponseDataToolsItemVersionsTestMax).describe('Config version runs in the `test` environment execute.')
})
}))
}),
  "message": zod.string()
})


export const WorkerGetToolParams = zod.object({
  "id": zod.string().uuid()
})

export const workerGetToolResponseDataToolVersionsLatestMin = -9007199254740991;
export const workerGetToolResponseDataToolVersionsLatestMax = 9007199254740991;

export const workerGetToolResponseDataToolVersionsLiveMin = -9007199254740991;
export const workerGetToolResponseDataToolVersionsLiveMax = 9007199254740991;

export const workerGetToolResponseDataToolVersionsTestMin = -9007199254740991;
export const workerGetToolResponseDataToolVersionsTestMax = 9007199254740991;



export const WorkerGetToolResponse = zod.object({
  "data": zod.object({
  "tool": zod.object({
  "id": zod.string(),
  "name": zod.string(),
  "description": zod.string().optional(),
  "code": zod.string(),
  "schema": zod.record(zod.string(), zod.unknown()),
  "secret_ids": zod.array(zod.string()).describe('Secrets attached to the tool. A tool with attached secrets takes its execution environment exclusively from the secret store, each secret arriving under its own env key.'),
  "versions": zod.object({
  "latest": zod.number().int().min(workerGetToolResponseDataToolVersionsLatestMin).max(workerGetToolResponseDataToolVersionsLatestMax).describe('Newest config version. The code, schema and secrets in this response are its snapshot.'),
  "live": zod.number().int().min(workerGetToolResponseDataToolVersionsLiveMin).max(workerGetToolResponseDataToolVersionsLiveMax).describe('Config version runs in the `live` environment execute.'),
  "test": zod.number().int().min(workerGetToolResponseDataToolVersionsTestMin).max(workerGetToolResponseDataToolVersionsTestMax).describe('Config version runs in the `test` environment execute.')
})
})
}),
  "message": zod.string()
})


export const WorkerExecuteToolParams = zod.object({
  "id": zod.string().uuid()
})

export const workerExecuteToolBodyParamsDefault = {};

export const WorkerExecuteToolBody = zod.object({
  "params": zod.record(zod.string(), zod.unknown()).default(workerExecuteToolBodyParamsDefault),
  "environment": zod.enum(['live', 'test']).optional().describe('Environment to run the tool in, which selects the secret values it receives. A worker run is pinned to its own environment; other callers default to live.')
})

export const WorkerExecuteToolResponse = zod.object({
  "data": zod.object({
  "result": zod.string().optional(),
  "error": zod.object({
  "name": zod.string(),
  "message": zod.string()
}).optional(),
  "traces": zod.array(zod.object({
  "text": zod.string(),
  "timestamp": zod.string()
}))
}),
  "message": zod.string()
})


export const notifyAdminBodyMessageMax = 2000;



export const NotifyAdminBody = zod.object({
  "message": zod.string().min(1).max(notifyAdminBodyMessageMax).describe('What went wrong and what you need, in plain language. Write it for a person who is not watching this run: say what you were trying to do, what blocked you, and what you would need to continue.')
})

export const NotifyAdminResponse = zod.object({
  "data": zod.object({
  "id": zod.string().describe('Identifier of the report that was recorded')
}),
  "message": zod.string()
})





export const UploadFileBody = zod.object({
  "source_url": zod.string().describe('URL of the file to upload. Accepts either a public HTTPS URL or an `avallon://artifact-upload/` URL returned by the Request a pre-signed URL for direct large file upload (POST /v1/artifacts/get-upload-url) endpoint.'),
  "document_name": zod.string().min(1),
  "processing_options": zod.object({
  "file_password": zod.string().optional(),
  "file_splitting_enabled": zod.boolean().optional()
}).optional(),
  "created_at_document": zod.string().datetime({"offset":true}).optional(),
  "metadata": zod.record(zod.string(), zod.unknown()).optional()
})

export const UploadFileResponse = zod.object({
  "data": zod.object({
  "upload_id": zod.string()
}),
  "message": zod.string()
})





export const CreateAgentWebhookParams = zod.object({
  "voiceAgentId": zod.string().min(1)
})

export const createAgentWebhookBodyNameMax = 256;

export const createAgentWebhookBodyUrlMax = 2048;


export const createAgentWebhookBodyAuthHeaderNameOneMax = 256;

export const createAgentWebhookBodyAuthHeaderValueOneMax = 2048;



export const CreateAgentWebhookBody = zod.object({
  "name": zod.string().min(1).max(createAgentWebhookBodyNameMax),
  "url": zod.string().url().max(createAgentWebhookBodyUrlMax),
  "environments": zod.array(zod.enum(['live', 'test'])).min(1).default([`live`]),
  "auth_header_name": zod.union([zod.string().max(createAgentWebhookBodyAuthHeaderNameOneMax),zod.null()]).optional(),
  "auth_header_value": zod.union([zod.string().max(createAgentWebhookBodyAuthHeaderValueOneMax),zod.null()]).optional(),
  "enabled": zod.boolean().optional()
})

export const CreateAgentWebhookResponse = zod.object({
  "data": zod.object({
  "id": zod.string(),
  "scope": zod.union([zod.object({
  "extractor_id": zod.string()
}),zod.object({
  "call_agent_id": zod.string()
}),zod.object({
  "inbox_id": zod.string()
}),zod.object({
  "worker_id": zod.string()
}),zod.object({
  "notifications": zod.literal(true)
}).describe('The organization\'s notification feed, not a resource')]),
  "name": zod.string(),
  "url": zod.string(),
  "auth_header_name": zod.union([zod.string(),zod.null()]),
  "has_auth": zod.boolean(),
  "enabled": zod.boolean(),
  "environments": zod.array(zod.enum(['live', 'test'])),
  "created_at": zod.string().datetime({"offset":true}),
  "updated_at": zod.string().datetime({"offset":true})
}),
  "message": zod.string()
})





export const ListAgentWebhooksParams = zod.object({
  "voiceAgentId": zod.string().min(1)
})

export const ListAgentWebhooksQueryParams = zod.object({
  "environment": zod.enum(['live', 'test']).optional().describe('Only return webhooks that receive events from this environment. Webhooks configured for both environments match either value.')
})

export const ListAgentWebhooksResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.string(),
  "scope": zod.union([zod.object({
  "extractor_id": zod.string()
}),zod.object({
  "call_agent_id": zod.string()
}),zod.object({
  "inbox_id": zod.string()
}),zod.object({
  "worker_id": zod.string()
}),zod.object({
  "notifications": zod.literal(true)
}).describe('The organization\'s notification feed, not a resource')]),
  "name": zod.string(),
  "url": zod.string(),
  "auth_header_name": zod.union([zod.string(),zod.null()]),
  "has_auth": zod.boolean(),
  "enabled": zod.boolean(),
  "environments": zod.array(zod.enum(['live', 'test'])),
  "created_at": zod.string().datetime({"offset":true}),
  "updated_at": zod.string().datetime({"offset":true})
})),
  "message": zod.string()
})





export const CreateInboxWebhookParams = zod.object({
  "inboxId": zod.string().min(1)
})

export const createInboxWebhookBodyNameMax = 256;

export const createInboxWebhookBodyUrlMax = 2048;


export const createInboxWebhookBodyAuthHeaderNameOneMax = 256;

export const createInboxWebhookBodyAuthHeaderValueOneMax = 2048;



export const CreateInboxWebhookBody = zod.object({
  "name": zod.string().min(1).max(createInboxWebhookBodyNameMax),
  "url": zod.string().url().max(createInboxWebhookBodyUrlMax),
  "environments": zod.array(zod.enum(['live', 'test'])).min(1).default([`live`]),
  "auth_header_name": zod.union([zod.string().max(createInboxWebhookBodyAuthHeaderNameOneMax),zod.null()]).optional(),
  "auth_header_value": zod.union([zod.string().max(createInboxWebhookBodyAuthHeaderValueOneMax),zod.null()]).optional(),
  "enabled": zod.boolean().optional()
})

export const CreateInboxWebhookResponse = zod.object({
  "data": zod.object({
  "id": zod.string(),
  "scope": zod.union([zod.object({
  "extractor_id": zod.string()
}),zod.object({
  "call_agent_id": zod.string()
}),zod.object({
  "inbox_id": zod.string()
}),zod.object({
  "worker_id": zod.string()
}),zod.object({
  "notifications": zod.literal(true)
}).describe('The organization\'s notification feed, not a resource')]),
  "name": zod.string(),
  "url": zod.string(),
  "auth_header_name": zod.union([zod.string(),zod.null()]),
  "has_auth": zod.boolean(),
  "enabled": zod.boolean(),
  "environments": zod.array(zod.enum(['live', 'test'])),
  "created_at": zod.string().datetime({"offset":true}),
  "updated_at": zod.string().datetime({"offset":true})
}),
  "message": zod.string()
})





export const ListInboxWebhooksParams = zod.object({
  "inboxId": zod.string().min(1)
})

export const ListInboxWebhooksQueryParams = zod.object({
  "environment": zod.enum(['live', 'test']).optional().describe('Only return webhooks that receive events from this environment. Webhooks configured for both environments match either value.')
})

export const ListInboxWebhooksResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.string(),
  "scope": zod.union([zod.object({
  "extractor_id": zod.string()
}),zod.object({
  "call_agent_id": zod.string()
}),zod.object({
  "inbox_id": zod.string()
}),zod.object({
  "worker_id": zod.string()
}),zod.object({
  "notifications": zod.literal(true)
}).describe('The organization\'s notification feed, not a resource')]),
  "name": zod.string(),
  "url": zod.string(),
  "auth_header_name": zod.union([zod.string(),zod.null()]),
  "has_auth": zod.boolean(),
  "enabled": zod.boolean(),
  "environments": zod.array(zod.enum(['live', 'test'])),
  "created_at": zod.string().datetime({"offset":true}),
  "updated_at": zod.string().datetime({"offset":true})
})),
  "message": zod.string()
})





export const CreateExtractorWebhookParams = zod.object({
  "id": zod.string().min(1)
})

export const createExtractorWebhookBodyNameMax = 256;

export const createExtractorWebhookBodyUrlMax = 2048;


export const createExtractorWebhookBodyAuthHeaderNameOneMax = 256;

export const createExtractorWebhookBodyAuthHeaderValueOneMax = 2048;



export const CreateExtractorWebhookBody = zod.object({
  "name": zod.string().min(1).max(createExtractorWebhookBodyNameMax),
  "url": zod.string().url().max(createExtractorWebhookBodyUrlMax),
  "environments": zod.array(zod.enum(['live', 'test'])).min(1).default([`live`]),
  "auth_header_name": zod.union([zod.string().max(createExtractorWebhookBodyAuthHeaderNameOneMax),zod.null()]).optional(),
  "auth_header_value": zod.union([zod.string().max(createExtractorWebhookBodyAuthHeaderValueOneMax),zod.null()]).optional(),
  "enabled": zod.boolean().optional()
})

export const CreateExtractorWebhookResponse = zod.object({
  "data": zod.object({
  "id": zod.string(),
  "scope": zod.union([zod.object({
  "extractor_id": zod.string()
}),zod.object({
  "call_agent_id": zod.string()
}),zod.object({
  "inbox_id": zod.string()
}),zod.object({
  "worker_id": zod.string()
}),zod.object({
  "notifications": zod.literal(true)
}).describe('The organization\'s notification feed, not a resource')]),
  "name": zod.string(),
  "url": zod.string(),
  "auth_header_name": zod.union([zod.string(),zod.null()]),
  "has_auth": zod.boolean(),
  "enabled": zod.boolean(),
  "environments": zod.array(zod.enum(['live', 'test'])),
  "created_at": zod.string().datetime({"offset":true}),
  "updated_at": zod.string().datetime({"offset":true})
}),
  "message": zod.string()
})





export const ListWebhooksParams = zod.object({
  "id": zod.string().min(1)
})

export const ListWebhooksQueryParams = zod.object({
  "environment": zod.enum(['live', 'test']).optional().describe('Only return webhooks that receive events from this environment. Webhooks configured for both environments match either value.')
})

export const ListWebhooksResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.string(),
  "scope": zod.union([zod.object({
  "extractor_id": zod.string()
}),zod.object({
  "call_agent_id": zod.string()
}),zod.object({
  "inbox_id": zod.string()
}),zod.object({
  "worker_id": zod.string()
}),zod.object({
  "notifications": zod.literal(true)
}).describe('The organization\'s notification feed, not a resource')]),
  "name": zod.string(),
  "url": zod.string(),
  "auth_header_name": zod.union([zod.string(),zod.null()]),
  "has_auth": zod.boolean(),
  "enabled": zod.boolean(),
  "environments": zod.array(zod.enum(['live', 'test'])),
  "created_at": zod.string().datetime({"offset":true}),
  "updated_at": zod.string().datetime({"offset":true})
})),
  "message": zod.string()
})


export const createNotificationWebhookBodyNameMax = 256;

export const createNotificationWebhookBodyUrlMax = 2048;


export const createNotificationWebhookBodyAuthHeaderNameOneMax = 256;

export const createNotificationWebhookBodyAuthHeaderValueOneMax = 2048;



export const CreateNotificationWebhookBody = zod.object({
  "name": zod.string().min(1).max(createNotificationWebhookBodyNameMax),
  "url": zod.string().url().max(createNotificationWebhookBodyUrlMax),
  "environments": zod.array(zod.enum(['live', 'test'])).min(1).default([`live`]),
  "auth_header_name": zod.union([zod.string().max(createNotificationWebhookBodyAuthHeaderNameOneMax),zod.null()]).optional(),
  "auth_header_value": zod.union([zod.string().max(createNotificationWebhookBodyAuthHeaderValueOneMax),zod.null()]).optional(),
  "enabled": zod.boolean().optional()
})

export const CreateNotificationWebhookResponse = zod.object({
  "data": zod.object({
  "id": zod.string(),
  "scope": zod.union([zod.object({
  "extractor_id": zod.string()
}),zod.object({
  "call_agent_id": zod.string()
}),zod.object({
  "inbox_id": zod.string()
}),zod.object({
  "worker_id": zod.string()
}),zod.object({
  "notifications": zod.literal(true)
}).describe('The organization\'s notification feed, not a resource')]),
  "name": zod.string(),
  "url": zod.string(),
  "auth_header_name": zod.union([zod.string(),zod.null()]),
  "has_auth": zod.boolean(),
  "enabled": zod.boolean(),
  "environments": zod.array(zod.enum(['live', 'test'])),
  "created_at": zod.string().datetime({"offset":true}),
  "updated_at": zod.string().datetime({"offset":true})
}),
  "message": zod.string()
})


export const ListNotificationWebhooksQueryParams = zod.object({
  "environment": zod.enum(['live', 'test']).optional().describe('Only return webhooks that receive events from this environment. Webhooks configured for both environments match either value.')
})

export const ListNotificationWebhooksResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.string(),
  "scope": zod.union([zod.object({
  "extractor_id": zod.string()
}),zod.object({
  "call_agent_id": zod.string()
}),zod.object({
  "inbox_id": zod.string()
}),zod.object({
  "worker_id": zod.string()
}),zod.object({
  "notifications": zod.literal(true)
}).describe('The organization\'s notification feed, not a resource')]),
  "name": zod.string(),
  "url": zod.string(),
  "auth_header_name": zod.union([zod.string(),zod.null()]),
  "has_auth": zod.boolean(),
  "enabled": zod.boolean(),
  "environments": zod.array(zod.enum(['live', 'test'])),
  "created_at": zod.string().datetime({"offset":true}),
  "updated_at": zod.string().datetime({"offset":true})
})),
  "message": zod.string()
})





export const DeleteWebhookParams = zod.object({
  "id": zod.string().min(1)
})

export const DeleteWebhookResponse = zod.object({
  "data": zod.object({

}),
  "message": zod.string()
})





export const GetWebhookParams = zod.object({
  "id": zod.string().min(1)
})

export const GetWebhookResponse = zod.object({
  "data": zod.object({
  "id": zod.string(),
  "scope": zod.union([zod.object({
  "extractor_id": zod.string()
}),zod.object({
  "call_agent_id": zod.string()
}),zod.object({
  "inbox_id": zod.string()
}),zod.object({
  "worker_id": zod.string()
}),zod.object({
  "notifications": zod.literal(true)
}).describe('The organization\'s notification feed, not a resource')]),
  "name": zod.string(),
  "url": zod.string(),
  "auth_header_name": zod.union([zod.string(),zod.null()]),
  "has_auth": zod.boolean(),
  "enabled": zod.boolean(),
  "environments": zod.array(zod.enum(['live', 'test'])),
  "created_at": zod.string().datetime({"offset":true}),
  "updated_at": zod.string().datetime({"offset":true})
}),
  "message": zod.string()
})





export const UpdateWebhookParams = zod.object({
  "id": zod.string().min(1)
})

export const updateWebhookBodyNameMax = 256;

export const updateWebhookBodyUrlMax = 2048;


export const updateWebhookBodyAuthOneHeaderNameMax = 256;

export const updateWebhookBodyAuthOneHeaderValueMax = 2048;



export const UpdateWebhookBody = zod.object({
  "name": zod.string().min(1).max(updateWebhookBodyNameMax).optional(),
  "url": zod.string().url().max(updateWebhookBodyUrlMax).optional(),
  "environments": zod.array(zod.enum(['live', 'test'])).min(1).optional(),
  "enabled": zod.boolean().optional(),
  "auth": zod.union([zod.object({
  "header_name": zod.string().min(1).max(updateWebhookBodyAuthOneHeaderNameMax),
  "header_value": zod.string().min(1).max(updateWebhookBodyAuthOneHeaderValueMax)
}),zod.null()]).optional()
})

export const UpdateWebhookResponse = zod.object({
  "data": zod.object({
  "id": zod.string(),
  "scope": zod.union([zod.object({
  "extractor_id": zod.string()
}),zod.object({
  "call_agent_id": zod.string()
}),zod.object({
  "inbox_id": zod.string()
}),zod.object({
  "worker_id": zod.string()
}),zod.object({
  "notifications": zod.literal(true)
}).describe('The organization\'s notification feed, not a resource')]),
  "name": zod.string(),
  "url": zod.string(),
  "auth_header_name": zod.union([zod.string(),zod.null()]),
  "has_auth": zod.boolean(),
  "enabled": zod.boolean(),
  "environments": zod.array(zod.enum(['live', 'test'])),
  "created_at": zod.string().datetime({"offset":true}),
  "updated_at": zod.string().datetime({"offset":true})
}),
  "message": zod.string()
})





export const ListWebhookDeliveriesParams = zod.object({
  "id": zod.string().min(1)
})

export const listWebhookDeliveriesQueryCountDefault = 50;
export const listWebhookDeliveriesQueryCountMax = 100;

export const listWebhookDeliveriesQueryOffsetDefault = 0;
export const listWebhookDeliveriesQueryOffsetMin = 0;

export const listWebhookDeliveriesQuerySortOrderDefault = `desc`;

export const ListWebhookDeliveriesQueryParams = zod.object({
  "count": zod.number().min(1).max(listWebhookDeliveriesQueryCountMax).default(listWebhookDeliveriesQueryCountDefault),
  "offset": zod.number().min(listWebhookDeliveriesQueryOffsetMin).default(listWebhookDeliveriesQueryOffsetDefault),
  "sort_order": zod.enum(['asc', 'desc']).default(listWebhookDeliveriesQuerySortOrderDefault)
})

export const ListWebhookDeliveriesResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.string(),
  "webhook_id": zod.string(),
  "event_type": zod.string(),
  "event_id": zod.union([zod.string(),zod.null()]),
  "status_code": zod.union([zod.number(),zod.null()]),
  "duration_ms": zod.union([zod.number(),zod.null()]),
  "error_message": zod.union([zod.string(),zod.null()]),
  "created_at": zod.string().datetime({"offset":true})
})),
  "message": zod.string(),
  "meta": zod.object({
  "total": zod.number()
})
})





export const TestWebhookParams = zod.object({
  "id": zod.string().min(1)
})

export const testWebhookBodyEnvironmentDefault = `live`;

export const TestWebhookBody = zod.object({
  "environment": zod.enum(['live', 'test']).default(testWebhookBodyEnvironmentDefault).describe('The environment to stamp on the test payload.')
})

export const TestWebhookResponse = zod.object({
  "data": zod.object({
  "success": zod.boolean(),
  "status_code": zod.union([zod.number(),zod.null()]),
  "duration_ms": zod.number(),
  "error": zod.union([zod.string(),zod.null()])
}),
  "message": zod.string()
})

